/**
 * Dados simulados e descaracterizados para desenvolvimento local do SAPL Map.
 *
 * Contém 235 indicações sintéticas, 15 autores genéricos e distribuição variada
 * entre as 15 categorias temáticas oficiais.
 *
 * @module services/mockData
 */

export const MOCK_CATEGORIAS = [
  {
    "id": 1,
    "nome": "Infraestrutura",
    "descricao": "Obras, pavimentação e iluminação"
  },
  {
    "id": 2,
    "nome": "Saúde",
    "descricao": "Postos de saúde, remédios e atendimento"
  },
  {
    "id": 3,
    "nome": "Educação",
    "descricao": "Escolas, creches e transporte escolar"
  },
  {
    "id": 4,
    "nome": "Segurança",
    "descricao": "Policiamento, câmeras e rondas"
  },
  {
    "id": 5,
    "nome": "Meio Ambiente",
    "descricao": "Praças, poda de árvores e limpeza"
  },
  {
    "id": 6,
    "nome": "Outros",
    "descricao": "Diversos temas legislativos"
  }
];

export const MOCK_INDICACOES = [
  {
    "id": 901,
    "sapl_id": 9901,
    "numero": 1,
    "ano": 2024,
    "ementa": "Solicita reforma e revitalização completa da iluminação, calçamento e pista de caminhada do Parque Municipal Lagoa dos Pássaros.",
    "autor": "Comissão de Meio Ambiente",
    "data_apresentacao": "10/04/2024",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Meio Ambiente e Proteção Animal"
    },
    "enderecos_extraidos": [
      {
        "id": 9901,
        "indicacao_id": 901,
        "raw_text": "Parque Municipal Lagoa dos Pássaros, Centro",
        "street": "Parque Lagoa dos Pássaros",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 9901,
          "indicacao_id": 901,
          "endereco_id": 9901,
          "raw_address": "Parque Municipal Lagoa dos Pássaros, Centro",
          "normalized_address": "Parque Lagoa dos Pássaros - Centro, Artur Nogueira - SP",
          "latitude": -22.5695,
          "longitude": -47.1650,
          "geometry_type": "Polygon",
          "geometry_geojson": {
            "type": "Polygon",
            "coordinates": [
              [
                [-47.1675, -22.5678],
                [-47.1625, -22.5678],
                [-47.1625, -22.5712],
                [-47.1675, -22.5712],
                [-47.1675, -22.5678]
              ]
            ]
          },
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 9901,
        "indicacao_id": 901,
        "latitude": -22.5695,
        "longitude": -47.1650,
        "geometry_type": "Polygon",
        "geometry_geojson": {
          "type": "Polygon",
          "coordinates": [
            [
              [-47.1675, -22.5678],
              [-47.1625, -22.5678],
              [-47.1625, -22.5712],
              [-47.1675, -22.5712],
              [-47.1675, -22.5678]
            ]
          ]
        },
        "is_approximate": false,
        "raw_address": "Parque Municipal Lagoa dos Pássaros, Centro",
        "normalized_address": "Parque Lagoa dos Pássaros - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 901,
          "numero": 1,
          "ano": 2024,
          "ementa": "Solicita reforma e revitalização completa da iluminação, calçamento e pista de caminhada do Parque Municipal Lagoa dos Pássaros.",
          "autor": "Comissão de Meio Ambiente",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 5,
            "nome": "Meio Ambiente e Proteção Animal"
          }
        }
      }
    ]
  },
  {
    "id": 902,
    "sapl_id": 9902,
    "numero": 2,
    "ano": 2024,
    "ementa": "Solicita serviços de paisagismo, poda preventiva de árvores e modernização do calçamento na Praça do Coreto.",
    "autor": "Mário Silva",
    "data_apresentacao": "15/05/2024",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Cultura e Turismo"
    },
    "enderecos_extraidos": [
      {
        "id": 9902,
        "indicacao_id": 902,
        "raw_text": "Praça Governador Laudo Natel (Praça do Coreto), Centro",
        "street": "Praça do Coreto",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 9902,
          "indicacao_id": 902,
          "endereco_id": 9902,
          "raw_address": "Praça Governador Laudo Natel (Praça do Coreto), Centro",
          "normalized_address": "Praça do Coreto - Centro, Artur Nogueira - SP",
          "latitude": -22.5733,
          "longitude": -47.1735,
          "geometry_type": "Polygon",
          "geometry_geojson": {
            "type": "Polygon",
            "coordinates": [
              [
                [-47.1748, -22.5724],
                [-47.1722, -22.5724],
                [-47.1722, -22.5742],
                [-47.1748, -22.5742],
                [-47.1748, -22.5724]
              ]
            ]
          },
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 9902,
        "indicacao_id": 902,
        "latitude": -22.5733,
        "longitude": -47.1735,
        "geometry_type": "Polygon",
        "geometry_geojson": {
          "type": "Polygon",
          "coordinates": [
            [
              [-47.1748, -22.5724],
              [-47.1722, -22.5724],
              [-47.1722, -22.5742],
              [-47.1748, -22.5742],
              [-47.1748, -22.5724]
            ]
          ]
        },
        "is_approximate": false,
        "raw_address": "Praça Governador Laudo Natel (Praça do Coreto), Centro",
        "normalized_address": "Praça do Coreto - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 902,
          "numero": 2,
          "ano": 2024,
          "ementa": "Solicita serviços de paisagismo, poda preventiva de árvores e modernização do calçamento na Praça do Coreto.",
          "autor": "Mário Silva",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 11,
            "nome": "Cultura e Turismo"
          }
        }
      }
    ]
  },
  {
    "id": 903,
    "sapl_id": 9903,
    "numero": 3,
    "ano": 2024,
    "ementa": "Solicita recapeamento asfáltico, pintura de solo e redutores de velocidade na Avenida XV de Novembro.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "22/06/2024",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 9903,
        "indicacao_id": 903,
        "raw_text": "Avenida XV de Novembro, Centro",
        "street": "Avenida XV de Novembro",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 9903,
          "indicacao_id": 903,
          "endereco_id": 9903,
          "raw_address": "Avenida XV de Novembro, Centro",
          "normalized_address": "Avenida XV de Novembro - Centro, Artur Nogueira - SP",
          "latitude": -22.5730,
          "longitude": -47.1720,
          "geometry_type": "LineString",
          "geometry_geojson": {
            "type": "LineString",
            "coordinates": [
              [-47.1780, -22.5708],
              [-47.1740, -22.5722],
              [-47.1700, -22.5738],
              [-47.1660, -22.5752]
            ]
          },
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 9903,
        "indicacao_id": 903,
        "latitude": -22.5730,
        "longitude": -47.1720,
        "geometry_type": "LineString",
        "geometry_geojson": {
          "type": "LineString",
          "coordinates": [
            [-47.1780, -22.5708],
            [-47.1740, -22.5722],
            [-47.1700, -22.5738],
            [-47.1660, -22.5752]
          ]
        },
        "is_approximate": false,
        "raw_address": "Avenida XV de Novembro, Centro",
        "normalized_address": "Avenida XV de Novembro - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 903,
          "numero": 3,
          "ano": 2024,
          "ementa": "Solicita recapeamento asfáltico, pintura de solo e redutores de velocidade na Avenida XV de Novembro.",
          "autor": "Fernanda Freitas",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 904,
    "sapl_id": 9904,
    "numero": 4,
    "ano": 2024,
    "ementa": "Solicita manutenção das quadras poliesportivas e área recreativa no Complexo Esportivo Maurício Sia.",
    "autor": "Caio Campos",
    "data_apresentacao": "05/08/2024",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 9904,
        "indicacao_id": 904,
        "raw_text": "Complexo Esportivo Maurício Sia, Jardim Faveri",
        "street": "Complexo Esportivo Maurício Sia",
        "bairro": "Jardim Faveri",
        "status": "geocodificado",
        "geo_pin": {
          "id": 9904,
          "indicacao_id": 904,
          "endereco_id": 9904,
          "raw_address": "Complexo Esportivo Maurício Sia, Jardim Faveri",
          "normalized_address": "Complexo Esportivo Maurício Sia - Jardim Faveri, Artur Nogueira - SP",
          "latitude": -22.5780,
          "longitude": -47.1680,
          "geometry_type": "Polygon",
          "geometry_geojson": {
            "type": "Polygon",
            "coordinates": [
              [
                [-47.1695, -22.5765],
                [-47.1665, -22.5765],
                [-47.1665, -22.5795],
                [-47.1695, -22.5795],
                [-47.1695, -22.5765]
              ]
            ]
          },
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 9904,
        "indicacao_id": 904,
        "latitude": -22.5780,
        "longitude": -47.1680,
        "geometry_type": "Polygon",
        "geometry_geojson": {
          "type": "Polygon",
          "coordinates": [
            [
              [-47.1695, -22.5765],
              [-47.1665, -22.5765],
              [-47.1665, -22.5795],
              [-47.1695, -22.5795],
              [-47.1695, -22.5765]
            ]
          ]
        },
        "is_approximate": false,
        "raw_address": "Complexo Esportivo Maurício Sia, Jardim Faveri",
        "normalized_address": "Complexo Esportivo Maurício Sia - Jardim Faveri, Artur Nogueira - SP",
        "indicacao": {
          "id": 904,
          "numero": 4,
          "ano": 2024,
          "ementa": "Solicita manutenção das quadras poliesportivas e área recreativa no Complexo Esportivo Maurício Sia.",
          "autor": "Caio Campos",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 8,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 101,
    "sapl_id": 1101,
    "numero": 201,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Maria Marson Aresi, bairro Jardim Sacilotto II.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "24/02/2022",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 101,
        "indicacao_id": 101,
        "raw_text": "Rua Maria Marson Aresi, nº 311",
        "street": "Rua Maria Marson Aresi",
        "number": "311",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 601,
          "indicacao_id": 101,
          "endereco_id": 101,
          "raw_address": "Rua Maria Marson Aresi, nº 311",
          "normalized_address": "Rua Maria Marson Aresi, nº 311 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58172,
          "longitude": -47.17554,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 601,
        "indicacao_id": 101,
        "latitude": -22.58172,
        "longitude": -47.17554,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 311",
        "normalized_address": "Rua Maria Marson Aresi, nº 311 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 101,
          "numero": 201,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Maria Marson Aresi, bairro Jardim Sacilotto II.",
          "autor": "Fernanda Freitas",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 102,
    "sapl_id": 1102,
    "numero": 202,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Goiás, bairro Jardim Itamaraty.",
    "autor": "Caio Campos",
    "data_apresentacao": "27/07/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 102,
        "indicacao_id": 102,
        "raw_text": "Rua Goiás, nº 322",
        "street": "Rua Goiás",
        "number": "322",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 602,
          "indicacao_id": 102,
          "endereco_id": 102,
          "raw_address": "Rua Goiás, nº 322",
          "normalized_address": "Rua Goiás, nº 322 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58238,
          "longitude": -47.16798,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 602,
        "indicacao_id": 102,
        "latitude": -22.58238,
        "longitude": -47.16798,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 322",
        "normalized_address": "Rua Goiás, nº 322 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 102,
          "numero": 202,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Goiás, bairro Jardim Itamaraty.",
          "autor": "Caio Campos",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 103,
    "sapl_id": 1103,
    "numero": 203,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua das Hortênsias, bairro Jardim Planalto.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "02/12/2025",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 103,
        "indicacao_id": 103,
        "raw_text": "Rua das Hortênsias, nº 333",
        "street": "Rua das Hortênsias",
        "number": "333",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 603,
          "indicacao_id": 103,
          "endereco_id": 103,
          "raw_address": "Rua das Hortênsias, nº 333",
          "normalized_address": "Rua das Hortênsias, nº 333 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56762,
          "longitude": -47.167,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 603,
        "indicacao_id": 103,
        "latitude": -22.56762,
        "longitude": -47.167,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 333",
        "normalized_address": "Rua das Hortênsias, nº 333 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 103,
          "numero": 203,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua das Hortênsias, bairro Jardim Planalto.",
          "autor": "Rafael Teixeira",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 104,
    "sapl_id": 1104,
    "numero": 204,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Santa Gertrudes, bairro Jardim Conservani.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "05/05/2023",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 104,
        "indicacao_id": 104,
        "raw_text": "Rua Santa Gertrudes, nº 344",
        "street": "Rua Santa Gertrudes",
        "number": "344",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 604,
          "indicacao_id": 104,
          "endereco_id": 104,
          "raw_address": "Rua Santa Gertrudes, nº 344",
          "normalized_address": "Rua Santa Gertrudes, nº 344 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56828,
          "longitude": -47.16352,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 604,
        "indicacao_id": 104,
        "latitude": -22.56828,
        "longitude": -47.16352,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 344",
        "normalized_address": "Rua Santa Gertrudes, nº 344 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 104,
          "numero": 204,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Santa Gertrudes, bairro Jardim Conservani.",
          "autor": "Marina Ribeiro",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 105,
    "sapl_id": 1105,
    "numero": 205,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua 7 de Setembro, bairro Centro.",
    "autor": "Leandro Prado",
    "data_apresentacao": "08/10/2022",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 105,
        "indicacao_id": 105,
        "raw_text": "Rua 7 de Setembro",
        "street": "Rua 7 de Setembro",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 605,
          "indicacao_id": 105,
          "endereco_id": 105,
          "raw_address": "Rua 7 de Setembro",
          "normalized_address": "Rua 7 de Setembro - Centro, Artur Nogueira - SP",
          "latitude": -22.57452,
          "longitude": -47.16846,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 605,
        "indicacao_id": 105,
        "latitude": -22.57452,
        "longitude": -47.16846,
        "is_approximate": true,
        "raw_address": "Rua 7 de Setembro",
        "normalized_address": "Rua 7 de Setembro - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 105,
          "numero": 205,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua 7 de Setembro, bairro Centro.",
          "autor": "Leandro Prado",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 106,
    "sapl_id": 1106,
    "numero": 206,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Raymundo Berni, bairro Jardim Sacilotto I.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "11/03/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 106,
        "indicacao_id": 106,
        "raw_text": "Rua Raymundo Berni, nº 120",
        "street": "Rua Raymundo Berni",
        "number": "120",
        "bairro": "Jardim Sacilotto I",
        "status": "geocodificado",
        "geo_pin": {
          "id": 606,
          "indicacao_id": 106,
          "endereco_id": 106,
          "raw_address": "Rua Raymundo Berni, nº 120",
          "normalized_address": "Rua Raymundo Berni, nº 120 - Jardim Sacilotto I, Artur Nogueira - SP",
          "latitude": -22.58018,
          "longitude": -47.17598,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 606,
        "indicacao_id": 106,
        "latitude": -22.58018,
        "longitude": -47.17598,
        "is_approximate": false,
        "raw_address": "Rua Raymundo Berni, nº 120",
        "normalized_address": "Rua Raymundo Berni, nº 120 - Jardim Sacilotto I, Artur Nogueira - SP",
        "indicacao": {
          "id": 106,
          "numero": 206,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Raymundo Berni, bairro Jardim Sacilotto I.",
          "autor": "Gabriel Gomes",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 107,
    "sapl_id": 1107,
    "numero": 207,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Estrada Municipal São Bento, bairro Bairro São Bento.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "14/08/2025",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 107,
        "indicacao_id": 107,
        "raw_text": "Estrada Municipal São Bento, nº 377",
        "street": "Estrada Municipal São Bento",
        "number": "377",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 607,
          "indicacao_id": 107,
          "endereco_id": 107,
          "raw_address": "Estrada Municipal São Bento, nº 377",
          "normalized_address": "Estrada Municipal São Bento, nº 377 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58284,
          "longitude": -47.18092,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 607,
        "indicacao_id": 107,
        "latitude": -22.58284,
        "longitude": -47.18092,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 377",
        "normalized_address": "Estrada Municipal São Bento, nº 377 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 107,
          "numero": 207,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Estrada Municipal São Bento, bairro Bairro São Bento.",
          "autor": "Nicolas Rocha",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 108,
    "sapl_id": 1108,
    "numero": 208,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua José Amaro Rodrigues, bairro Parque das Flores.",
    "autor": "Bianca Barros",
    "data_apresentacao": "17/01/2023",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 108,
        "indicacao_id": 108,
        "raw_text": "Rua José Amaro Rodrigues, nº 388",
        "street": "Rua José Amaro Rodrigues",
        "number": "388",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 608,
          "indicacao_id": 108,
          "endereco_id": 108,
          "raw_address": "Rua José Amaro Rodrigues, nº 388",
          "normalized_address": "Rua José Amaro Rodrigues, nº 388 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58058,
          "longitude": -47.16494,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 608,
        "indicacao_id": 108,
        "latitude": -22.58058,
        "longitude": -47.16494,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 388",
        "normalized_address": "Rua José Amaro Rodrigues, nº 388 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 108,
          "numero": 208,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua José Amaro Rodrigues, bairro Parque das Flores.",
          "autor": "Bianca Barros",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 109,
    "sapl_id": 1109,
    "numero": 209,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Joinville, bairro Jardim Blumenau.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "20/06/2022",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 109,
        "indicacao_id": 109,
        "raw_text": "Rua Joinville, nº 399",
        "street": "Rua Joinville",
        "number": "399",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 609,
          "indicacao_id": 109,
          "endereco_id": 109,
          "raw_address": "Rua Joinville, nº 399",
          "normalized_address": "Rua Joinville, nº 399 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57624,
          "longitude": -47.17988,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 609,
        "indicacao_id": 109,
        "latitude": -22.57624,
        "longitude": -47.17988,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 399",
        "normalized_address": "Rua Joinville, nº 399 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 109,
          "numero": 209,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Joinville, bairro Jardim Blumenau.",
          "autor": "Igor Nascimento",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 110,
    "sapl_id": 1110,
    "numero": 210,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua dos Ipês, bairro Jardim Planalto.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "23/11/2021",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 110,
        "indicacao_id": 110,
        "raw_text": "Rua dos Ipês",
        "street": "Rua dos Ipês",
        "number": null,
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 610,
          "indicacao_id": 110,
          "endereco_id": 110,
          "raw_address": "Rua dos Ipês",
          "normalized_address": "Rua dos Ipês - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56698,
          "longitude": -47.1689,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 610,
        "indicacao_id": 110,
        "latitude": -22.56698,
        "longitude": -47.1689,
        "is_approximate": true,
        "raw_address": "Rua dos Ipês",
        "normalized_address": "Rua dos Ipês - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 110,
          "numero": 210,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua dos Ipês, bairro Jardim Planalto.",
          "autor": "Julia Oliveira",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 111,
    "sapl_id": 1111,
    "numero": 211,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Pedro Rosa, bairro Coração Criança.",
    "autor": "Helena Martins",
    "data_apresentacao": "26/04/2025",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 111,
        "indicacao_id": 111,
        "raw_text": "Rua Pedro Rosa, nº 421",
        "street": "Rua Pedro Rosa",
        "number": "421",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 611,
          "indicacao_id": 111,
          "endereco_id": 111,
          "raw_address": "Rua Pedro Rosa, nº 421",
          "normalized_address": "Rua Pedro Rosa, nº 421 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56314,
          "longitude": -47.17734,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 611,
        "indicacao_id": 111,
        "latitude": -22.56314,
        "longitude": -47.17734,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 421",
        "normalized_address": "Rua Pedro Rosa, nº 421 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 111,
          "numero": 211,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Pedro Rosa, bairro Coração Criança.",
          "autor": "Helena Martins",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 112,
    "sapl_id": 1112,
    "numero": 212,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua XV de Novembro, bairro Centro.",
    "autor": "Alex Andrade",
    "data_apresentacao": "01/09/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 112,
        "indicacao_id": 112,
        "raw_text": "Rua XV de Novembro, nº 432",
        "street": "Rua XV de Novembro",
        "number": "432",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 612,
          "indicacao_id": 112,
          "endereco_id": 112,
          "raw_address": "Rua XV de Novembro, nº 432",
          "normalized_address": "Rua XV de Novembro, nº 432 - Centro, Artur Nogueira - SP",
          "latitude": -22.5708,
          "longitude": -47.17086,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 612,
        "indicacao_id": 112,
        "latitude": -22.5708,
        "longitude": -47.17086,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 432",
        "normalized_address": "Rua XV de Novembro, nº 432 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 112,
          "numero": 212,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua XV de Novembro, bairro Centro.",
          "autor": "Alex Andrade",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 113,
    "sapl_id": 1113,
    "numero": 213,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Maria Marson Aresi, bairro Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "04/02/2022",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 113,
        "indicacao_id": 113,
        "raw_text": "Rua Maria Marson Aresi, nº 443",
        "street": "Rua Maria Marson Aresi",
        "number": "443",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 613,
          "indicacao_id": 113,
          "endereco_id": 113,
          "raw_address": "Rua Maria Marson Aresi, nº 443",
          "normalized_address": "Rua Maria Marson Aresi, nº 443 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58154,
          "longitude": -47.1723,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 613,
        "indicacao_id": 113,
        "latitude": -22.58154,
        "longitude": -47.1723,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 443",
        "normalized_address": "Rua Maria Marson Aresi, nº 443 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 113,
          "numero": 213,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Maria Marson Aresi, bairro Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 114,
    "sapl_id": 1114,
    "numero": 214,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Goiás, bairro Jardim Itamaraty.",
    "autor": "Patricia Silva",
    "data_apresentacao": "07/07/2021",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 114,
        "indicacao_id": 114,
        "raw_text": "Rua Goiás, nº 454",
        "street": "Rua Goiás",
        "number": "454",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 614,
          "indicacao_id": 114,
          "endereco_id": 114,
          "raw_address": "Rua Goiás, nº 454",
          "normalized_address": "Rua Goiás, nº 454 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5822,
          "longitude": -47.17032,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 614,
        "indicacao_id": 114,
        "latitude": -22.5822,
        "longitude": -47.17032,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 454",
        "normalized_address": "Rua Goiás, nº 454 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 114,
          "numero": 214,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Goiás, bairro Jardim Itamaraty.",
          "autor": "Patricia Silva",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 115,
    "sapl_id": 1115,
    "numero": 215,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua das Hortênsias, bairro Jardim Planalto.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "10/12/2025",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 115,
        "indicacao_id": 115,
        "raw_text": "Rua das Hortênsias",
        "street": "Rua das Hortênsias",
        "number": null,
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 615,
          "indicacao_id": 115,
          "endereco_id": 115,
          "raw_address": "Rua das Hortênsias",
          "normalized_address": "Rua das Hortênsias - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56744,
          "longitude": -47.16934,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 615,
        "indicacao_id": 115,
        "latitude": -22.56744,
        "longitude": -47.16934,
        "is_approximate": true,
        "raw_address": "Rua das Hortênsias",
        "normalized_address": "Rua das Hortênsias - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 115,
          "numero": 215,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua das Hortênsias, bairro Jardim Planalto.",
          "autor": "Eduardo Esteves",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 116,
    "sapl_id": 1116,
    "numero": 216,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Santa Gertrudes, bairro Jardim Conservani.",
    "autor": "Patricia Silva",
    "data_apresentacao": "13/05/2023",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 116,
        "indicacao_id": 116,
        "raw_text": "Rua Santa Gertrudes, nº 476",
        "street": "Rua Santa Gertrudes",
        "number": "476",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 616,
          "indicacao_id": 116,
          "endereco_id": 116,
          "raw_address": "Rua Santa Gertrudes, nº 476",
          "normalized_address": "Rua Santa Gertrudes, nº 476 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.5681,
          "longitude": -47.16028,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 616,
        "indicacao_id": 116,
        "latitude": -22.5681,
        "longitude": -47.16028,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 476",
        "normalized_address": "Rua Santa Gertrudes, nº 476 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 116,
          "numero": 216,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Santa Gertrudes, bairro Jardim Conservani.",
          "autor": "Patricia Silva",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 117,
    "sapl_id": 1117,
    "numero": 217,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua 7 de Setembro, bairro Centro.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "16/10/2022",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 117,
        "indicacao_id": 117,
        "raw_text": "Rua 7 de Setembro, nº 487",
        "street": "Rua 7 de Setembro",
        "number": "487",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 617,
          "indicacao_id": 117,
          "endereco_id": 117,
          "raw_address": "Rua 7 de Setembro, nº 487",
          "normalized_address": "Rua 7 de Setembro, nº 487 - Centro, Artur Nogueira - SP",
          "latitude": -22.57434,
          "longitude": -47.1708,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 617,
        "indicacao_id": 117,
        "latitude": -22.57434,
        "longitude": -47.1708,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 487",
        "normalized_address": "Rua 7 de Setembro, nº 487 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 117,
          "numero": 217,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua 7 de Setembro, bairro Centro.",
          "autor": "Rafael Teixeira",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 118,
    "sapl_id": 1118,
    "numero": 218,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Reinaldo Stein, bairro Jardim Sacilotto II.",
    "autor": "Leandro Prado",
    "data_apresentacao": "19/03/2021",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 118,
        "indicacao_id": 118,
        "raw_text": "Rua Reinaldo Stein, nº 498",
        "street": "Rua Reinaldo Stein",
        "number": "498",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 618,
          "indicacao_id": 118,
          "endereco_id": 118,
          "raw_address": "Rua Reinaldo Stein, nº 498",
          "normalized_address": "Rua Reinaldo Stein, nº 498 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58,
          "longitude": -47.17274,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 618,
        "indicacao_id": 118,
        "latitude": -22.58,
        "longitude": -47.17274,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 498",
        "normalized_address": "Rua Reinaldo Stein, nº 498 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 118,
          "numero": 218,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Reinaldo Stein, bairro Jardim Sacilotto II.",
          "autor": "Leandro Prado",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 119,
    "sapl_id": 1119,
    "numero": 219,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Estrada Municipal São Bento, bairro Bairro São Bento.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "22/08/2025",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 119,
        "indicacao_id": 119,
        "raw_text": "Estrada Municipal São Bento, nº 509",
        "street": "Estrada Municipal São Bento",
        "number": "509",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 619,
          "indicacao_id": 119,
          "endereco_id": 119,
          "raw_address": "Estrada Municipal São Bento, nº 509",
          "normalized_address": "Estrada Municipal São Bento, nº 509 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58266,
          "longitude": -47.18326,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 619,
        "indicacao_id": 119,
        "latitude": -22.58266,
        "longitude": -47.18326,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 509",
        "normalized_address": "Estrada Municipal São Bento, nº 509 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 119,
          "numero": 219,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Estrada Municipal São Bento, bairro Bairro São Bento.",
          "autor": "Nicolas Rocha",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 120,
    "sapl_id": 1120,
    "numero": 220,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua José Amaro Rodrigues, bairro Parque das Flores.",
    "autor": "Helena Martins",
    "data_apresentacao": "25/01/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 120,
        "indicacao_id": 120,
        "raw_text": "Rua José Amaro Rodrigues",
        "street": "Rua José Amaro Rodrigues",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 620,
          "indicacao_id": 120,
          "endereco_id": 120,
          "raw_address": "Rua José Amaro Rodrigues",
          "normalized_address": "Rua José Amaro Rodrigues - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.5804,
          "longitude": -47.1617,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 620,
        "indicacao_id": 120,
        "latitude": -22.5804,
        "longitude": -47.1617,
        "is_approximate": true,
        "raw_address": "Rua José Amaro Rodrigues",
        "normalized_address": "Rua José Amaro Rodrigues - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 120,
          "numero": 220,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua José Amaro Rodrigues, bairro Parque das Flores.",
          "autor": "Helena Martins",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 121,
    "sapl_id": 1121,
    "numero": 221,
    "ano": 2022,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Joinville, bairro Jardim Blumenau.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "28/06/2022",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 121,
        "indicacao_id": 121,
        "raw_text": "Rua Joinville, nº 531",
        "street": "Rua Joinville",
        "number": "531",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 621,
          "indicacao_id": 121,
          "endereco_id": 121,
          "raw_address": "Rua Joinville, nº 531",
          "normalized_address": "Rua Joinville, nº 531 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57606,
          "longitude": -47.18222,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 621,
        "indicacao_id": 121,
        "latitude": -22.57606,
        "longitude": -47.18222,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 531",
        "normalized_address": "Rua Joinville, nº 531 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 121,
          "numero": 221,
          "ano": 2022,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Joinville, bairro Jardim Blumenau.",
          "autor": "Igor Nascimento",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 122,
    "sapl_id": 1122,
    "numero": 222,
    "ano": 2021,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua dos Ipês, bairro Jardim Planalto.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "03/11/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 122,
        "indicacao_id": 122,
        "raw_text": "Rua dos Ipês, nº 542",
        "street": "Rua dos Ipês",
        "number": "542",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 622,
          "indicacao_id": 122,
          "endereco_id": 122,
          "raw_address": "Rua dos Ipês, nº 542",
          "normalized_address": "Rua dos Ipês, nº 542 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5668,
          "longitude": -47.16566,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 622,
        "indicacao_id": 122,
        "latitude": -22.5668,
        "longitude": -47.16566,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 542",
        "normalized_address": "Rua dos Ipês, nº 542 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 122,
          "numero": 222,
          "ano": 2021,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua dos Ipês, bairro Jardim Planalto.",
          "autor": "Julia Oliveira",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 123,
    "sapl_id": 1123,
    "numero": 223,
    "ano": 2025,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Pedro Rosa, bairro Coração Criança.",
    "autor": "Bianca Barros",
    "data_apresentacao": "06/04/2025",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 123,
        "indicacao_id": 123,
        "raw_text": "Rua Pedro Rosa, nº 553",
        "street": "Rua Pedro Rosa",
        "number": "553",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 623,
          "indicacao_id": 123,
          "endereco_id": 123,
          "raw_address": "Rua Pedro Rosa, nº 553",
          "normalized_address": "Rua Pedro Rosa, nº 553 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56296,
          "longitude": -47.17968,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 623,
        "indicacao_id": 123,
        "latitude": -22.56296,
        "longitude": -47.17968,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 553",
        "normalized_address": "Rua Pedro Rosa, nº 553 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 123,
          "numero": 223,
          "ano": 2025,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua Pedro Rosa, bairro Coração Criança.",
          "autor": "Bianca Barros",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 124,
    "sapl_id": 1124,
    "numero": 224,
    "ano": 2023,
    "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua XV de Novembro, bairro Centro.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "09/09/2023",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 124,
        "indicacao_id": 124,
        "raw_text": "Rua XV de Novembro, nº 564",
        "street": "Rua XV de Novembro",
        "number": "564",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 624,
          "indicacao_id": 124,
          "endereco_id": 124,
          "raw_address": "Rua XV de Novembro, nº 564",
          "normalized_address": "Rua XV de Novembro, nº 564 - Centro, Artur Nogueira - SP",
          "latitude": -22.5762,
          "longitude": -47.1732,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 624,
        "indicacao_id": 124,
        "latitude": -22.5762,
        "longitude": -47.1732,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 564",
        "normalized_address": "Rua XV de Novembro, nº 564 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 124,
          "numero": 224,
          "ano": 2023,
          "ementa": "Solicita recapeamento asfáltico e manutenção de pavimentação na Rua XV de Novembro, bairro Centro.",
          "autor": "Marina Ribeiro",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 125,
    "sapl_id": 1125,
    "numero": 225,
    "ano": 2022,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Maria Marson Aresi, Jardim Sacilotto II.",
    "autor": "Alex Andrade",
    "data_apresentacao": "12/02/2022",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 125,
        "indicacao_id": 125,
        "raw_text": "Rua Maria Marson Aresi",
        "street": "Rua Maria Marson Aresi",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 625,
          "indicacao_id": 125,
          "endereco_id": 125,
          "raw_address": "Rua Maria Marson Aresi",
          "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58136,
          "longitude": -47.17464,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 625,
        "indicacao_id": 125,
        "latitude": -22.58136,
        "longitude": -47.17464,
        "is_approximate": true,
        "raw_address": "Rua Maria Marson Aresi",
        "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 125,
          "numero": 225,
          "ano": 2022,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Maria Marson Aresi, Jardim Sacilotto II.",
          "autor": "Alex Andrade",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 126,
    "sapl_id": 1126,
    "numero": 226,
    "ano": 2021,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Goiás, Jardim Itamaraty.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "15/07/2021",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 126,
        "indicacao_id": 126,
        "raw_text": "Rua Goiás, nº 586",
        "street": "Rua Goiás",
        "number": "586",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 626,
          "indicacao_id": 126,
          "endereco_id": 126,
          "raw_address": "Rua Goiás, nº 586",
          "normalized_address": "Rua Goiás, nº 586 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58202,
          "longitude": -47.17266,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 626,
        "indicacao_id": 126,
        "latitude": -22.58202,
        "longitude": -47.17266,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 586",
        "normalized_address": "Rua Goiás, nº 586 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 126,
          "numero": 226,
          "ano": 2021,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Goiás, Jardim Itamaraty.",
          "autor": "Eduardo Esteves",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 127,
    "sapl_id": 1127,
    "numero": 227,
    "ano": 2025,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua das Hortênsias, Jardim Planalto.",
    "autor": "Caio Campos",
    "data_apresentacao": "18/12/2025",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 127,
        "indicacao_id": 127,
        "raw_text": "Rua das Hortênsias, nº 597",
        "street": "Rua das Hortênsias",
        "number": "597",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 627,
          "indicacao_id": 127,
          "endereco_id": 127,
          "raw_address": "Rua das Hortênsias, nº 597",
          "normalized_address": "Rua das Hortênsias, nº 597 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56726,
          "longitude": -47.1661,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 627,
        "indicacao_id": 127,
        "latitude": -22.56726,
        "longitude": -47.1661,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 597",
        "normalized_address": "Rua das Hortênsias, nº 597 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 127,
          "numero": 227,
          "ano": 2025,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua das Hortênsias, Jardim Planalto.",
          "autor": "Caio Campos",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 128,
    "sapl_id": 1128,
    "numero": 228,
    "ano": 2023,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Santa Gertrudes, Jardim Conservani.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "21/05/2023",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 128,
        "indicacao_id": 128,
        "raw_text": "Rua Santa Gertrudes, nº 608",
        "street": "Rua Santa Gertrudes",
        "number": "608",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 628,
          "indicacao_id": 128,
          "endereco_id": 128,
          "raw_address": "Rua Santa Gertrudes, nº 608",
          "normalized_address": "Rua Santa Gertrudes, nº 608 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56792,
          "longitude": -47.16262,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 628,
        "indicacao_id": 128,
        "latitude": -22.56792,
        "longitude": -47.16262,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 608",
        "normalized_address": "Rua Santa Gertrudes, nº 608 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 128,
          "numero": 228,
          "ano": 2023,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Santa Gertrudes, Jardim Conservani.",
          "autor": "Gabriel Gomes",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 129,
    "sapl_id": 1129,
    "numero": 229,
    "ano": 2022,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua 7 de Setembro, Centro.",
    "autor": "Diana Dias",
    "data_apresentacao": "24/10/2022",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 129,
        "indicacao_id": 129,
        "raw_text": "Rua 7 de Setembro, nº 619",
        "street": "Rua 7 de Setembro",
        "number": "619",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 629,
          "indicacao_id": 129,
          "endereco_id": 129,
          "raw_address": "Rua 7 de Setembro, nº 619",
          "normalized_address": "Rua 7 de Setembro, nº 619 - Centro, Artur Nogueira - SP",
          "latitude": -22.57416,
          "longitude": -47.16756,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 629,
        "indicacao_id": 129,
        "latitude": -22.57416,
        "longitude": -47.16756,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 619",
        "normalized_address": "Rua 7 de Setembro, nº 619 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 129,
          "numero": 229,
          "ano": 2022,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua 7 de Setembro, Centro.",
          "autor": "Diana Dias",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 130,
    "sapl_id": 1130,
    "numero": 230,
    "ano": 2021,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Reinaldo Stein, Jardim Sacilotto II.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "27/03/2021",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 130,
        "indicacao_id": 130,
        "raw_text": "Rua Reinaldo Stein",
        "street": "Rua Reinaldo Stein",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 630,
          "indicacao_id": 130,
          "endereco_id": 130,
          "raw_address": "Rua Reinaldo Stein",
          "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.57982,
          "longitude": -47.17508,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 630,
        "indicacao_id": 130,
        "latitude": -22.57982,
        "longitude": -47.17508,
        "is_approximate": true,
        "raw_address": "Rua Reinaldo Stein",
        "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 130,
          "numero": 230,
          "ano": 2021,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Reinaldo Stein, Jardim Sacilotto II.",
          "autor": "Fernanda Freitas",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 131,
    "sapl_id": 1131,
    "numero": 231,
    "ano": 2025,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Estrada Municipal São Bento, Bairro São Bento.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "02/08/2025",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 131,
        "indicacao_id": 131,
        "raw_text": "Estrada Municipal São Bento, nº 641",
        "street": "Estrada Municipal São Bento",
        "number": "641",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 631,
          "indicacao_id": 131,
          "endereco_id": 131,
          "raw_address": "Estrada Municipal São Bento, nº 641",
          "normalized_address": "Estrada Municipal São Bento, nº 641 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58248,
          "longitude": -47.18002,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 631,
        "indicacao_id": 131,
        "latitude": -22.58248,
        "longitude": -47.18002,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 641",
        "normalized_address": "Estrada Municipal São Bento, nº 641 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 131,
          "numero": 231,
          "ano": 2025,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Estrada Municipal São Bento, Bairro São Bento.",
          "autor": "Nicolas Rocha",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 132,
    "sapl_id": 1132,
    "numero": 232,
    "ano": 2023,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua José Amaro Rodrigues, Parque das Flores.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "05/01/2023",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 132,
        "indicacao_id": 132,
        "raw_text": "Rua José Amaro Rodrigues, nº 652",
        "street": "Rua José Amaro Rodrigues",
        "number": "652",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 632,
          "indicacao_id": 132,
          "endereco_id": 132,
          "raw_address": "Rua José Amaro Rodrigues, nº 652",
          "normalized_address": "Rua José Amaro Rodrigues, nº 652 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58022,
          "longitude": -47.16404,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 632,
        "indicacao_id": 132,
        "latitude": -22.58022,
        "longitude": -47.16404,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 652",
        "normalized_address": "Rua José Amaro Rodrigues, nº 652 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 132,
          "numero": 232,
          "ano": 2023,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua José Amaro Rodrigues, Parque das Flores.",
          "autor": "Fernanda Freitas",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 133,
    "sapl_id": 1133,
    "numero": 233,
    "ano": 2022,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Joinville, Jardim Blumenau.",
    "autor": "Alex Andrade",
    "data_apresentacao": "08/06/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 133,
        "indicacao_id": 133,
        "raw_text": "Rua Joinville, nº 663",
        "street": "Rua Joinville",
        "number": "663",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 633,
          "indicacao_id": 133,
          "endereco_id": 133,
          "raw_address": "Rua Joinville, nº 663",
          "normalized_address": "Rua Joinville, nº 663 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57588,
          "longitude": -47.17898,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 633,
        "indicacao_id": 133,
        "latitude": -22.57588,
        "longitude": -47.17898,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 663",
        "normalized_address": "Rua Joinville, nº 663 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 133,
          "numero": 233,
          "ano": 2022,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Joinville, Jardim Blumenau.",
          "autor": "Alex Andrade",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 134,
    "sapl_id": 1134,
    "numero": 234,
    "ano": 2021,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua dos Ipês, Jardim Planalto.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "11/11/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 134,
        "indicacao_id": 134,
        "raw_text": "Rua dos Ipês, nº 674",
        "street": "Rua dos Ipês",
        "number": "674",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 634,
          "indicacao_id": 134,
          "endereco_id": 134,
          "raw_address": "Rua dos Ipês, nº 674",
          "normalized_address": "Rua dos Ipês, nº 674 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56662,
          "longitude": -47.168,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 634,
        "indicacao_id": 134,
        "latitude": -22.56662,
        "longitude": -47.168,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 674",
        "normalized_address": "Rua dos Ipês, nº 674 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 134,
          "numero": 234,
          "ano": 2021,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua dos Ipês, Jardim Planalto.",
          "autor": "Marina Ribeiro",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 135,
    "sapl_id": 1135,
    "numero": 235,
    "ano": 2025,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Pedro Rosa, Coração Criança.",
    "autor": "Patricia Silva",
    "data_apresentacao": "14/04/2025",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 135,
        "indicacao_id": 135,
        "raw_text": "Rua Pedro Rosa",
        "street": "Rua Pedro Rosa",
        "number": null,
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 635,
          "indicacao_id": 135,
          "endereco_id": 135,
          "raw_address": "Rua Pedro Rosa",
          "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56278,
          "longitude": -47.18202,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 635,
        "indicacao_id": 135,
        "latitude": -22.56278,
        "longitude": -47.18202,
        "is_approximate": true,
        "raw_address": "Rua Pedro Rosa",
        "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 135,
          "numero": 235,
          "ano": 2025,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Pedro Rosa, Coração Criança.",
          "autor": "Patricia Silva",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 136,
    "sapl_id": 1136,
    "numero": 236,
    "ano": 2023,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua XV de Novembro, Centro.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "17/09/2023",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 136,
        "indicacao_id": 136,
        "raw_text": "Rua XV de Novembro, nº 696",
        "street": "Rua XV de Novembro",
        "number": "696",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 636,
          "indicacao_id": 136,
          "endereco_id": 136,
          "raw_address": "Rua XV de Novembro, nº 696",
          "normalized_address": "Rua XV de Novembro, nº 696 - Centro, Artur Nogueira - SP",
          "latitude": -22.57602,
          "longitude": -47.16996,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 636,
        "indicacao_id": 136,
        "latitude": -22.57602,
        "longitude": -47.16996,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 696",
        "normalized_address": "Rua XV de Novembro, nº 696 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 136,
          "numero": 236,
          "ano": 2023,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua XV de Novembro, Centro.",
          "autor": "Julia Oliveira",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 137,
    "sapl_id": 1137,
    "numero": 237,
    "ano": 2022,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Maria Marson Aresi, Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "20/02/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 137,
        "indicacao_id": 137,
        "raw_text": "Rua Maria Marson Aresi, nº 707",
        "street": "Rua Maria Marson Aresi",
        "number": "707",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 637,
          "indicacao_id": 137,
          "endereco_id": 137,
          "raw_address": "Rua Maria Marson Aresi, nº 707",
          "normalized_address": "Rua Maria Marson Aresi, nº 707 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58118,
          "longitude": -47.17698,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 637,
        "indicacao_id": 137,
        "latitude": -22.58118,
        "longitude": -47.17698,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 707",
        "normalized_address": "Rua Maria Marson Aresi, nº 707 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 137,
          "numero": 237,
          "ano": 2022,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Maria Marson Aresi, Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 138,
    "sapl_id": 1138,
    "numero": 238,
    "ano": 2021,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Goiás, Jardim Itamaraty.",
    "autor": "Leandro Prado",
    "data_apresentacao": "23/07/2021",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 138,
        "indicacao_id": 138,
        "raw_text": "Rua Goiás, nº 718",
        "street": "Rua Goiás",
        "number": "718",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 638,
          "indicacao_id": 138,
          "endereco_id": 138,
          "raw_address": "Rua Goiás, nº 718",
          "normalized_address": "Rua Goiás, nº 718 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58184,
          "longitude": -47.16942,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 638,
        "indicacao_id": 138,
        "latitude": -22.58184,
        "longitude": -47.16942,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 718",
        "normalized_address": "Rua Goiás, nº 718 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 138,
          "numero": 238,
          "ano": 2021,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Goiás, Jardim Itamaraty.",
          "autor": "Leandro Prado",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 139,
    "sapl_id": 1139,
    "numero": 239,
    "ano": 2025,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua das Hortênsias, Jardim Planalto.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "26/12/2025",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 139,
        "indicacao_id": 139,
        "raw_text": "Rua das Hortênsias, nº 729",
        "street": "Rua das Hortênsias",
        "number": "729",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 639,
          "indicacao_id": 139,
          "endereco_id": 139,
          "raw_address": "Rua das Hortênsias, nº 729",
          "normalized_address": "Rua das Hortênsias, nº 729 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56708,
          "longitude": -47.16844,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 639,
        "indicacao_id": 139,
        "latitude": -22.56708,
        "longitude": -47.16844,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 729",
        "normalized_address": "Rua das Hortênsias, nº 729 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 139,
          "numero": 239,
          "ano": 2025,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua das Hortênsias, Jardim Planalto.",
          "autor": "Rafael Teixeira",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 140,
    "sapl_id": 1140,
    "numero": 240,
    "ano": 2023,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Santa Gertrudes, Jardim Conservani.",
    "autor": "Caio Campos",
    "data_apresentacao": "01/05/2023",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 140,
        "indicacao_id": 140,
        "raw_text": "Rua Santa Gertrudes",
        "street": "Rua Santa Gertrudes",
        "number": null,
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 640,
          "indicacao_id": 140,
          "endereco_id": 140,
          "raw_address": "Rua Santa Gertrudes",
          "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56774,
          "longitude": -47.15938,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 640,
        "indicacao_id": 140,
        "latitude": -22.56774,
        "longitude": -47.15938,
        "is_approximate": true,
        "raw_address": "Rua Santa Gertrudes",
        "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 140,
          "numero": 240,
          "ano": 2023,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Santa Gertrudes, Jardim Conservani.",
          "autor": "Caio Campos",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 141,
    "sapl_id": 1141,
    "numero": 241,
    "ano": 2022,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua 7 de Setembro, Centro.",
    "autor": "Bianca Barros",
    "data_apresentacao": "04/10/2022",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 141,
        "indicacao_id": 141,
        "raw_text": "Rua 7 de Setembro, nº 751",
        "street": "Rua 7 de Setembro",
        "number": "751",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 641,
          "indicacao_id": 141,
          "endereco_id": 141,
          "raw_address": "Rua 7 de Setembro, nº 751",
          "normalized_address": "Rua 7 de Setembro, nº 751 - Centro, Artur Nogueira - SP",
          "latitude": -22.57398,
          "longitude": -47.1699,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 641,
        "indicacao_id": 141,
        "latitude": -22.57398,
        "longitude": -47.1699,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 751",
        "normalized_address": "Rua 7 de Setembro, nº 751 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 141,
          "numero": 241,
          "ano": 2022,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua 7 de Setembro, Centro.",
          "autor": "Bianca Barros",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 142,
    "sapl_id": 1142,
    "numero": 242,
    "ano": 2021,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Reinaldo Stein, Jardim Sacilotto II.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "07/03/2021",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 142,
        "indicacao_id": 142,
        "raw_text": "Rua Reinaldo Stein, nº 762",
        "street": "Rua Reinaldo Stein",
        "number": "762",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 642,
          "indicacao_id": 142,
          "endereco_id": 142,
          "raw_address": "Rua Reinaldo Stein, nº 762",
          "normalized_address": "Rua Reinaldo Stein, nº 762 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.57964,
          "longitude": -47.17184,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 642,
        "indicacao_id": 142,
        "latitude": -22.57964,
        "longitude": -47.17184,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 762",
        "normalized_address": "Rua Reinaldo Stein, nº 762 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 142,
          "numero": 242,
          "ano": 2021,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua Reinaldo Stein, Jardim Sacilotto II.",
          "autor": "Eduardo Esteves",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 143,
    "sapl_id": 1143,
    "numero": 243,
    "ano": 2025,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Estrada Municipal São Bento, Bairro São Bento.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "10/08/2025",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 143,
        "indicacao_id": 143,
        "raw_text": "Estrada Municipal São Bento, nº 773",
        "street": "Estrada Municipal São Bento",
        "number": "773",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 643,
          "indicacao_id": 143,
          "endereco_id": 143,
          "raw_address": "Estrada Municipal São Bento, nº 773",
          "normalized_address": "Estrada Municipal São Bento, nº 773 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.5823,
          "longitude": -47.18236,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 643,
        "indicacao_id": 143,
        "latitude": -22.5823,
        "longitude": -47.18236,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 773",
        "normalized_address": "Estrada Municipal São Bento, nº 773 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 143,
          "numero": 243,
          "ano": 2025,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Estrada Municipal São Bento, Bairro São Bento.",
          "autor": "Igor Nascimento",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 144,
    "sapl_id": 1144,
    "numero": 244,
    "ano": 2023,
    "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua José Amaro Rodrigues, Parque das Flores.",
    "autor": "Helena Martins",
    "data_apresentacao": "13/01/2023",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 144,
        "indicacao_id": 144,
        "raw_text": "Rua José Amaro Rodrigues, nº 784",
        "street": "Rua José Amaro Rodrigues",
        "number": "784",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 644,
          "indicacao_id": 144,
          "endereco_id": 144,
          "raw_address": "Rua José Amaro Rodrigues, nº 784",
          "normalized_address": "Rua José Amaro Rodrigues, nº 784 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58004,
          "longitude": -47.1608,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 644,
        "indicacao_id": 144,
        "latitude": -22.58004,
        "longitude": -47.1608,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 784",
        "normalized_address": "Rua José Amaro Rodrigues, nº 784 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 144,
          "numero": 244,
          "ano": 2023,
          "ementa": "Indica pintura de faixa de pedestres e implantação de lombada redutora na Rua José Amaro Rodrigues, Parque das Flores.",
          "autor": "Helena Martins",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 145,
    "sapl_id": 1145,
    "numero": 245,
    "ano": 2022,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua das Hortênsias, Jardim Planalto.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "16/06/2022",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 145,
        "indicacao_id": 145,
        "raw_text": "Rua das Hortênsias",
        "street": "Rua das Hortênsias",
        "number": null,
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 645,
          "indicacao_id": 145,
          "endereco_id": 145,
          "raw_address": "Rua das Hortênsias",
          "normalized_address": "Rua das Hortênsias - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5642,
          "longitude": -47.16682,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 645,
        "indicacao_id": 145,
        "latitude": -22.5642,
        "longitude": -47.16682,
        "is_approximate": true,
        "raw_address": "Rua das Hortênsias",
        "normalized_address": "Rua das Hortênsias - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 145,
          "numero": 245,
          "ano": 2022,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua das Hortênsias, Jardim Planalto.",
          "autor": "Gabriel Gomes",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 146,
    "sapl_id": 1146,
    "numero": 246,
    "ano": 2021,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Santa Gertrudes, Jardim Conservani.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "19/11/2021",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 146,
        "indicacao_id": 146,
        "raw_text": "Rua Santa Gertrudes, nº 806",
        "street": "Rua Santa Gertrudes",
        "number": "806",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 646,
          "indicacao_id": 146,
          "endereco_id": 146,
          "raw_address": "Rua Santa Gertrudes, nº 806",
          "normalized_address": "Rua Santa Gertrudes, nº 806 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.57044,
          "longitude": -47.16334,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 646,
        "indicacao_id": 146,
        "latitude": -22.57044,
        "longitude": -47.16334,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 806",
        "normalized_address": "Rua Santa Gertrudes, nº 806 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 146,
          "numero": 246,
          "ano": 2021,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Santa Gertrudes, Jardim Conservani.",
          "autor": "Gabriel Gomes",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 147,
    "sapl_id": 1147,
    "numero": 247,
    "ano": 2025,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua 7 de Setembro, Centro.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "22/04/2025",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 147,
        "indicacao_id": 147,
        "raw_text": "Rua 7 de Setembro, nº 817",
        "street": "Rua 7 de Setembro",
        "number": "817",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 647,
          "indicacao_id": 147,
          "endereco_id": 147,
          "raw_address": "Rua 7 de Setembro, nº 817",
          "normalized_address": "Rua 7 de Setembro, nº 817 - Centro, Artur Nogueira - SP",
          "latitude": -22.5711,
          "longitude": -47.16828,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 647,
        "indicacao_id": 147,
        "latitude": -22.5711,
        "longitude": -47.16828,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 817",
        "normalized_address": "Rua 7 de Setembro, nº 817 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 147,
          "numero": 247,
          "ano": 2025,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua 7 de Setembro, Centro.",
          "autor": "Julia Oliveira",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 148,
    "sapl_id": 1148,
    "numero": 248,
    "ano": 2023,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Reinaldo Stein, Jardim Sacilotto II.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "25/09/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 148,
        "indicacao_id": 148,
        "raw_text": "Rua Reinaldo Stein, nº 828",
        "street": "Rua Reinaldo Stein",
        "number": "828",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 648,
          "indicacao_id": 148,
          "endereco_id": 148,
          "raw_address": "Rua Reinaldo Stein, nº 828",
          "normalized_address": "Rua Reinaldo Stein, nº 828 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58234,
          "longitude": -47.1758,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 648,
        "indicacao_id": 148,
        "latitude": -22.58234,
        "longitude": -47.1758,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 828",
        "normalized_address": "Rua Reinaldo Stein, nº 828 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 148,
          "numero": 248,
          "ano": 2023,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Reinaldo Stein, Jardim Sacilotto II.",
          "autor": "Eduardo Esteves",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 149,
    "sapl_id": 1149,
    "numero": 249,
    "ano": 2022,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Estrada Municipal São Bento, Bairro São Bento.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "28/02/2022",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 149,
        "indicacao_id": 149,
        "raw_text": "Estrada Municipal São Bento, nº 839",
        "street": "Estrada Municipal São Bento",
        "number": "839",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 649,
          "indicacao_id": 149,
          "endereco_id": 149,
          "raw_address": "Estrada Municipal São Bento, nº 839",
          "normalized_address": "Estrada Municipal São Bento, nº 839 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.585,
          "longitude": -47.18074,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 649,
        "indicacao_id": 149,
        "latitude": -22.585,
        "longitude": -47.18074,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 839",
        "normalized_address": "Estrada Municipal São Bento, nº 839 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 149,
          "numero": 249,
          "ano": 2022,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Estrada Municipal São Bento, Bairro São Bento.",
          "autor": "Nicolas Rocha",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 150,
    "sapl_id": 1150,
    "numero": 250,
    "ano": 2021,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua José Amaro Rodrigues, Parque das Flores.",
    "autor": "Caio Campos",
    "data_apresentacao": "03/07/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 150,
        "indicacao_id": 150,
        "raw_text": "Rua José Amaro Rodrigues",
        "street": "Rua José Amaro Rodrigues",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 650,
          "indicacao_id": 150,
          "endereco_id": 150,
          "raw_address": "Rua José Amaro Rodrigues",
          "normalized_address": "Rua José Amaro Rodrigues - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57716,
          "longitude": -47.16476,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 650,
        "indicacao_id": 150,
        "latitude": -22.57716,
        "longitude": -47.16476,
        "is_approximate": true,
        "raw_address": "Rua José Amaro Rodrigues",
        "normalized_address": "Rua José Amaro Rodrigues - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 150,
          "numero": 250,
          "ano": 2021,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua José Amaro Rodrigues, Parque das Flores.",
          "autor": "Caio Campos",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 151,
    "sapl_id": 1151,
    "numero": 251,
    "ano": 2025,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Joinville, Jardim Blumenau.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "06/12/2025",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 151,
        "indicacao_id": 151,
        "raw_text": "Rua Joinville, nº 861",
        "street": "Rua Joinville",
        "number": "861",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 651,
          "indicacao_id": 151,
          "endereco_id": 151,
          "raw_address": "Rua Joinville, nº 861",
          "normalized_address": "Rua Joinville, nº 861 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.5784,
          "longitude": -47.1797,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 651,
        "indicacao_id": 151,
        "latitude": -22.5784,
        "longitude": -47.1797,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 861",
        "normalized_address": "Rua Joinville, nº 861 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 151,
          "numero": 251,
          "ano": 2025,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Joinville, Jardim Blumenau.",
          "autor": "Rafael Teixeira",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 152,
    "sapl_id": 1152,
    "numero": 252,
    "ano": 2023,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua dos Ipês, Jardim Planalto.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "09/05/2023",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 152,
        "indicacao_id": 152,
        "raw_text": "Rua dos Ipês, nº 872",
        "street": "Rua dos Ipês",
        "number": "872",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 652,
          "indicacao_id": 152,
          "endereco_id": 152,
          "raw_address": "Rua dos Ipês, nº 872",
          "normalized_address": "Rua dos Ipês, nº 872 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56356,
          "longitude": -47.16872,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 652,
        "indicacao_id": 152,
        "latitude": -22.56356,
        "longitude": -47.16872,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 872",
        "normalized_address": "Rua dos Ipês, nº 872 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 152,
          "numero": 252,
          "ano": 2023,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua dos Ipês, Jardim Planalto.",
          "autor": "Igor Nascimento",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 153,
    "sapl_id": 1153,
    "numero": 253,
    "ano": 2022,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Pedro Rosa, Coração Criança.",
    "autor": "Bianca Barros",
    "data_apresentacao": "12/10/2022",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 153,
        "indicacao_id": 153,
        "raw_text": "Rua Pedro Rosa, nº 883",
        "street": "Rua Pedro Rosa",
        "number": "883",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 653,
          "indicacao_id": 153,
          "endereco_id": 153,
          "raw_address": "Rua Pedro Rosa, nº 883",
          "normalized_address": "Rua Pedro Rosa, nº 883 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.5653,
          "longitude": -47.17716,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 653,
        "indicacao_id": 153,
        "latitude": -22.5653,
        "longitude": -47.17716,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 883",
        "normalized_address": "Rua Pedro Rosa, nº 883 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 153,
          "numero": 253,
          "ano": 2022,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Pedro Rosa, Coração Criança.",
          "autor": "Bianca Barros",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 154,
    "sapl_id": 1154,
    "numero": 254,
    "ano": 2021,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua XV de Novembro, Centro.",
    "autor": "Alex Andrade",
    "data_apresentacao": "15/03/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 154,
        "indicacao_id": 154,
        "raw_text": "Rua XV de Novembro, nº 894",
        "street": "Rua XV de Novembro",
        "number": "894",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 654,
          "indicacao_id": 154,
          "endereco_id": 154,
          "raw_address": "Rua XV de Novembro, nº 894",
          "normalized_address": "Rua XV de Novembro, nº 894 - Centro, Artur Nogueira - SP",
          "latitude": -22.57296,
          "longitude": -47.17068,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 654,
        "indicacao_id": 154,
        "latitude": -22.57296,
        "longitude": -47.17068,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 894",
        "normalized_address": "Rua XV de Novembro, nº 894 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 154,
          "numero": 254,
          "ano": 2021,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua XV de Novembro, Centro.",
          "autor": "Alex Andrade",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 155,
    "sapl_id": 1155,
    "numero": 255,
    "ano": 2025,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Maria Marson Aresi, Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "18/08/2025",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 155,
        "indicacao_id": 155,
        "raw_text": "Rua Maria Marson Aresi",
        "street": "Rua Maria Marson Aresi",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 655,
          "indicacao_id": 155,
          "endereco_id": 155,
          "raw_address": "Rua Maria Marson Aresi",
          "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5837,
          "longitude": -47.1777,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 655,
        "indicacao_id": 155,
        "latitude": -22.5837,
        "longitude": -47.1777,
        "is_approximate": true,
        "raw_address": "Rua Maria Marson Aresi",
        "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 155,
          "numero": 255,
          "ano": 2025,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Maria Marson Aresi, Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 156,
    "sapl_id": 1156,
    "numero": 256,
    "ano": 2023,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Goiás, Jardim Itamaraty.",
    "autor": "Leandro Prado",
    "data_apresentacao": "21/01/2023",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 156,
        "indicacao_id": 156,
        "raw_text": "Rua Goiás, nº 66",
        "street": "Rua Goiás",
        "number": "66",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 656,
          "indicacao_id": 156,
          "endereco_id": 156,
          "raw_address": "Rua Goiás, nº 66",
          "normalized_address": "Rua Goiás, nº 66 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58436,
          "longitude": -47.17014,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 656,
        "indicacao_id": 156,
        "latitude": -22.58436,
        "longitude": -47.17014,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 66",
        "normalized_address": "Rua Goiás, nº 66 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 156,
          "numero": 256,
          "ano": 2023,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua Goiás, Jardim Itamaraty.",
          "autor": "Leandro Prado",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 157,
    "sapl_id": 1157,
    "numero": 257,
    "ano": 2022,
    "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua das Hortênsias, Jardim Planalto.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "24/06/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 157,
        "indicacao_id": 157,
        "raw_text": "Rua das Hortênsias, nº 77",
        "street": "Rua das Hortênsias",
        "number": "77",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 657,
          "indicacao_id": 157,
          "endereco_id": 157,
          "raw_address": "Rua das Hortênsias, nº 77",
          "normalized_address": "Rua das Hortênsias, nº 77 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56402,
          "longitude": -47.16916,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 657,
        "indicacao_id": 157,
        "latitude": -22.56402,
        "longitude": -47.16916,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 77",
        "normalized_address": "Rua das Hortênsias, nº 77 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 157,
          "numero": 257,
          "ano": 2022,
          "ementa": "Solicita abrigo com cobertura e assento para ponto de ônibus na Rua das Hortênsias, Jardim Planalto.",
          "autor": "Fernanda Freitas",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 158,
    "sapl_id": 1158,
    "numero": 258,
    "ano": 2023,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Duque de Caxias, Centro.",
    "autor": "Patricia Silva",
    "data_apresentacao": "27/11/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 158,
        "indicacao_id": 158,
        "raw_text": "Rua Duque de Caxias, nº 88",
        "street": "Rua Duque de Caxias",
        "number": "88",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 658,
          "indicacao_id": 158,
          "endereco_id": 158,
          "raw_address": "Rua Duque de Caxias, nº 88",
          "normalized_address": "Rua Duque de Caxias, nº 88 - Centro, Artur Nogueira - SP",
          "latitude": -22.57076,
          "longitude": -47.1731,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 658,
        "indicacao_id": 158,
        "latitude": -22.57076,
        "longitude": -47.1731,
        "is_approximate": false,
        "raw_address": "Rua Duque de Caxias, nº 88",
        "normalized_address": "Rua Duque de Caxias, nº 88 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 158,
          "numero": 258,
          "ano": 2023,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Duque de Caxias, Centro.",
          "autor": "Patricia Silva",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 159,
    "sapl_id": 1159,
    "numero": 259,
    "ano": 2022,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Santo de Faveri, Jardim Sacilotto II.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "02/04/2022",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 159,
        "indicacao_id": 159,
        "raw_text": "Rua Santo de Faveri, nº 99",
        "street": "Rua Santo de Faveri",
        "number": "99",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 659,
          "indicacao_id": 159,
          "endereco_id": 159,
          "raw_address": "Rua Santo de Faveri, nº 99",
          "normalized_address": "Rua Santo de Faveri, nº 99 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58142,
          "longitude": -47.17812,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 659,
        "indicacao_id": 159,
        "latitude": -22.58142,
        "longitude": -47.17812,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 99",
        "normalized_address": "Rua Santo de Faveri, nº 99 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 159,
          "numero": 259,
          "ano": 2022,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Santo de Faveri, Jardim Sacilotto II.",
          "autor": "Marina Ribeiro",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 160,
    "sapl_id": 1160,
    "numero": 260,
    "ano": 2021,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Bela Vista, Residencial Bela Vista.",
    "autor": "Helena Martins",
    "data_apresentacao": "05/09/2021",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 160,
        "indicacao_id": 160,
        "raw_text": "Rua Bela Vista",
        "street": "Rua Bela Vista",
        "number": null,
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 660,
          "indicacao_id": 160,
          "endereco_id": 160,
          "raw_address": "Rua Bela Vista",
          "normalized_address": "Rua Bela Vista - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.56216,
          "longitude": -47.17056,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 660,
        "indicacao_id": 160,
        "latitude": -22.56216,
        "longitude": -47.17056,
        "is_approximate": true,
        "raw_address": "Rua Bela Vista",
        "normalized_address": "Rua Bela Vista - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 160,
          "numero": 260,
          "ano": 2021,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Bela Vista, Residencial Bela Vista.",
          "autor": "Helena Martins",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 161,
    "sapl_id": 1161,
    "numero": 261,
    "ano": 2026,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "08/02/2026",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 161,
        "indicacao_id": 161,
        "raw_text": "Rua Humberto Rossetti, nº 121",
        "street": "Rua Humberto Rossetti",
        "number": "121",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 661,
          "indicacao_id": 161,
          "endereco_id": 161,
          "raw_address": "Rua Humberto Rossetti, nº 121",
          "normalized_address": "Rua Humberto Rossetti, nº 121 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57782,
          "longitude": -47.16608,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 661,
        "indicacao_id": 161,
        "latitude": -22.57782,
        "longitude": -47.16608,
        "is_approximate": false,
        "raw_address": "Rua Humberto Rossetti, nº 121",
        "normalized_address": "Rua Humberto Rossetti, nº 121 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 161,
          "numero": 261,
          "ano": 2026,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Rafael Teixeira",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 162,
    "sapl_id": 1162,
    "numero": 262,
    "ano": 2023,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Blumenau, Jardim Blumenau.",
    "autor": "Alex Andrade",
    "data_apresentacao": "11/07/2023",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 162,
        "indicacao_id": 162,
        "raw_text": "Rua Blumenau, nº 132",
        "street": "Rua Blumenau",
        "number": "132",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 662,
          "indicacao_id": 162,
          "endereco_id": 162,
          "raw_address": "Rua Blumenau, nº 132",
          "normalized_address": "Rua Blumenau, nº 132 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57348,
          "longitude": -47.17802,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 662,
        "indicacao_id": 162,
        "latitude": -22.57348,
        "longitude": -47.17802,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 132",
        "normalized_address": "Rua Blumenau, nº 132 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 162,
          "numero": 262,
          "ano": 2023,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Blumenau, Jardim Blumenau.",
          "autor": "Alex Andrade",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 163,
    "sapl_id": 1163,
    "numero": 263,
    "ano": 2022,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Adhemar de Barros, Centro.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "14/12/2022",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 163,
        "indicacao_id": 163,
        "raw_text": "Rua Adhemar de Barros, nº 143",
        "street": "Rua Adhemar de Barros",
        "number": "143",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 663,
          "indicacao_id": 163,
          "endereco_id": 163,
          "raw_address": "Rua Adhemar de Barros, nº 143",
          "normalized_address": "Rua Adhemar de Barros, nº 143 - Centro, Artur Nogueira - SP",
          "latitude": -22.57572,
          "longitude": -47.17154,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 663,
        "indicacao_id": 163,
        "latitude": -22.57572,
        "longitude": -47.17154,
        "is_approximate": false,
        "raw_address": "Rua Adhemar de Barros, nº 143",
        "normalized_address": "Rua Adhemar de Barros, nº 143 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 163,
          "numero": 263,
          "ano": 2022,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Adhemar de Barros, Centro.",
          "autor": "Gabriel Gomes",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 164,
    "sapl_id": 1164,
    "numero": 264,
    "ano": 2021,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Antônio Tagliari, Coração Criança.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "17/05/2021",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 164,
        "indicacao_id": 164,
        "raw_text": "Rua Antônio Tagliari, nº 154",
        "street": "Rua Antônio Tagliari",
        "number": "154",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 664,
          "indicacao_id": 164,
          "endereco_id": 164,
          "raw_address": "Rua Antônio Tagliari, nº 154",
          "normalized_address": "Rua Antônio Tagliari, nº 154 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56038,
          "longitude": -47.17548,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 664,
        "indicacao_id": 164,
        "latitude": -22.56038,
        "longitude": -47.17548,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 154",
        "normalized_address": "Rua Antônio Tagliari, nº 154 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 164,
          "numero": 264,
          "ano": 2021,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Antônio Tagliari, Coração Criança.",
          "autor": "Fernanda Freitas",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 165,
    "sapl_id": 1165,
    "numero": 265,
    "ano": 2026,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Avenida Fernando Arens, Centro.",
    "autor": "Caio Campos",
    "data_apresentacao": "20/10/2026",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 165,
        "indicacao_id": 165,
        "raw_text": "Avenida Fernando Arens",
        "street": "Avenida Fernando Arens",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 665,
          "indicacao_id": 165,
          "endereco_id": 165,
          "raw_address": "Avenida Fernando Arens",
          "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
          "latitude": -22.57302,
          "longitude": -47.1728,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 665,
        "indicacao_id": 165,
        "latitude": -22.57302,
        "longitude": -47.1728,
        "is_approximate": true,
        "raw_address": "Avenida Fernando Arens",
        "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 165,
          "numero": 265,
          "ano": 2026,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Avenida Fernando Arens, Centro.",
          "autor": "Caio Campos",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 166,
    "sapl_id": 1166,
    "numero": 266,
    "ano": 2023,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Av. Dr. Roberto Silva, Parque das Flores.",
    "autor": "Leandro Prado",
    "data_apresentacao": "23/03/2023",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 166,
        "indicacao_id": 166,
        "raw_text": "Av. Dr. Roberto Silva, nº 176",
        "street": "Av. Dr. Roberto Silva",
        "number": "176",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 666,
          "indicacao_id": 166,
          "endereco_id": 166,
          "raw_address": "Av. Dr. Roberto Silva, nº 176",
          "normalized_address": "Av. Dr. Roberto Silva, nº 176 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57628,
          "longitude": -47.16852,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 666,
        "indicacao_id": 166,
        "latitude": -22.57628,
        "longitude": -47.16852,
        "is_approximate": false,
        "raw_address": "Av. Dr. Roberto Silva, nº 176",
        "normalized_address": "Av. Dr. Roberto Silva, nº 176 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 166,
          "numero": 266,
          "ano": 2023,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Av. Dr. Roberto Silva, Parque das Flores.",
          "autor": "Leandro Prado",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 167,
    "sapl_id": 1167,
    "numero": 267,
    "ano": 2022,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Itamaraty, Jardim Itamaraty.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "26/08/2022",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 167,
        "indicacao_id": 167,
        "raw_text": "Rua Itamaraty, nº 187",
        "street": "Rua Itamaraty",
        "number": "187",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 667,
          "indicacao_id": 167,
          "endereco_id": 167,
          "raw_address": "Rua Itamaraty, nº 187",
          "normalized_address": "Rua Itamaraty, nº 187 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58552,
          "longitude": -47.16846,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 667,
        "indicacao_id": 167,
        "latitude": -22.58552,
        "longitude": -47.16846,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 187",
        "normalized_address": "Rua Itamaraty, nº 187 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 167,
          "numero": 267,
          "ano": 2022,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Itamaraty, Jardim Itamaraty.",
          "autor": "Julia Oliveira",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 168,
    "sapl_id": 1168,
    "numero": 268,
    "ano": 2021,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua das Margaridas, Jardim Planalto.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "01/01/2021",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 168,
        "indicacao_id": 168,
        "raw_text": "Rua das Margaridas, nº 198",
        "street": "Rua das Margaridas",
        "number": "198",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 668,
          "indicacao_id": 168,
          "endereco_id": 168,
          "raw_address": "Rua das Margaridas, nº 198",
          "normalized_address": "Rua das Margaridas, nº 198 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56418,
          "longitude": -47.17148,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 668,
        "indicacao_id": 168,
        "latitude": -22.56418,
        "longitude": -47.17148,
        "is_approximate": false,
        "raw_address": "Rua das Margaridas, nº 198",
        "normalized_address": "Rua das Margaridas, nº 198 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 168,
          "numero": 268,
          "ano": 2021,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua das Margaridas, Jardim Planalto.",
          "autor": "Nicolas Rocha",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 169,
    "sapl_id": 1169,
    "numero": 269,
    "ano": 2026,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Expedicionários, Jardim Conservani.",
    "autor": "Diana Dias",
    "data_apresentacao": "04/06/2026",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 169,
        "indicacao_id": 169,
        "raw_text": "Rua Expedicionários, nº 209",
        "street": "Rua Expedicionários",
        "number": "209",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 669,
          "indicacao_id": 169,
          "endereco_id": 169,
          "raw_address": "Rua Expedicionários, nº 209",
          "normalized_address": "Rua Expedicionários, nº 209 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56584,
          "longitude": -47.16092,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 669,
        "indicacao_id": 169,
        "latitude": -22.56584,
        "longitude": -47.16092,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 209",
        "normalized_address": "Rua Expedicionários, nº 209 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 169,
          "numero": 269,
          "ano": 2026,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Expedicionários, Jardim Conservani.",
          "autor": "Diana Dias",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 170,
    "sapl_id": 1170,
    "numero": 270,
    "ano": 2023,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Duque de Caxias, Centro.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "07/11/2023",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 170,
        "indicacao_id": 170,
        "raw_text": "Rua Duque de Caxias",
        "street": "Rua Duque de Caxias",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 670,
          "indicacao_id": 170,
          "endereco_id": 170,
          "raw_address": "Rua Duque de Caxias",
          "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
          "latitude": -22.57058,
          "longitude": -47.17544,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 670,
        "indicacao_id": 170,
        "latitude": -22.57058,
        "longitude": -47.17544,
        "is_approximate": true,
        "raw_address": "Rua Duque de Caxias",
        "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 170,
          "numero": 270,
          "ano": 2023,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Duque de Caxias, Centro.",
          "autor": "Eduardo Esteves",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 171,
    "sapl_id": 1171,
    "numero": 271,
    "ano": 2022,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Santo de Faveri, Jardim Sacilotto II.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "10/04/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 171,
        "indicacao_id": 171,
        "raw_text": "Rua Santo de Faveri, nº 231",
        "street": "Rua Santo de Faveri",
        "number": "231",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 671,
          "indicacao_id": 171,
          "endereco_id": 171,
          "raw_address": "Rua Santo de Faveri, nº 231",
          "normalized_address": "Rua Santo de Faveri, nº 231 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58124,
          "longitude": -47.17488,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 671,
        "indicacao_id": 171,
        "latitude": -22.58124,
        "longitude": -47.17488,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 231",
        "normalized_address": "Rua Santo de Faveri, nº 231 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 171,
          "numero": 271,
          "ano": 2022,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Santo de Faveri, Jardim Sacilotto II.",
          "autor": "Marina Ribeiro",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 172,
    "sapl_id": 1172,
    "numero": 272,
    "ano": 2021,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Bela Vista, Residencial Bela Vista.",
    "autor": "Helena Martins",
    "data_apresentacao": "13/09/2021",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 172,
        "indicacao_id": 172,
        "raw_text": "Rua Bela Vista, nº 242",
        "street": "Rua Bela Vista",
        "number": "242",
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 672,
          "indicacao_id": 172,
          "endereco_id": 172,
          "raw_address": "Rua Bela Vista, nº 242",
          "normalized_address": "Rua Bela Vista, nº 242 - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.56198,
          "longitude": -47.1729,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 672,
        "indicacao_id": 172,
        "latitude": -22.56198,
        "longitude": -47.1729,
        "is_approximate": false,
        "raw_address": "Rua Bela Vista, nº 242",
        "normalized_address": "Rua Bela Vista, nº 242 - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 172,
          "numero": 272,
          "ano": 2021,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Bela Vista, Residencial Bela Vista.",
          "autor": "Helena Martins",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 173,
    "sapl_id": 1173,
    "numero": 273,
    "ano": 2026,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Patricia Silva",
    "data_apresentacao": "16/02/2026",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 173,
        "indicacao_id": 173,
        "raw_text": "Rua Humberto Rossetti, nº 253",
        "street": "Rua Humberto Rossetti",
        "number": "253",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 673,
          "indicacao_id": 173,
          "endereco_id": 173,
          "raw_address": "Rua Humberto Rossetti, nº 253",
          "normalized_address": "Rua Humberto Rossetti, nº 253 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57764,
          "longitude": -47.16284,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 673,
        "indicacao_id": 173,
        "latitude": -22.57764,
        "longitude": -47.16284,
        "is_approximate": false,
        "raw_address": "Rua Humberto Rossetti, nº 253",
        "normalized_address": "Rua Humberto Rossetti, nº 253 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 173,
          "numero": 273,
          "ano": 2026,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Patricia Silva",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 174,
    "sapl_id": 1174,
    "numero": 274,
    "ano": 2023,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Blumenau, Jardim Blumenau.",
    "autor": "Bianca Barros",
    "data_apresentacao": "19/07/2023",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 174,
        "indicacao_id": 174,
        "raw_text": "Rua Blumenau, nº 264",
        "street": "Rua Blumenau",
        "number": "264",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 674,
          "indicacao_id": 174,
          "endereco_id": 174,
          "raw_address": "Rua Blumenau, nº 264",
          "normalized_address": "Rua Blumenau, nº 264 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.5733,
          "longitude": -47.18036,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 674,
        "indicacao_id": 174,
        "latitude": -22.5733,
        "longitude": -47.18036,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 264",
        "normalized_address": "Rua Blumenau, nº 264 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 174,
          "numero": 274,
          "ano": 2023,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Blumenau, Jardim Blumenau.",
          "autor": "Bianca Barros",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 175,
    "sapl_id": 1175,
    "numero": 275,
    "ano": 2022,
    "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Adhemar de Barros, Centro.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "22/12/2022",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 175,
        "indicacao_id": 175,
        "raw_text": "Rua Adhemar de Barros",
        "street": "Rua Adhemar de Barros",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 675,
          "indicacao_id": 175,
          "endereco_id": 175,
          "raw_address": "Rua Adhemar de Barros",
          "normalized_address": "Rua Adhemar de Barros - Centro, Artur Nogueira - SP",
          "latitude": -22.57554,
          "longitude": -47.1683,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 675,
        "indicacao_id": 175,
        "latitude": -22.57554,
        "longitude": -47.1683,
        "is_approximate": true,
        "raw_address": "Rua Adhemar de Barros",
        "normalized_address": "Rua Adhemar de Barros - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 175,
          "numero": 275,
          "ano": 2022,
          "ementa": "Solicita substituição de luminárias convencionais por tecnologia LED na Rua Adhemar de Barros, Centro.",
          "autor": "Igor Nascimento",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 176,
    "sapl_id": 1176,
    "numero": 276,
    "ano": 2021,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "25/05/2021",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 176,
        "indicacao_id": 176,
        "raw_text": "Rua Humberto Rossetti, nº 286",
        "street": "Rua Humberto Rossetti",
        "number": "286",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 676,
          "indicacao_id": 176,
          "endereco_id": 176,
          "raw_address": "Rua Humberto Rossetti, nº 286",
          "normalized_address": "Rua Humberto Rossetti, nº 286 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.5762,
          "longitude": -47.16482,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 676,
        "indicacao_id": 176,
        "latitude": -22.5762,
        "longitude": -47.16482,
        "is_approximate": false,
        "raw_address": "Rua Humberto Rossetti, nº 286",
        "normalized_address": "Rua Humberto Rossetti, nº 286 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 176,
          "numero": 276,
          "ano": 2021,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Gabriel Gomes",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 177,
    "sapl_id": 1177,
    "numero": 277,
    "ano": 2026,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Blumenau, Jardim Blumenau.",
    "autor": "Leandro Prado",
    "data_apresentacao": "28/10/2026",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 177,
        "indicacao_id": 177,
        "raw_text": "Rua Blumenau, nº 297",
        "street": "Rua Blumenau",
        "number": "297",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 677,
          "indicacao_id": 177,
          "endereco_id": 177,
          "raw_address": "Rua Blumenau, nº 297",
          "normalized_address": "Rua Blumenau, nº 297 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57744,
          "longitude": -47.18234,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 677,
        "indicacao_id": 177,
        "latitude": -22.57744,
        "longitude": -47.18234,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 297",
        "normalized_address": "Rua Blumenau, nº 297 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 177,
          "numero": 277,
          "ano": 2026,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Blumenau, Jardim Blumenau.",
          "autor": "Leandro Prado",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 178,
    "sapl_id": 1178,
    "numero": 278,
    "ano": 2023,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Adhemar de Barros, Centro.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "03/03/2023",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 178,
        "indicacao_id": 178,
        "raw_text": "Rua Adhemar de Barros, nº 308",
        "street": "Rua Adhemar de Barros",
        "number": "308",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 678,
          "indicacao_id": 178,
          "endereco_id": 178,
          "raw_address": "Rua Adhemar de Barros, nº 308",
          "normalized_address": "Rua Adhemar de Barros, nº 308 - Centro, Artur Nogueira - SP",
          "latitude": -22.5741,
          "longitude": -47.17028,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 678,
        "indicacao_id": 178,
        "latitude": -22.5741,
        "longitude": -47.17028,
        "is_approximate": false,
        "raw_address": "Rua Adhemar de Barros, nº 308",
        "normalized_address": "Rua Adhemar de Barros, nº 308 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 178,
          "numero": 278,
          "ano": 2023,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Adhemar de Barros, Centro.",
          "autor": "Nicolas Rocha",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 179,
    "sapl_id": 1179,
    "numero": 279,
    "ano": 2022,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Antônio Tagliari, Coração Criança.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "06/08/2022",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 179,
        "indicacao_id": 179,
        "raw_text": "Rua Antônio Tagliari, nº 319",
        "street": "Rua Antônio Tagliari",
        "number": "319",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 679,
          "indicacao_id": 179,
          "endereco_id": 179,
          "raw_address": "Rua Antônio Tagliari, nº 319",
          "normalized_address": "Rua Antônio Tagliari, nº 319 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56434,
          "longitude": -47.1798,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 679,
        "indicacao_id": 179,
        "latitude": -22.56434,
        "longitude": -47.1798,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 319",
        "normalized_address": "Rua Antônio Tagliari, nº 319 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 179,
          "numero": 279,
          "ano": 2022,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Antônio Tagliari, Coração Criança.",
          "autor": "Rafael Teixeira",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 180,
    "sapl_id": 1180,
    "numero": 280,
    "ano": 2021,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Avenida Fernando Arens, Centro.",
    "autor": "Caio Campos",
    "data_apresentacao": "09/01/2021",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 180,
        "indicacao_id": 180,
        "raw_text": "Avenida Fernando Arens",
        "street": "Avenida Fernando Arens",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 680,
          "indicacao_id": 180,
          "endereco_id": 180,
          "raw_address": "Avenida Fernando Arens",
          "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
          "latitude": -22.5714,
          "longitude": -47.17154,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 680,
        "indicacao_id": 180,
        "latitude": -22.5714,
        "longitude": -47.17154,
        "is_approximate": true,
        "raw_address": "Avenida Fernando Arens",
        "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 180,
          "numero": 280,
          "ano": 2021,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Avenida Fernando Arens, Centro.",
          "autor": "Caio Campos",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 181,
    "sapl_id": 1181,
    "numero": 281,
    "ano": 2026,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Av. Dr. Roberto Silva, Parque das Flores.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "12/06/2026",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 181,
        "indicacao_id": 181,
        "raw_text": "Av. Dr. Roberto Silva, nº 341",
        "street": "Av. Dr. Roberto Silva",
        "number": "341",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 681,
          "indicacao_id": 181,
          "endereco_id": 181,
          "raw_address": "Av. Dr. Roberto Silva, nº 341",
          "normalized_address": "Av. Dr. Roberto Silva, nº 341 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57466,
          "longitude": -47.16726,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 681,
        "indicacao_id": 181,
        "latitude": -22.57466,
        "longitude": -47.16726,
        "is_approximate": false,
        "raw_address": "Av. Dr. Roberto Silva, nº 341",
        "normalized_address": "Av. Dr. Roberto Silva, nº 341 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 181,
          "numero": 281,
          "ano": 2026,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Av. Dr. Roberto Silva, Parque das Flores.",
          "autor": "Marina Ribeiro",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 182,
    "sapl_id": 1182,
    "numero": 282,
    "ano": 2023,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Itamaraty, Jardim Itamaraty.",
    "autor": "Alex Andrade",
    "data_apresentacao": "15/11/2023",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 182,
        "indicacao_id": 182,
        "raw_text": "Rua Itamaraty, nº 352",
        "street": "Rua Itamaraty",
        "number": "352",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 682,
          "indicacao_id": 182,
          "endereco_id": 182,
          "raw_address": "Rua Itamaraty, nº 352",
          "normalized_address": "Rua Itamaraty, nº 352 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5839,
          "longitude": -47.1672,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 682,
        "indicacao_id": 182,
        "latitude": -22.5839,
        "longitude": -47.1672,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 352",
        "normalized_address": "Rua Itamaraty, nº 352 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 182,
          "numero": 282,
          "ano": 2023,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Itamaraty, Jardim Itamaraty.",
          "autor": "Alex Andrade",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 183,
    "sapl_id": 1183,
    "numero": 283,
    "ano": 2022,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua das Margaridas, Jardim Planalto.",
    "autor": "Bianca Barros",
    "data_apresentacao": "18/04/2022",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 183,
        "indicacao_id": 183,
        "raw_text": "Rua das Margaridas, nº 363",
        "street": "Rua das Margaridas",
        "number": "363",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 683,
          "indicacao_id": 183,
          "endereco_id": 183,
          "raw_address": "Rua das Margaridas, nº 363",
          "normalized_address": "Rua das Margaridas, nº 363 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56256,
          "longitude": -47.17022,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 683,
        "indicacao_id": 183,
        "latitude": -22.56256,
        "longitude": -47.17022,
        "is_approximate": false,
        "raw_address": "Rua das Margaridas, nº 363",
        "normalized_address": "Rua das Margaridas, nº 363 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 183,
          "numero": 283,
          "ano": 2022,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua das Margaridas, Jardim Planalto.",
          "autor": "Bianca Barros",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 184,
    "sapl_id": 1184,
    "numero": 284,
    "ano": 2021,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Expedicionários, Jardim Conservani.",
    "autor": "Helena Martins",
    "data_apresentacao": "21/09/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 184,
        "indicacao_id": 184,
        "raw_text": "Rua Expedicionários, nº 374",
        "street": "Rua Expedicionários",
        "number": "374",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 684,
          "indicacao_id": 184,
          "endereco_id": 184,
          "raw_address": "Rua Expedicionários, nº 374",
          "normalized_address": "Rua Expedicionários, nº 374 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.5698,
          "longitude": -47.15966,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 684,
        "indicacao_id": 184,
        "latitude": -22.5698,
        "longitude": -47.15966,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 374",
        "normalized_address": "Rua Expedicionários, nº 374 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 184,
          "numero": 284,
          "ano": 2021,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Expedicionários, Jardim Conservani.",
          "autor": "Helena Martins",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 185,
    "sapl_id": 1185,
    "numero": 285,
    "ano": 2026,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Duque de Caxias, Centro.",
    "autor": "Patricia Silva",
    "data_apresentacao": "24/02/2026",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 185,
        "indicacao_id": 185,
        "raw_text": "Rua Duque de Caxias",
        "street": "Rua Duque de Caxias",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 685,
          "indicacao_id": 185,
          "endereco_id": 185,
          "raw_address": "Rua Duque de Caxias",
          "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
          "latitude": -22.56896,
          "longitude": -47.17418,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 685,
        "indicacao_id": 185,
        "latitude": -22.56896,
        "longitude": -47.17418,
        "is_approximate": true,
        "raw_address": "Rua Duque de Caxias",
        "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 185,
          "numero": 285,
          "ano": 2026,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Duque de Caxias, Centro.",
          "autor": "Patricia Silva",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 186,
    "sapl_id": 1186,
    "numero": 286,
    "ano": 2023,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Santo de Faveri, Jardim Sacilotto II.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "27/07/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 186,
        "indicacao_id": 186,
        "raw_text": "Rua Santo de Faveri, nº 396",
        "street": "Rua Santo de Faveri",
        "number": "396",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 686,
          "indicacao_id": 186,
          "endereco_id": 186,
          "raw_address": "Rua Santo de Faveri, nº 396",
          "normalized_address": "Rua Santo de Faveri, nº 396 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5852,
          "longitude": -47.1792,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 686,
        "indicacao_id": 186,
        "latitude": -22.5852,
        "longitude": -47.1792,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 396",
        "normalized_address": "Rua Santo de Faveri, nº 396 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 186,
          "numero": 286,
          "ano": 2023,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Santo de Faveri, Jardim Sacilotto II.",
          "autor": "Eduardo Esteves",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 187,
    "sapl_id": 1187,
    "numero": 287,
    "ano": 2022,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Bela Vista, Residencial Bela Vista.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "02/12/2022",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 187,
        "indicacao_id": 187,
        "raw_text": "Rua Bela Vista, nº 407",
        "street": "Rua Bela Vista",
        "number": "407",
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 687,
          "indicacao_id": 187,
          "endereco_id": 187,
          "raw_address": "Rua Bela Vista, nº 407",
          "normalized_address": "Rua Bela Vista, nº 407 - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.56036,
          "longitude": -47.17164,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 687,
        "indicacao_id": 187,
        "latitude": -22.56036,
        "longitude": -47.17164,
        "is_approximate": false,
        "raw_address": "Rua Bela Vista, nº 407",
        "normalized_address": "Rua Bela Vista, nº 407 - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 187,
          "numero": 287,
          "ano": 2022,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Bela Vista, Residencial Bela Vista.",
          "autor": "Igor Nascimento",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 188,
    "sapl_id": 1188,
    "numero": 288,
    "ano": 2021,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Diana Dias",
    "data_apresentacao": "05/05/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 188,
        "indicacao_id": 188,
        "raw_text": "Rua Humberto Rossetti, nº 418",
        "street": "Rua Humberto Rossetti",
        "number": "418",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 688,
          "indicacao_id": 188,
          "endereco_id": 188,
          "raw_address": "Rua Humberto Rossetti, nº 418",
          "normalized_address": "Rua Humberto Rossetti, nº 418 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57602,
          "longitude": -47.16716,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 688,
        "indicacao_id": 188,
        "latitude": -22.57602,
        "longitude": -47.16716,
        "is_approximate": false,
        "raw_address": "Rua Humberto Rossetti, nº 418",
        "normalized_address": "Rua Humberto Rossetti, nº 418 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 188,
          "numero": 288,
          "ano": 2021,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Diana Dias",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 189,
    "sapl_id": 1189,
    "numero": 289,
    "ano": 2026,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Blumenau, Jardim Blumenau.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "08/10/2026",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 189,
        "indicacao_id": 189,
        "raw_text": "Rua Blumenau, nº 429",
        "street": "Rua Blumenau",
        "number": "429",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 689,
          "indicacao_id": 189,
          "endereco_id": 189,
          "raw_address": "Rua Blumenau, nº 429",
          "normalized_address": "Rua Blumenau, nº 429 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57726,
          "longitude": -47.1791,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 689,
        "indicacao_id": 189,
        "latitude": -22.57726,
        "longitude": -47.1791,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 429",
        "normalized_address": "Rua Blumenau, nº 429 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 189,
          "numero": 289,
          "ano": 2026,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Blumenau, Jardim Blumenau.",
          "autor": "Fernanda Freitas",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 190,
    "sapl_id": 1190,
    "numero": 290,
    "ano": 2023,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Adhemar de Barros, Centro.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "11/03/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 190,
        "indicacao_id": 190,
        "raw_text": "Rua Adhemar de Barros",
        "street": "Rua Adhemar de Barros",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 690,
          "indicacao_id": 190,
          "endereco_id": 190,
          "raw_address": "Rua Adhemar de Barros",
          "normalized_address": "Rua Adhemar de Barros - Centro, Artur Nogueira - SP",
          "latitude": -22.57392,
          "longitude": -47.17262,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 690,
        "indicacao_id": 190,
        "latitude": -22.57392,
        "longitude": -47.17262,
        "is_approximate": true,
        "raw_address": "Rua Adhemar de Barros",
        "normalized_address": "Rua Adhemar de Barros - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 190,
          "numero": 290,
          "ano": 2023,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Adhemar de Barros, Centro.",
          "autor": "Julia Oliveira",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 191,
    "sapl_id": 1191,
    "numero": 291,
    "ano": 2022,
    "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Antônio Tagliari, Coração Criança.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "14/08/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 191,
        "indicacao_id": 191,
        "raw_text": "Rua Antônio Tagliari, nº 451",
        "street": "Rua Antônio Tagliari",
        "number": "451",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 691,
          "indicacao_id": 191,
          "endereco_id": 191,
          "raw_address": "Rua Antônio Tagliari, nº 451",
          "normalized_address": "Rua Antônio Tagliari, nº 451 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56416,
          "longitude": -47.17656,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 691,
        "indicacao_id": 191,
        "latitude": -22.56416,
        "longitude": -47.17656,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 451",
        "normalized_address": "Rua Antônio Tagliari, nº 451 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 191,
          "numero": 291,
          "ano": 2022,
          "ementa": "Indica desobstrução e manutenção na rede de drenagem de águas pluviais na Rua Antônio Tagliari, Coração Criança.",
          "autor": "Nicolas Rocha",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 192,
    "sapl_id": 1192,
    "numero": 292,
    "ano": 2021,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Avenida Fernando Arens, Centro.",
    "autor": "Caio Campos",
    "data_apresentacao": "17/01/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 192,
        "indicacao_id": 192,
        "raw_text": "Avenida Fernando Arens, nº 462",
        "street": "Avenida Fernando Arens",
        "number": "462",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 692,
          "indicacao_id": 192,
          "endereco_id": 192,
          "raw_address": "Avenida Fernando Arens, nº 462",
          "normalized_address": "Avenida Fernando Arens, nº 462 - Centro, Artur Nogueira - SP",
          "latitude": -22.57122,
          "longitude": -47.17388,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 692,
        "indicacao_id": 192,
        "latitude": -22.57122,
        "longitude": -47.17388,
        "is_approximate": false,
        "raw_address": "Avenida Fernando Arens, nº 462",
        "normalized_address": "Avenida Fernando Arens, nº 462 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 192,
          "numero": 292,
          "ano": 2021,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Avenida Fernando Arens, Centro.",
          "autor": "Caio Campos",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 193,
    "sapl_id": 1193,
    "numero": 293,
    "ano": 2026,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Av. Dr. Roberto Silva, Parque das Flores.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "20/06/2026",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 193,
        "indicacao_id": 193,
        "raw_text": "Av. Dr. Roberto Silva, nº 473",
        "street": "Av. Dr. Roberto Silva",
        "number": "473",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 693,
          "indicacao_id": 193,
          "endereco_id": 193,
          "raw_address": "Av. Dr. Roberto Silva, nº 473",
          "normalized_address": "Av. Dr. Roberto Silva, nº 473 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57448,
          "longitude": -47.16402,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 693,
        "indicacao_id": 193,
        "latitude": -22.57448,
        "longitude": -47.16402,
        "is_approximate": false,
        "raw_address": "Av. Dr. Roberto Silva, nº 473",
        "normalized_address": "Av. Dr. Roberto Silva, nº 473 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 193,
          "numero": 293,
          "ano": 2026,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Av. Dr. Roberto Silva, Parque das Flores.",
          "autor": "Fernanda Freitas",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 194,
    "sapl_id": 1194,
    "numero": 294,
    "ano": 2023,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Itamaraty, Jardim Itamaraty.",
    "autor": "Patricia Silva",
    "data_apresentacao": "23/11/2023",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 194,
        "indicacao_id": 194,
        "raw_text": "Rua Itamaraty, nº 484",
        "street": "Rua Itamaraty",
        "number": "484",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 694,
          "indicacao_id": 194,
          "endereco_id": 194,
          "raw_address": "Rua Itamaraty, nº 484",
          "normalized_address": "Rua Itamaraty, nº 484 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58372,
          "longitude": -47.16954,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 694,
        "indicacao_id": 194,
        "latitude": -22.58372,
        "longitude": -47.16954,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 484",
        "normalized_address": "Rua Itamaraty, nº 484 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 194,
          "numero": 294,
          "ano": 2023,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Itamaraty, Jardim Itamaraty.",
          "autor": "Patricia Silva",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 195,
    "sapl_id": 1195,
    "numero": 295,
    "ano": 2022,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua das Margaridas, Jardim Planalto.",
    "autor": "Diana Dias",
    "data_apresentacao": "26/04/2022",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 195,
        "indicacao_id": 195,
        "raw_text": "Rua das Margaridas",
        "street": "Rua das Margaridas",
        "number": null,
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 695,
          "indicacao_id": 195,
          "endereco_id": 195,
          "raw_address": "Rua das Margaridas",
          "normalized_address": "Rua das Margaridas - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56238,
          "longitude": -47.16698,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 695,
        "indicacao_id": 195,
        "latitude": -22.56238,
        "longitude": -47.16698,
        "is_approximate": true,
        "raw_address": "Rua das Margaridas",
        "normalized_address": "Rua das Margaridas - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 195,
          "numero": 295,
          "ano": 2022,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua das Margaridas, Jardim Planalto.",
          "autor": "Diana Dias",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 196,
    "sapl_id": 1196,
    "numero": 296,
    "ano": 2021,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Expedicionários, Jardim Conservani.",
    "autor": "Alex Andrade",
    "data_apresentacao": "01/09/2021",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 196,
        "indicacao_id": 196,
        "raw_text": "Rua Expedicionários, nº 506",
        "street": "Rua Expedicionários",
        "number": "506",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 696,
          "indicacao_id": 196,
          "endereco_id": 196,
          "raw_address": "Rua Expedicionários, nº 506",
          "normalized_address": "Rua Expedicionários, nº 506 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56962,
          "longitude": -47.162,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 696,
        "indicacao_id": 196,
        "latitude": -22.56962,
        "longitude": -47.162,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 506",
        "normalized_address": "Rua Expedicionários, nº 506 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 196,
          "numero": 296,
          "ano": 2021,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Expedicionários, Jardim Conservani.",
          "autor": "Alex Andrade",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 197,
    "sapl_id": 1197,
    "numero": 297,
    "ano": 2026,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Duque de Caxias, Centro.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "04/02/2026",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 197,
        "indicacao_id": 197,
        "raw_text": "Rua Duque de Caxias, nº 517",
        "street": "Rua Duque de Caxias",
        "number": "517",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 697,
          "indicacao_id": 197,
          "endereco_id": 197,
          "raw_address": "Rua Duque de Caxias, nº 517",
          "normalized_address": "Rua Duque de Caxias, nº 517 - Centro, Artur Nogueira - SP",
          "latitude": -22.56878,
          "longitude": -47.17652,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 697,
        "indicacao_id": 197,
        "latitude": -22.56878,
        "longitude": -47.17652,
        "is_approximate": false,
        "raw_address": "Rua Duque de Caxias, nº 517",
        "normalized_address": "Rua Duque de Caxias, nº 517 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 197,
          "numero": 297,
          "ano": 2026,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Duque de Caxias, Centro.",
          "autor": "Eduardo Esteves",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 198,
    "sapl_id": 1198,
    "numero": 298,
    "ano": 2023,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Santo de Faveri, Jardim Sacilotto II.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "07/07/2023",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 198,
        "indicacao_id": 198,
        "raw_text": "Rua Santo de Faveri, nº 528",
        "street": "Rua Santo de Faveri",
        "number": "528",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 698,
          "indicacao_id": 198,
          "endereco_id": 198,
          "raw_address": "Rua Santo de Faveri, nº 528",
          "normalized_address": "Rua Santo de Faveri, nº 528 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58502,
          "longitude": -47.17596,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 698,
        "indicacao_id": 198,
        "latitude": -22.58502,
        "longitude": -47.17596,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 528",
        "normalized_address": "Rua Santo de Faveri, nº 528 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 198,
          "numero": 298,
          "ano": 2023,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Santo de Faveri, Jardim Sacilotto II.",
          "autor": "Igor Nascimento",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 199,
    "sapl_id": 1199,
    "numero": 299,
    "ano": 2022,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Bela Vista, Residencial Bela Vista.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "10/12/2022",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 199,
        "indicacao_id": 199,
        "raw_text": "Rua Bela Vista, nº 539",
        "street": "Rua Bela Vista",
        "number": "539",
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 699,
          "indicacao_id": 199,
          "endereco_id": 199,
          "raw_address": "Rua Bela Vista, nº 539",
          "normalized_address": "Rua Bela Vista, nº 539 - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.56018,
          "longitude": -47.17398,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 699,
        "indicacao_id": 199,
        "latitude": -22.56018,
        "longitude": -47.17398,
        "is_approximate": false,
        "raw_address": "Rua Bela Vista, nº 539",
        "normalized_address": "Rua Bela Vista, nº 539 - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 199,
          "numero": 299,
          "ano": 2022,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Bela Vista, Residencial Bela Vista.",
          "autor": "Marina Ribeiro",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 200,
    "sapl_id": 1200,
    "numero": 300,
    "ano": 2021,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Helena Martins",
    "data_apresentacao": "13/05/2021",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 200,
        "indicacao_id": 200,
        "raw_text": "Rua Humberto Rossetti",
        "street": "Rua Humberto Rossetti",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 700,
          "indicacao_id": 200,
          "endereco_id": 200,
          "raw_address": "Rua Humberto Rossetti",
          "normalized_address": "Rua Humberto Rossetti - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57584,
          "longitude": -47.16392,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 700,
        "indicacao_id": 200,
        "latitude": -22.57584,
        "longitude": -47.16392,
        "is_approximate": true,
        "raw_address": "Rua Humberto Rossetti",
        "normalized_address": "Rua Humberto Rossetti - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 200,
          "numero": 300,
          "ano": 2021,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Helena Martins",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 201,
    "sapl_id": 1201,
    "numero": 301,
    "ano": 2024,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Blumenau, Jardim Blumenau.",
    "autor": "Bianca Barros",
    "data_apresentacao": "16/10/2024",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 201,
        "indicacao_id": 201,
        "raw_text": "Rua Blumenau, nº 561",
        "street": "Rua Blumenau",
        "number": "561",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 701,
          "indicacao_id": 201,
          "endereco_id": 201,
          "raw_address": "Rua Blumenau, nº 561",
          "normalized_address": "Rua Blumenau, nº 561 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57708,
          "longitude": -47.18144,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 701,
        "indicacao_id": 201,
        "latitude": -22.57708,
        "longitude": -47.18144,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 561",
        "normalized_address": "Rua Blumenau, nº 561 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 201,
          "numero": 301,
          "ano": 2024,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Blumenau, Jardim Blumenau.",
          "autor": "Bianca Barros",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 202,
    "sapl_id": 1202,
    "numero": 302,
    "ano": 2023,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Adhemar de Barros, Centro.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "19/03/2023",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 202,
        "indicacao_id": 202,
        "raw_text": "Rua Adhemar de Barros, nº 572",
        "street": "Rua Adhemar de Barros",
        "number": "572",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 702,
          "indicacao_id": 202,
          "endereco_id": 202,
          "raw_address": "Rua Adhemar de Barros, nº 572",
          "normalized_address": "Rua Adhemar de Barros, nº 572 - Centro, Artur Nogueira - SP",
          "latitude": -22.57374,
          "longitude": -47.16938,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 702,
        "indicacao_id": 202,
        "latitude": -22.57374,
        "longitude": -47.16938,
        "is_approximate": false,
        "raw_address": "Rua Adhemar de Barros, nº 572",
        "normalized_address": "Rua Adhemar de Barros, nº 572 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 202,
          "numero": 302,
          "ano": 2023,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Adhemar de Barros, Centro.",
          "autor": "Rafael Teixeira",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 203,
    "sapl_id": 1203,
    "numero": 303,
    "ano": 2022,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Antônio Tagliari, Coração Criança.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "22/08/2022",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 203,
        "indicacao_id": 203,
        "raw_text": "Rua Antônio Tagliari, nº 583",
        "street": "Rua Antônio Tagliari",
        "number": "583",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 703,
          "indicacao_id": 203,
          "endereco_id": 203,
          "raw_address": "Rua Antônio Tagliari, nº 583",
          "normalized_address": "Rua Antônio Tagliari, nº 583 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56398,
          "longitude": -47.1789,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 703,
        "indicacao_id": 203,
        "latitude": -22.56398,
        "longitude": -47.1789,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 583",
        "normalized_address": "Rua Antônio Tagliari, nº 583 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 203,
          "numero": 303,
          "ano": 2022,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Antônio Tagliari, Coração Criança.",
          "autor": "Gabriel Gomes",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 204,
    "sapl_id": 1204,
    "numero": 304,
    "ano": 2021,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Avenida Fernando Arens, Centro.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "25/01/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 204,
        "indicacao_id": 204,
        "raw_text": "Avenida Fernando Arens, nº 594",
        "street": "Avenida Fernando Arens",
        "number": "594",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 704,
          "indicacao_id": 204,
          "endereco_id": 204,
          "raw_address": "Avenida Fernando Arens, nº 594",
          "normalized_address": "Avenida Fernando Arens, nº 594 - Centro, Artur Nogueira - SP",
          "latitude": -22.57104,
          "longitude": -47.17064,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 704,
        "indicacao_id": 204,
        "latitude": -22.57104,
        "longitude": -47.17064,
        "is_approximate": false,
        "raw_address": "Avenida Fernando Arens, nº 594",
        "normalized_address": "Avenida Fernando Arens, nº 594 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 204,
          "numero": 304,
          "ano": 2021,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Avenida Fernando Arens, Centro.",
          "autor": "Julia Oliveira",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 205,
    "sapl_id": 1205,
    "numero": 305,
    "ano": 2024,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Av. Dr. Roberto Silva, Parque das Flores.",
    "autor": "Leandro Prado",
    "data_apresentacao": "28/06/2024",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 205,
        "indicacao_id": 205,
        "raw_text": "Av. Dr. Roberto Silva",
        "street": "Av. Dr. Roberto Silva",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 705,
          "indicacao_id": 205,
          "endereco_id": 205,
          "raw_address": "Av. Dr. Roberto Silva",
          "normalized_address": "Av. Dr. Roberto Silva - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.5743,
          "longitude": -47.16636,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 705,
        "indicacao_id": 205,
        "latitude": -22.5743,
        "longitude": -47.16636,
        "is_approximate": true,
        "raw_address": "Av. Dr. Roberto Silva",
        "normalized_address": "Av. Dr. Roberto Silva - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 205,
          "numero": 305,
          "ano": 2024,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Av. Dr. Roberto Silva, Parque das Flores.",
          "autor": "Leandro Prado",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 206,
    "sapl_id": 1206,
    "numero": 306,
    "ano": 2023,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Itamaraty, Jardim Itamaraty.",
    "autor": "Leandro Prado",
    "data_apresentacao": "03/11/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 206,
        "indicacao_id": 206,
        "raw_text": "Rua Itamaraty, nº 616",
        "street": "Rua Itamaraty",
        "number": "616",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 706,
          "indicacao_id": 206,
          "endereco_id": 206,
          "raw_address": "Rua Itamaraty, nº 616",
          "normalized_address": "Rua Itamaraty, nº 616 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58354,
          "longitude": -47.1663,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 706,
        "indicacao_id": 206,
        "latitude": -22.58354,
        "longitude": -47.1663,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 616",
        "normalized_address": "Rua Itamaraty, nº 616 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 206,
          "numero": 306,
          "ano": 2023,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Itamaraty, Jardim Itamaraty.",
          "autor": "Leandro Prado",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 207,
    "sapl_id": 1207,
    "numero": 307,
    "ano": 2022,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua das Margaridas, Jardim Planalto.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "06/04/2022",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 207,
        "indicacao_id": 207,
        "raw_text": "Rua das Margaridas, nº 627",
        "street": "Rua das Margaridas",
        "number": "627",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 707,
          "indicacao_id": 207,
          "endereco_id": 207,
          "raw_address": "Rua das Margaridas, nº 627",
          "normalized_address": "Rua das Margaridas, nº 627 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5622,
          "longitude": -47.16932,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 707,
        "indicacao_id": 207,
        "latitude": -22.5622,
        "longitude": -47.16932,
        "is_approximate": false,
        "raw_address": "Rua das Margaridas, nº 627",
        "normalized_address": "Rua das Margaridas, nº 627 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 207,
          "numero": 307,
          "ano": 2022,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua das Margaridas, Jardim Planalto.",
          "autor": "Eduardo Esteves",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 208,
    "sapl_id": 1208,
    "numero": 308,
    "ano": 2021,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Expedicionários, Jardim Conservani.",
    "autor": "Caio Campos",
    "data_apresentacao": "09/09/2021",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 208,
        "indicacao_id": 208,
        "raw_text": "Rua Expedicionários, nº 638",
        "street": "Rua Expedicionários",
        "number": "638",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 708,
          "indicacao_id": 208,
          "endereco_id": 208,
          "raw_address": "Rua Expedicionários, nº 638",
          "normalized_address": "Rua Expedicionários, nº 638 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56944,
          "longitude": -47.16434,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 708,
        "indicacao_id": 208,
        "latitude": -22.56944,
        "longitude": -47.16434,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 638",
        "normalized_address": "Rua Expedicionários, nº 638 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 208,
          "numero": 308,
          "ano": 2021,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Expedicionários, Jardim Conservani.",
          "autor": "Caio Campos",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 209,
    "sapl_id": 1209,
    "numero": 309,
    "ano": 2024,
    "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Duque de Caxias, Centro.",
    "autor": "Helena Martins",
    "data_apresentacao": "12/02/2024",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 209,
        "indicacao_id": 209,
        "raw_text": "Rua Duque de Caxias, nº 649",
        "street": "Rua Duque de Caxias",
        "number": "649",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 709,
          "indicacao_id": 209,
          "endereco_id": 209,
          "raw_address": "Rua Duque de Caxias, nº 649",
          "normalized_address": "Rua Duque de Caxias, nº 649 - Centro, Artur Nogueira - SP",
          "latitude": -22.5686,
          "longitude": -47.17328,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 709,
        "indicacao_id": 209,
        "latitude": -22.5686,
        "longitude": -47.17328,
        "is_approximate": false,
        "raw_address": "Rua Duque de Caxias, nº 649",
        "normalized_address": "Rua Duque de Caxias, nº 649 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 209,
          "numero": 309,
          "ano": 2024,
          "ementa": "Solicita serviços de roçagem, capina e limpeza de canteiros públicos na Rua Duque de Caxias, Centro.",
          "autor": "Helena Martins",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 210,
    "sapl_id": 1210,
    "numero": 310,
    "ano": 2023,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua das Margaridas, Jardim Planalto.",
    "autor": "Diana Dias",
    "data_apresentacao": "15/07/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 210,
        "indicacao_id": 210,
        "raw_text": "Rua das Margaridas",
        "street": "Rua das Margaridas",
        "number": null,
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 710,
          "indicacao_id": 210,
          "endereco_id": 210,
          "raw_address": "Rua das Margaridas",
          "normalized_address": "Rua das Margaridas - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56634,
          "longitude": -47.1713,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 710,
        "indicacao_id": 210,
        "latitude": -22.56634,
        "longitude": -47.1713,
        "is_approximate": true,
        "raw_address": "Rua das Margaridas",
        "normalized_address": "Rua das Margaridas - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 210,
          "numero": 310,
          "ano": 2023,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua das Margaridas, Jardim Planalto.",
          "autor": "Diana Dias",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 211,
    "sapl_id": 1211,
    "numero": 311,
    "ano": 2022,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Expedicionários, Jardim Conservani.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "18/12/2022",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 211,
        "indicacao_id": 211,
        "raw_text": "Rua Expedicionários, nº 671",
        "street": "Rua Expedicionários",
        "number": "671",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 711,
          "indicacao_id": 211,
          "endereco_id": 211,
          "raw_address": "Rua Expedicionários, nº 671",
          "normalized_address": "Rua Expedicionários, nº 671 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.568,
          "longitude": -47.16074,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 711,
        "indicacao_id": 211,
        "latitude": -22.568,
        "longitude": -47.16074,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 671",
        "normalized_address": "Rua Expedicionários, nº 671 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 211,
          "numero": 311,
          "ano": 2022,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Expedicionários, Jardim Conservani.",
          "autor": "Gabriel Gomes",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 212,
    "sapl_id": 1212,
    "numero": 312,
    "ano": 2021,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Duque de Caxias, Centro.",
    "autor": "Alex Andrade",
    "data_apresentacao": "21/05/2021",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 212,
        "indicacao_id": 212,
        "raw_text": "Rua Duque de Caxias, nº 682",
        "street": "Rua Duque de Caxias",
        "number": "682",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 712,
          "indicacao_id": 212,
          "endereco_id": 212,
          "raw_address": "Rua Duque de Caxias, nº 682",
          "normalized_address": "Rua Duque de Caxias, nº 682 - Centro, Artur Nogueira - SP",
          "latitude": -22.56716,
          "longitude": -47.17526,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 712,
        "indicacao_id": 212,
        "latitude": -22.56716,
        "longitude": -47.17526,
        "is_approximate": false,
        "raw_address": "Rua Duque de Caxias, nº 682",
        "normalized_address": "Rua Duque de Caxias, nº 682 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 212,
          "numero": 312,
          "ano": 2021,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Duque de Caxias, Centro.",
          "autor": "Alex Andrade",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 213,
    "sapl_id": 1213,
    "numero": 313,
    "ano": 2024,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Santo de Faveri, Jardim Sacilotto II.",
    "autor": "Bianca Barros",
    "data_apresentacao": "24/10/2024",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 213,
        "indicacao_id": 213,
        "raw_text": "Rua Santo de Faveri, nº 693",
        "street": "Rua Santo de Faveri",
        "number": "693",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 713,
          "indicacao_id": 213,
          "endereco_id": 213,
          "raw_address": "Rua Santo de Faveri, nº 693",
          "normalized_address": "Rua Santo de Faveri, nº 693 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5834,
          "longitude": -47.1747,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 713,
        "indicacao_id": 213,
        "latitude": -22.5834,
        "longitude": -47.1747,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 693",
        "normalized_address": "Rua Santo de Faveri, nº 693 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 213,
          "numero": 313,
          "ano": 2024,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Santo de Faveri, Jardim Sacilotto II.",
          "autor": "Bianca Barros",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 214,
    "sapl_id": 1214,
    "numero": 314,
    "ano": 2023,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Bela Vista, Residencial Bela Vista.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "27/03/2023",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 214,
        "indicacao_id": 214,
        "raw_text": "Rua Bela Vista, nº 704",
        "street": "Rua Bela Vista",
        "number": "704",
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 714,
          "indicacao_id": 214,
          "endereco_id": 214,
          "raw_address": "Rua Bela Vista, nº 704",
          "normalized_address": "Rua Bela Vista, nº 704 - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.55856,
          "longitude": -47.17272,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 714,
        "indicacao_id": 214,
        "latitude": -22.55856,
        "longitude": -47.17272,
        "is_approximate": false,
        "raw_address": "Rua Bela Vista, nº 704",
        "normalized_address": "Rua Bela Vista, nº 704 - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 214,
          "numero": 314,
          "ano": 2023,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Bela Vista, Residencial Bela Vista.",
          "autor": "Fernanda Freitas",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 215,
    "sapl_id": 1215,
    "numero": 315,
    "ano": 2022,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Humberto Rossetti, Parque das Flores.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "02/08/2022",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 215,
        "indicacao_id": 215,
        "raw_text": "Rua Humberto Rossetti",
        "street": "Rua Humberto Rossetti",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 715,
          "indicacao_id": 215,
          "endereco_id": 215,
          "raw_address": "Rua Humberto Rossetti",
          "normalized_address": "Rua Humberto Rossetti - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.5798,
          "longitude": -47.16266,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 715,
        "indicacao_id": 215,
        "latitude": -22.5798,
        "longitude": -47.16266,
        "is_approximate": true,
        "raw_address": "Rua Humberto Rossetti",
        "normalized_address": "Rua Humberto Rossetti - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 215,
          "numero": 315,
          "ano": 2022,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Humberto Rossetti, Parque das Flores.",
          "autor": "Igor Nascimento",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 216,
    "sapl_id": 1216,
    "numero": 316,
    "ano": 2021,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Blumenau, Jardim Blumenau.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "05/01/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 216,
        "indicacao_id": 216,
        "raw_text": "Rua Blumenau, nº 726",
        "street": "Rua Blumenau",
        "number": "726",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 716,
          "indicacao_id": 216,
          "endereco_id": 216,
          "raw_address": "Rua Blumenau, nº 726",
          "normalized_address": "Rua Blumenau, nº 726 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57546,
          "longitude": -47.18018,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 716,
        "indicacao_id": 216,
        "latitude": -22.57546,
        "longitude": -47.18018,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 726",
        "normalized_address": "Rua Blumenau, nº 726 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 216,
          "numero": 316,
          "ano": 2021,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Blumenau, Jardim Blumenau.",
          "autor": "Nicolas Rocha",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 217,
    "sapl_id": 1217,
    "numero": 317,
    "ano": 2024,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Adhemar de Barros, Centro.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "08/06/2024",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 217,
        "indicacao_id": 217,
        "raw_text": "Rua Adhemar de Barros, nº 737",
        "street": "Rua Adhemar de Barros",
        "number": "737",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 717,
          "indicacao_id": 217,
          "endereco_id": 217,
          "raw_address": "Rua Adhemar de Barros, nº 737",
          "normalized_address": "Rua Adhemar de Barros, nº 737 - Centro, Artur Nogueira - SP",
          "latitude": -22.5777,
          "longitude": -47.1737,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 717,
        "indicacao_id": 217,
        "latitude": -22.5777,
        "longitude": -47.1737,
        "is_approximate": false,
        "raw_address": "Rua Adhemar de Barros, nº 737",
        "normalized_address": "Rua Adhemar de Barros, nº 737 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 217,
          "numero": 317,
          "ano": 2024,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Adhemar de Barros, Centro.",
          "autor": "Rafael Teixeira",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 218,
    "sapl_id": 1218,
    "numero": 318,
    "ano": 2023,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Antônio Tagliari, Coração Criança.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "11/11/2023",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 218,
        "indicacao_id": 218,
        "raw_text": "Rua Antônio Tagliari, nº 748",
        "street": "Rua Antônio Tagliari",
        "number": "748",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 718,
          "indicacao_id": 218,
          "endereco_id": 218,
          "raw_address": "Rua Antônio Tagliari, nº 748",
          "normalized_address": "Rua Antônio Tagliari, nº 748 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56236,
          "longitude": -47.17764,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 718,
        "indicacao_id": 218,
        "latitude": -22.56236,
        "longitude": -47.17764,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 748",
        "normalized_address": "Rua Antônio Tagliari, nº 748 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 218,
          "numero": 318,
          "ano": 2023,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Antônio Tagliari, Coração Criança.",
          "autor": "Julia Oliveira",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 219,
    "sapl_id": 1219,
    "numero": 319,
    "ano": 2022,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Avenida Fernando Arens, Centro.",
    "autor": "Patricia Silva",
    "data_apresentacao": "14/04/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 219,
        "indicacao_id": 219,
        "raw_text": "Avenida Fernando Arens, nº 759",
        "street": "Avenida Fernando Arens",
        "number": "759",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 719,
          "indicacao_id": 219,
          "endereco_id": 219,
          "raw_address": "Avenida Fernando Arens, nº 759",
          "normalized_address": "Avenida Fernando Arens, nº 759 - Centro, Artur Nogueira - SP",
          "latitude": -22.56942,
          "longitude": -47.17496,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 719,
        "indicacao_id": 219,
        "latitude": -22.56942,
        "longitude": -47.17496,
        "is_approximate": false,
        "raw_address": "Avenida Fernando Arens, nº 759",
        "normalized_address": "Avenida Fernando Arens, nº 759 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 219,
          "numero": 319,
          "ano": 2022,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Avenida Fernando Arens, Centro.",
          "autor": "Patricia Silva",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 220,
    "sapl_id": 1220,
    "numero": 320,
    "ano": 2021,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Av. Dr. Roberto Silva, Parque das Flores.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "17/09/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 220,
        "indicacao_id": 220,
        "raw_text": "Av. Dr. Roberto Silva",
        "street": "Av. Dr. Roberto Silva",
        "number": null,
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 720,
          "indicacao_id": 220,
          "endereco_id": 220,
          "raw_address": "Av. Dr. Roberto Silva",
          "normalized_address": "Av. Dr. Roberto Silva - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57826,
          "longitude": -47.1651,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 720,
        "indicacao_id": 220,
        "latitude": -22.57826,
        "longitude": -47.1651,
        "is_approximate": true,
        "raw_address": "Av. Dr. Roberto Silva",
        "normalized_address": "Av. Dr. Roberto Silva - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 220,
          "numero": 320,
          "ano": 2021,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Av. Dr. Roberto Silva, Parque das Flores.",
          "autor": "Marina Ribeiro",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 221,
    "sapl_id": 1221,
    "numero": 321,
    "ano": 2024,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Itamaraty, Jardim Itamaraty.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "20/02/2024",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 221,
        "indicacao_id": 221,
        "raw_text": "Rua Itamaraty, nº 781",
        "street": "Rua Itamaraty",
        "number": "781",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 721,
          "indicacao_id": 221,
          "endereco_id": 221,
          "raw_address": "Rua Itamaraty, nº 781",
          "normalized_address": "Rua Itamaraty, nº 781 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58192,
          "longitude": -47.17062,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 721,
        "indicacao_id": 221,
        "latitude": -22.58192,
        "longitude": -47.17062,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 781",
        "normalized_address": "Rua Itamaraty, nº 781 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 221,
          "numero": 321,
          "ano": 2024,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Itamaraty, Jardim Itamaraty.",
          "autor": "Gabriel Gomes",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 222,
    "sapl_id": 1222,
    "numero": 322,
    "ano": 2023,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua das Margaridas, Jardim Planalto.",
    "autor": "Alex Andrade",
    "data_apresentacao": "23/07/2023",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 222,
        "indicacao_id": 222,
        "raw_text": "Rua das Margaridas, nº 792",
        "street": "Rua das Margaridas",
        "number": "792",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 722,
          "indicacao_id": 222,
          "endereco_id": 222,
          "raw_address": "Rua das Margaridas, nº 792",
          "normalized_address": "Rua das Margaridas, nº 792 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56616,
          "longitude": -47.16806,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 722,
        "indicacao_id": 222,
        "latitude": -22.56616,
        "longitude": -47.16806,
        "is_approximate": false,
        "raw_address": "Rua das Margaridas, nº 792",
        "normalized_address": "Rua das Margaridas, nº 792 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 222,
          "numero": 322,
          "ano": 2023,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua das Margaridas, Jardim Planalto.",
          "autor": "Alex Andrade",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 223,
    "sapl_id": 1223,
    "numero": 323,
    "ano": 2022,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Expedicionários, Jardim Conservani.",
    "autor": "Leandro Prado",
    "data_apresentacao": "26/12/2022",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 223,
        "indicacao_id": 223,
        "raw_text": "Rua Expedicionários, nº 803",
        "street": "Rua Expedicionários",
        "number": "803",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 723,
          "indicacao_id": 223,
          "endereco_id": 223,
          "raw_address": "Rua Expedicionários, nº 803",
          "normalized_address": "Rua Expedicionários, nº 803 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56782,
          "longitude": -47.16308,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 723,
        "indicacao_id": 223,
        "latitude": -22.56782,
        "longitude": -47.16308,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 803",
        "normalized_address": "Rua Expedicionários, nº 803 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 223,
          "numero": 323,
          "ano": 2022,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Expedicionários, Jardim Conservani.",
          "autor": "Leandro Prado",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 224,
    "sapl_id": 1224,
    "numero": 324,
    "ano": 2021,
    "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Duque de Caxias, Centro.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "01/05/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 224,
        "indicacao_id": 224,
        "raw_text": "Rua Duque de Caxias, nº 814",
        "street": "Rua Duque de Caxias",
        "number": "814",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 724,
          "indicacao_id": 224,
          "endereco_id": 224,
          "raw_address": "Rua Duque de Caxias, nº 814",
          "normalized_address": "Rua Duque de Caxias, nº 814 - Centro, Artur Nogueira - SP",
          "latitude": -22.56698,
          "longitude": -47.17202,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 724,
        "indicacao_id": 224,
        "latitude": -22.56698,
        "longitude": -47.17202,
        "is_approximate": false,
        "raw_address": "Rua Duque de Caxias, nº 814",
        "normalized_address": "Rua Duque de Caxias, nº 814 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 224,
          "numero": 324,
          "ano": 2021,
          "ementa": "Indica plantio de mudas nativas e revitalização paisagística na praça da Rua Duque de Caxias, Centro.",
          "autor": "Rafael Teixeira",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 225,
    "sapl_id": 1225,
    "numero": 325,
    "ano": 2022,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Coração Criança.",
    "autor": "Patricia Silva",
    "data_apresentacao": "04/10/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 225,
        "indicacao_id": 225,
        "raw_text": "Rua Pedro Rosa",
        "street": "Rua Pedro Rosa",
        "number": null,
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 725,
          "indicacao_id": 225,
          "endereco_id": 225,
          "raw_address": "Rua Pedro Rosa",
          "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56422,
          "longitude": -47.18004,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 725,
        "indicacao_id": 225,
        "latitude": -22.56422,
        "longitude": -47.18004,
        "is_approximate": true,
        "raw_address": "Rua Pedro Rosa",
        "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 225,
          "numero": 325,
          "ano": 2022,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Coração Criança.",
          "autor": "Patricia Silva",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 226,
    "sapl_id": 1226,
    "numero": 326,
    "ano": 2021,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "07/03/2021",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 226,
        "indicacao_id": 226,
        "raw_text": "Rua XV de Novembro, nº 836",
        "street": "Rua XV de Novembro",
        "number": "836",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 726,
          "indicacao_id": 226,
          "endereco_id": 226,
          "raw_address": "Rua XV de Novembro, nº 836",
          "normalized_address": "Rua XV de Novembro, nº 836 - Centro, Artur Nogueira - SP",
          "latitude": -22.57188,
          "longitude": -47.16798,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 726,
        "indicacao_id": 226,
        "latitude": -22.57188,
        "longitude": -47.16798,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 836",
        "normalized_address": "Rua XV de Novembro, nº 836 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 226,
          "numero": 326,
          "ano": 2021,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
          "autor": "Fernanda Freitas",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 227,
    "sapl_id": 1227,
    "numero": 327,
    "ano": 2024,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "10/08/2024",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 227,
        "indicacao_id": 227,
        "raw_text": "Rua Maria Marson Aresi, nº 847",
        "street": "Rua Maria Marson Aresi",
        "number": "847",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 727,
          "indicacao_id": 227,
          "endereco_id": 227,
          "raw_address": "Rua Maria Marson Aresi, nº 847",
          "normalized_address": "Rua Maria Marson Aresi, nº 847 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58262,
          "longitude": -47.175,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 727,
        "indicacao_id": 227,
        "latitude": -22.58262,
        "longitude": -47.175,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 847",
        "normalized_address": "Rua Maria Marson Aresi, nº 847 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 227,
          "numero": 327,
          "ano": 2024,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
          "autor": "Eduardo Esteves",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 228,
    "sapl_id": 1228,
    "numero": 328,
    "ano": 2023,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Itamaraty.",
    "autor": "Caio Campos",
    "data_apresentacao": "13/01/2023",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 228,
        "indicacao_id": 228,
        "raw_text": "Rua Goiás, nº 858",
        "street": "Rua Goiás",
        "number": "858",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 728,
          "indicacao_id": 228,
          "endereco_id": 228,
          "raw_address": "Rua Goiás, nº 858",
          "normalized_address": "Rua Goiás, nº 858 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58328,
          "longitude": -47.17302,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 728,
        "indicacao_id": 228,
        "latitude": -22.58328,
        "longitude": -47.17302,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 858",
        "normalized_address": "Rua Goiás, nº 858 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 228,
          "numero": 328,
          "ano": 2023,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Itamaraty.",
          "autor": "Caio Campos",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 229,
    "sapl_id": 1229,
    "numero": 329,
    "ano": 2022,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "16/06/2022",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 229,
        "indicacao_id": 229,
        "raw_text": "Rua das Hortênsias, nº 869",
        "street": "Rua das Hortênsias",
        "number": "869",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 729,
          "indicacao_id": 229,
          "endereco_id": 229,
          "raw_address": "Rua das Hortênsias, nº 869",
          "normalized_address": "Rua das Hortênsias, nº 869 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56852,
          "longitude": -47.16646,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 729,
        "indicacao_id": 229,
        "latitude": -22.56852,
        "longitude": -47.16646,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 869",
        "normalized_address": "Rua das Hortênsias, nº 869 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 229,
          "numero": 329,
          "ano": 2022,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
          "autor": "Igor Nascimento",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 230,
    "sapl_id": 1230,
    "numero": 330,
    "ano": 2021,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Conservani.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "19/11/2021",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 230,
        "indicacao_id": 230,
        "raw_text": "Rua Santa Gertrudes",
        "street": "Rua Santa Gertrudes",
        "number": null,
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 730,
          "indicacao_id": 230,
          "endereco_id": 230,
          "raw_address": "Rua Santa Gertrudes",
          "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56918,
          "longitude": -47.16298,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 730,
        "indicacao_id": 230,
        "latitude": -22.56918,
        "longitude": -47.16298,
        "is_approximate": true,
        "raw_address": "Rua Santa Gertrudes",
        "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 230,
          "numero": 330,
          "ano": 2021,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Conservani.",
          "autor": "Julia Oliveira",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 231,
    "sapl_id": 1231,
    "numero": 331,
    "ano": 2024,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
    "autor": "Helena Martins",
    "data_apresentacao": "22/04/2024",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 231,
        "indicacao_id": 231,
        "raw_text": "Rua 7 de Setembro, nº 891",
        "street": "Rua 7 de Setembro",
        "number": "891",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 731,
          "indicacao_id": 231,
          "endereco_id": 231,
          "raw_address": "Rua 7 de Setembro, nº 891",
          "normalized_address": "Rua 7 de Setembro, nº 891 - Centro, Artur Nogueira - SP",
          "latitude": -22.56984,
          "longitude": -47.16792,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 731,
        "indicacao_id": 231,
        "latitude": -22.56984,
        "longitude": -47.16792,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 891",
        "normalized_address": "Rua 7 de Setembro, nº 891 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 231,
          "numero": 331,
          "ano": 2024,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
          "autor": "Helena Martins",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 232,
    "sapl_id": 1232,
    "numero": 332,
    "ano": 2023,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
    "autor": "Bianca Barros",
    "data_apresentacao": "25/09/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 232,
        "indicacao_id": 232,
        "raw_text": "Rua Reinaldo Stein, nº 52",
        "street": "Rua Reinaldo Stein",
        "number": "52",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 732,
          "indicacao_id": 232,
          "endereco_id": 232,
          "raw_address": "Rua Reinaldo Stein, nº 52",
          "normalized_address": "Rua Reinaldo Stein, nº 52 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58108,
          "longitude": -47.17544,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 732,
        "indicacao_id": 232,
        "latitude": -22.58108,
        "longitude": -47.17544,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 52",
        "normalized_address": "Rua Reinaldo Stein, nº 52 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 232,
          "numero": 332,
          "ano": 2023,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
          "autor": "Bianca Barros",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 233,
    "sapl_id": 1233,
    "numero": 333,
    "ano": 2022,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Bairro São Bento.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "28/02/2022",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 233,
        "indicacao_id": 233,
        "raw_text": "Estrada Municipal São Bento, nº 63",
        "street": "Estrada Municipal São Bento",
        "number": "63",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 733,
          "indicacao_id": 233,
          "endereco_id": 233,
          "raw_address": "Estrada Municipal São Bento, nº 63",
          "normalized_address": "Estrada Municipal São Bento, nº 63 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58374,
          "longitude": -47.18038,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 733,
        "indicacao_id": 233,
        "latitude": -22.58374,
        "longitude": -47.18038,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 63",
        "normalized_address": "Estrada Municipal São Bento, nº 63 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 233,
          "numero": 333,
          "ano": 2022,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Bairro São Bento.",
          "autor": "Marina Ribeiro",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 234,
    "sapl_id": 1234,
    "numero": 334,
    "ano": 2021,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Parque das Flores.",
    "autor": "Diana Dias",
    "data_apresentacao": "03/07/2021",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 234,
        "indicacao_id": 234,
        "raw_text": "Rua José Amaro Rodrigues, nº 74",
        "street": "Rua José Amaro Rodrigues",
        "number": "74",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 734,
          "indicacao_id": 234,
          "endereco_id": 234,
          "raw_address": "Rua José Amaro Rodrigues, nº 74",
          "normalized_address": "Rua José Amaro Rodrigues, nº 74 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58148,
          "longitude": -47.1644,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 734,
        "indicacao_id": 234,
        "latitude": -22.58148,
        "longitude": -47.1644,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 74",
        "normalized_address": "Rua José Amaro Rodrigues, nº 74 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 234,
          "numero": 334,
          "ano": 2021,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Parque das Flores.",
          "autor": "Diana Dias",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 235,
    "sapl_id": 1235,
    "numero": 335,
    "ano": 2024,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Blumenau.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "06/12/2024",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 235,
        "indicacao_id": 235,
        "raw_text": "Rua Joinville",
        "street": "Rua Joinville",
        "number": null,
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 735,
          "indicacao_id": 235,
          "endereco_id": 235,
          "raw_address": "Rua Joinville",
          "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57714,
          "longitude": -47.17934,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 735,
        "indicacao_id": 235,
        "latitude": -22.57714,
        "longitude": -47.17934,
        "is_approximate": true,
        "raw_address": "Rua Joinville",
        "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 235,
          "numero": 335,
          "ano": 2024,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Blumenau.",
          "autor": "Nicolas Rocha",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 236,
    "sapl_id": 1236,
    "numero": 336,
    "ano": 2023,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "09/05/2023",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 236,
        "indicacao_id": 236,
        "raw_text": "Rua dos Ipês, nº 96",
        "street": "Rua dos Ipês",
        "number": "96",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 736,
          "indicacao_id": 236,
          "endereco_id": 236,
          "raw_address": "Rua dos Ipês, nº 96",
          "normalized_address": "Rua dos Ipês, nº 96 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5623,
          "longitude": -47.16836,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 736,
        "indicacao_id": 236,
        "latitude": -22.5623,
        "longitude": -47.16836,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 96",
        "normalized_address": "Rua dos Ipês, nº 96 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 236,
          "numero": 336,
          "ano": 2023,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
          "autor": "Julia Oliveira",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 237,
    "sapl_id": 1237,
    "numero": 337,
    "ano": 2022,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Coração Criança.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "12/10/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 237,
        "indicacao_id": 237,
        "raw_text": "Rua Pedro Rosa, nº 107",
        "street": "Rua Pedro Rosa",
        "number": "107",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 737,
          "indicacao_id": 237,
          "endereco_id": 237,
          "raw_address": "Rua Pedro Rosa, nº 107",
          "normalized_address": "Rua Pedro Rosa, nº 107 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56404,
          "longitude": -47.1768,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 737,
        "indicacao_id": 237,
        "latitude": -22.56404,
        "longitude": -47.1768,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 107",
        "normalized_address": "Rua Pedro Rosa, nº 107 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 237,
          "numero": 337,
          "ano": 2022,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Coração Criança.",
          "autor": "Rafael Teixeira",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 238,
    "sapl_id": 1238,
    "numero": 338,
    "ano": 2021,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
    "autor": "Leandro Prado",
    "data_apresentacao": "15/03/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 238,
        "indicacao_id": 238,
        "raw_text": "Rua XV de Novembro, nº 118",
        "street": "Rua XV de Novembro",
        "number": "118",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 738,
          "indicacao_id": 238,
          "endereco_id": 238,
          "raw_address": "Rua XV de Novembro, nº 118",
          "normalized_address": "Rua XV de Novembro, nº 118 - Centro, Artur Nogueira - SP",
          "latitude": -22.5717,
          "longitude": -47.17032,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 738,
        "indicacao_id": 238,
        "latitude": -22.5717,
        "longitude": -47.17032,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 118",
        "normalized_address": "Rua XV de Novembro, nº 118 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 238,
          "numero": 338,
          "ano": 2021,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Centro.",
          "autor": "Leandro Prado",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 239,
    "sapl_id": 1239,
    "numero": 339,
    "ano": 2024,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "18/08/2024",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 239,
        "indicacao_id": 239,
        "raw_text": "Rua Maria Marson Aresi, nº 129",
        "street": "Rua Maria Marson Aresi",
        "number": "129",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 739,
          "indicacao_id": 239,
          "endereco_id": 239,
          "raw_address": "Rua Maria Marson Aresi, nº 129",
          "normalized_address": "Rua Maria Marson Aresi, nº 129 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58244,
          "longitude": -47.17734,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 739,
        "indicacao_id": 239,
        "latitude": -22.58244,
        "longitude": -47.17734,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 129",
        "normalized_address": "Rua Maria Marson Aresi, nº 129 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 239,
          "numero": 339,
          "ano": 2024,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Sacilotto II.",
          "autor": "Gabriel Gomes",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 240,
    "sapl_id": 1240,
    "numero": 340,
    "ano": 2023,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Itamaraty.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "21/01/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 240,
        "indicacao_id": 240,
        "raw_text": "Rua Goiás",
        "street": "Rua Goiás",
        "number": null,
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 740,
          "indicacao_id": 240,
          "endereco_id": 240,
          "raw_address": "Rua Goiás",
          "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5831,
          "longitude": -47.16978,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 740,
        "indicacao_id": 240,
        "latitude": -22.5831,
        "longitude": -47.16978,
        "is_approximate": true,
        "raw_address": "Rua Goiás",
        "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 240,
          "numero": 340,
          "ano": 2023,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Itamaraty.",
          "autor": "Igor Nascimento",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 241,
    "sapl_id": 1241,
    "numero": 341,
    "ano": 2022,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "24/06/2022",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 241,
        "indicacao_id": 241,
        "raw_text": "Rua das Hortênsias, nº 151",
        "street": "Rua das Hortênsias",
        "number": "151",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 741,
          "indicacao_id": 241,
          "endereco_id": 241,
          "raw_address": "Rua das Hortênsias, nº 151",
          "normalized_address": "Rua das Hortênsias, nº 151 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56834,
          "longitude": -47.1688,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 741,
        "indicacao_id": 241,
        "latitude": -22.56834,
        "longitude": -47.1688,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 151",
        "normalized_address": "Rua das Hortênsias, nº 151 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 241,
          "numero": 341,
          "ano": 2022,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Planalto.",
          "autor": "Fernanda Freitas",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 242,
    "sapl_id": 1242,
    "numero": 342,
    "ano": 2021,
    "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Conservani.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "27/11/2021",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 242,
        "indicacao_id": 242,
        "raw_text": "Rua Santa Gertrudes, nº 162",
        "street": "Rua Santa Gertrudes",
        "number": "162",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 742,
          "indicacao_id": 242,
          "endereco_id": 242,
          "raw_address": "Rua Santa Gertrudes, nº 162",
          "normalized_address": "Rua Santa Gertrudes, nº 162 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.569,
          "longitude": -47.15974,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 742,
        "indicacao_id": 242,
        "latitude": -22.569,
        "longitude": -47.15974,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 162",
        "normalized_address": "Rua Santa Gertrudes, nº 162 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 242,
          "numero": 342,
          "ano": 2021,
          "ementa": "Solicita reforço no fornecimento de medicamentos e campanhas de saúde preventiva no Jardim Conservani.",
          "autor": "Nicolas Rocha",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 243,
    "sapl_id": 1243,
    "numero": 343,
    "ano": 2024,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Itamaraty.",
    "autor": "Caio Campos",
    "data_apresentacao": "02/04/2024",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 243,
        "indicacao_id": 243,
        "raw_text": "Rua Goiás, nº 173",
        "street": "Rua Goiás",
        "number": "173",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 743,
          "indicacao_id": 243,
          "endereco_id": 243,
          "raw_address": "Rua Goiás, nº 173",
          "normalized_address": "Rua Goiás, nº 173 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58166,
          "longitude": -47.17176,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 743,
        "indicacao_id": 243,
        "latitude": -22.58166,
        "longitude": -47.17176,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 173",
        "normalized_address": "Rua Goiás, nº 173 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 243,
          "numero": 343,
          "ano": 2024,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Itamaraty.",
          "autor": "Caio Campos",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 244,
    "sapl_id": 1244,
    "numero": 344,
    "ano": 2023,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "05/09/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 244,
        "indicacao_id": 244,
        "raw_text": "Rua das Hortênsias, nº 184",
        "street": "Rua das Hortênsias",
        "number": "184",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 744,
          "indicacao_id": 244,
          "endereco_id": 244,
          "raw_address": "Rua das Hortênsias, nº 184",
          "normalized_address": "Rua das Hortênsias, nº 184 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5669,
          "longitude": -47.1652,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 744,
        "indicacao_id": 244,
        "latitude": -22.5669,
        "longitude": -47.1652,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 184",
        "normalized_address": "Rua das Hortênsias, nº 184 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 244,
          "numero": 344,
          "ano": 2023,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
          "autor": "Marina Ribeiro",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 245,
    "sapl_id": 1245,
    "numero": 345,
    "ano": 2022,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Conservani.",
    "autor": "Alex Andrade",
    "data_apresentacao": "08/02/2022",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 245,
        "indicacao_id": 245,
        "raw_text": "Rua Santa Gertrudes",
        "street": "Rua Santa Gertrudes",
        "number": null,
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 745,
          "indicacao_id": 245,
          "endereco_id": 245,
          "raw_address": "Rua Santa Gertrudes",
          "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56756,
          "longitude": -47.16172,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 745,
        "indicacao_id": 245,
        "latitude": -22.56756,
        "longitude": -47.16172,
        "is_approximate": true,
        "raw_address": "Rua Santa Gertrudes",
        "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 245,
          "numero": 345,
          "ano": 2022,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Conservani.",
          "autor": "Alex Andrade",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 246,
    "sapl_id": 1246,
    "numero": 346,
    "ano": 2021,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "11/07/2021",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 246,
        "indicacao_id": 246,
        "raw_text": "Rua 7 de Setembro, nº 206",
        "street": "Rua 7 de Setembro",
        "number": "206",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 746,
          "indicacao_id": 246,
          "endereco_id": 246,
          "raw_address": "Rua 7 de Setembro, nº 206",
          "normalized_address": "Rua 7 de Setembro, nº 206 - Centro, Artur Nogueira - SP",
          "latitude": -22.5738,
          "longitude": -47.16666,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 746,
        "indicacao_id": 246,
        "latitude": -22.5738,
        "longitude": -47.16666,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 206",
        "normalized_address": "Rua 7 de Setembro, nº 206 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 246,
          "numero": 346,
          "ano": 2021,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
          "autor": "Eduardo Esteves",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 247,
    "sapl_id": 1247,
    "numero": 347,
    "ano": 2024,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "14/12/2024",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 247,
        "indicacao_id": 247,
        "raw_text": "Rua Reinaldo Stein, nº 217",
        "street": "Rua Reinaldo Stein",
        "number": "217",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 747,
          "indicacao_id": 247,
          "endereco_id": 247,
          "raw_address": "Rua Reinaldo Stein, nº 217",
          "normalized_address": "Rua Reinaldo Stein, nº 217 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.57946,
          "longitude": -47.17418,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 747,
        "indicacao_id": 247,
        "latitude": -22.57946,
        "longitude": -47.17418,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 217",
        "normalized_address": "Rua Reinaldo Stein, nº 217 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 247,
          "numero": 347,
          "ano": 2024,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 248,
    "sapl_id": 1248,
    "numero": 348,
    "ano": 2023,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Bairro São Bento.",
    "autor": "Bianca Barros",
    "data_apresentacao": "17/05/2023",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 248,
        "indicacao_id": 248,
        "raw_text": "Estrada Municipal São Bento, nº 228",
        "street": "Estrada Municipal São Bento",
        "number": "228",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 748,
          "indicacao_id": 248,
          "endereco_id": 248,
          "raw_address": "Estrada Municipal São Bento, nº 228",
          "normalized_address": "Estrada Municipal São Bento, nº 228 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.5877,
          "longitude": -47.1847,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 748,
        "indicacao_id": 248,
        "latitude": -22.5877,
        "longitude": -47.1847,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 228",
        "normalized_address": "Estrada Municipal São Bento, nº 228 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 248,
          "numero": 348,
          "ano": 2023,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Bairro São Bento.",
          "autor": "Bianca Barros",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 249,
    "sapl_id": 1249,
    "numero": 349,
    "ano": 2022,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Parque das Flores.",
    "autor": "Helena Martins",
    "data_apresentacao": "20/10/2022",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 249,
        "indicacao_id": 249,
        "raw_text": "Rua José Amaro Rodrigues, nº 239",
        "street": "Rua José Amaro Rodrigues",
        "number": "239",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 749,
          "indicacao_id": 249,
          "endereco_id": 249,
          "raw_address": "Rua José Amaro Rodrigues, nº 239",
          "normalized_address": "Rua José Amaro Rodrigues, nº 239 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57986,
          "longitude": -47.16314,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 749,
        "indicacao_id": 249,
        "latitude": -22.57986,
        "longitude": -47.16314,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 239",
        "normalized_address": "Rua José Amaro Rodrigues, nº 239 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 249,
          "numero": 349,
          "ano": 2022,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Parque das Flores.",
          "autor": "Helena Martins",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 250,
    "sapl_id": 1250,
    "numero": 350,
    "ano": 2021,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Blumenau.",
    "autor": "Patricia Silva",
    "data_apresentacao": "23/03/2021",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 250,
        "indicacao_id": 250,
        "raw_text": "Rua Joinville",
        "street": "Rua Joinville",
        "number": null,
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 750,
          "indicacao_id": 250,
          "endereco_id": 250,
          "raw_address": "Rua Joinville",
          "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57552,
          "longitude": -47.18366,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 750,
        "indicacao_id": 250,
        "latitude": -22.57552,
        "longitude": -47.18366,
        "is_approximate": true,
        "raw_address": "Rua Joinville",
        "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 250,
          "numero": 350,
          "ano": 2021,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Blumenau.",
          "autor": "Patricia Silva",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 251,
    "sapl_id": 1251,
    "numero": 351,
    "ano": 2024,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
    "autor": "Helena Martins",
    "data_apresentacao": "26/08/2024",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 251,
        "indicacao_id": 251,
        "raw_text": "Rua dos Ipês, nº 261",
        "street": "Rua dos Ipês",
        "number": "261",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 751,
          "indicacao_id": 251,
          "endereco_id": 251,
          "raw_address": "Rua dos Ipês, nº 261",
          "normalized_address": "Rua dos Ipês, nº 261 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56626,
          "longitude": -47.1671,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 751,
        "indicacao_id": 251,
        "latitude": -22.56626,
        "longitude": -47.1671,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 261",
        "normalized_address": "Rua dos Ipês, nº 261 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 251,
          "numero": 351,
          "ano": 2024,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
          "autor": "Helena Martins",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 252,
    "sapl_id": 1252,
    "numero": 352,
    "ano": 2023,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Coração Criança.",
    "autor": "Diana Dias",
    "data_apresentacao": "01/01/2023",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 252,
        "indicacao_id": 252,
        "raw_text": "Rua Pedro Rosa, nº 272",
        "street": "Rua Pedro Rosa",
        "number": "272",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 752,
          "indicacao_id": 252,
          "endereco_id": 252,
          "raw_address": "Rua Pedro Rosa, nº 272",
          "normalized_address": "Rua Pedro Rosa, nº 272 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56242,
          "longitude": -47.18112,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 752,
        "indicacao_id": 252,
        "latitude": -22.56242,
        "longitude": -47.18112,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 272",
        "normalized_address": "Rua Pedro Rosa, nº 272 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 252,
          "numero": 352,
          "ano": 2023,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Coração Criança.",
          "autor": "Diana Dias",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 253,
    "sapl_id": 1253,
    "numero": 353,
    "ano": 2022,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
    "autor": "Alex Andrade",
    "data_apresentacao": "04/06/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 253,
        "indicacao_id": 253,
        "raw_text": "Rua XV de Novembro, nº 283",
        "street": "Rua XV de Novembro",
        "number": "283",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 753,
          "indicacao_id": 253,
          "endereco_id": 253,
          "raw_address": "Rua XV de Novembro, nº 283",
          "normalized_address": "Rua XV de Novembro, nº 283 - Centro, Artur Nogueira - SP",
          "latitude": -22.57566,
          "longitude": -47.16906,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 753,
        "indicacao_id": 253,
        "latitude": -22.57566,
        "longitude": -47.16906,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 283",
        "normalized_address": "Rua XV de Novembro, nº 283 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 253,
          "numero": 353,
          "ano": 2022,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
          "autor": "Alex Andrade",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 254,
    "sapl_id": 1254,
    "numero": 354,
    "ano": 2021,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Sacilotto II.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "07/11/2021",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 254,
        "indicacao_id": 254,
        "raw_text": "Rua Maria Marson Aresi, nº 294",
        "street": "Rua Maria Marson Aresi",
        "number": "294",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 754,
          "indicacao_id": 254,
          "endereco_id": 254,
          "raw_address": "Rua Maria Marson Aresi, nº 294",
          "normalized_address": "Rua Maria Marson Aresi, nº 294 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58082,
          "longitude": -47.17608,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 754,
        "indicacao_id": 254,
        "latitude": -22.58082,
        "longitude": -47.17608,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 294",
        "normalized_address": "Rua Maria Marson Aresi, nº 294 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 254,
          "numero": 354,
          "ano": 2021,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Sacilotto II.",
          "autor": "Julia Oliveira",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 255,
    "sapl_id": 1255,
    "numero": 355,
    "ano": 2024,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Itamaraty.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "10/04/2024",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 255,
        "indicacao_id": 255,
        "raw_text": "Rua Goiás",
        "street": "Rua Goiás",
        "number": null,
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 755,
          "indicacao_id": 255,
          "endereco_id": 255,
          "raw_address": "Rua Goiás",
          "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58148,
          "longitude": -47.16852,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 755,
        "indicacao_id": 255,
        "latitude": -22.58148,
        "longitude": -47.16852,
        "is_approximate": true,
        "raw_address": "Rua Goiás",
        "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 255,
          "numero": 355,
          "ano": 2024,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Itamaraty.",
          "autor": "Igor Nascimento",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 256,
    "sapl_id": 1256,
    "numero": 356,
    "ano": 2023,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "13/09/2023",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 256,
        "indicacao_id": 256,
        "raw_text": "Rua das Hortênsias, nº 316",
        "street": "Rua das Hortênsias",
        "number": "316",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 756,
          "indicacao_id": 256,
          "endereco_id": 256,
          "raw_address": "Rua das Hortênsias, nº 316",
          "normalized_address": "Rua das Hortênsias, nº 316 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56672,
          "longitude": -47.16754,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 756,
        "indicacao_id": 256,
        "latitude": -22.56672,
        "longitude": -47.16754,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 316",
        "normalized_address": "Rua das Hortênsias, nº 316 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 256,
          "numero": 356,
          "ano": 2023,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Planalto.",
          "autor": "Fernanda Freitas",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 257,
    "sapl_id": 1257,
    "numero": 357,
    "ano": 2022,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Conservani.",
    "autor": "Patricia Silva",
    "data_apresentacao": "16/02/2022",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 257,
        "indicacao_id": 257,
        "raw_text": "Rua Santa Gertrudes, nº 327",
        "street": "Rua Santa Gertrudes",
        "number": "327",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 757,
          "indicacao_id": 257,
          "endereco_id": 257,
          "raw_address": "Rua Santa Gertrudes, nº 327",
          "normalized_address": "Rua Santa Gertrudes, nº 327 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56738,
          "longitude": -47.15848,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 757,
        "indicacao_id": 257,
        "latitude": -22.56738,
        "longitude": -47.15848,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 327",
        "normalized_address": "Rua Santa Gertrudes, nº 327 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 257,
          "numero": 357,
          "ano": 2022,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Jardim Conservani.",
          "autor": "Patricia Silva",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 258,
    "sapl_id": 1258,
    "numero": 358,
    "ano": 2021,
    "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
    "autor": "Caio Campos",
    "data_apresentacao": "19/07/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 258,
        "indicacao_id": 258,
        "raw_text": "Rua 7 de Setembro, nº 338",
        "street": "Rua 7 de Setembro",
        "number": "338",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 758,
          "indicacao_id": 258,
          "endereco_id": 258,
          "raw_address": "Rua 7 de Setembro, nº 338",
          "normalized_address": "Rua 7 de Setembro, nº 338 - Centro, Artur Nogueira - SP",
          "latitude": -22.57362,
          "longitude": -47.169,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 758,
        "indicacao_id": 258,
        "latitude": -22.57362,
        "longitude": -47.169,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 338",
        "normalized_address": "Rua 7 de Setembro, nº 338 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 258,
          "numero": 358,
          "ano": 2021,
          "ementa": "Indica manutenção preventiva na estrutura externa e pintura da unidade escolar no Centro.",
          "autor": "Caio Campos",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 259,
    "sapl_id": 1259,
    "numero": 359,
    "ano": 2024,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "22/12/2024",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 259,
        "indicacao_id": 259,
        "raw_text": "Rua Reinaldo Stein, nº 349",
        "street": "Rua Reinaldo Stein",
        "number": "349",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 759,
          "indicacao_id": 259,
          "endereco_id": 259,
          "raw_address": "Rua Reinaldo Stein, nº 349",
          "normalized_address": "Rua Reinaldo Stein, nº 349 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.57928,
          "longitude": -47.17652,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 759,
        "indicacao_id": 259,
        "latitude": -22.57928,
        "longitude": -47.17652,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 349",
        "normalized_address": "Rua Reinaldo Stein, nº 349 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 259,
          "numero": 359,
          "ano": 2024,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
          "autor": "Gabriel Gomes",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 260,
    "sapl_id": 1260,
    "numero": 360,
    "ano": 2023,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Bairro São Bento.",
    "autor": "Leandro Prado",
    "data_apresentacao": "25/05/2023",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 260,
        "indicacao_id": 260,
        "raw_text": "Estrada Municipal São Bento",
        "street": "Estrada Municipal São Bento",
        "number": null,
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 760,
          "indicacao_id": 260,
          "endereco_id": 260,
          "raw_address": "Estrada Municipal São Bento",
          "normalized_address": "Estrada Municipal São Bento - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58752,
          "longitude": -47.18146,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 760,
        "indicacao_id": 260,
        "latitude": -22.58752,
        "longitude": -47.18146,
        "is_approximate": true,
        "raw_address": "Estrada Municipal São Bento",
        "normalized_address": "Estrada Municipal São Bento - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 260,
          "numero": 360,
          "ano": 2023,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Bairro São Bento.",
          "autor": "Leandro Prado",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 261,
    "sapl_id": 1261,
    "numero": 361,
    "ano": 2022,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Parque das Flores.",
    "autor": "Bianca Barros",
    "data_apresentacao": "28/10/2022",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 261,
        "indicacao_id": 261,
        "raw_text": "Rua José Amaro Rodrigues, nº 371",
        "street": "Rua José Amaro Rodrigues",
        "number": "371",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 761,
          "indicacao_id": 261,
          "endereco_id": 261,
          "raw_address": "Rua José Amaro Rodrigues, nº 371",
          "normalized_address": "Rua José Amaro Rodrigues, nº 371 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57968,
          "longitude": -47.16548,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 761,
        "indicacao_id": 261,
        "latitude": -22.57968,
        "longitude": -47.16548,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 371",
        "normalized_address": "Rua José Amaro Rodrigues, nº 371 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 261,
          "numero": 361,
          "ano": 2022,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Parque das Flores.",
          "autor": "Bianca Barros",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 262,
    "sapl_id": 1262,
    "numero": 362,
    "ano": 2021,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Blumenau.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "03/03/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 262,
        "indicacao_id": 262,
        "raw_text": "Rua Joinville, nº 382",
        "street": "Rua Joinville",
        "number": "382",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 762,
          "indicacao_id": 262,
          "endereco_id": 262,
          "raw_address": "Rua Joinville, nº 382",
          "normalized_address": "Rua Joinville, nº 382 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57534,
          "longitude": -47.18042,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 762,
        "indicacao_id": 262,
        "latitude": -22.57534,
        "longitude": -47.18042,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 382",
        "normalized_address": "Rua Joinville, nº 382 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 262,
          "numero": 362,
          "ano": 2021,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Blumenau.",
          "autor": "Nicolas Rocha",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 263,
    "sapl_id": 1263,
    "numero": 363,
    "ano": 2024,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Planalto.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "06/08/2024",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 263,
        "indicacao_id": 263,
        "raw_text": "Rua dos Ipês, nº 393",
        "street": "Rua dos Ipês",
        "number": "393",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 763,
          "indicacao_id": 263,
          "endereco_id": 263,
          "raw_address": "Rua dos Ipês, nº 393",
          "normalized_address": "Rua dos Ipês, nº 393 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56608,
          "longitude": -47.16944,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 763,
        "indicacao_id": 263,
        "latitude": -22.56608,
        "longitude": -47.16944,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 393",
        "normalized_address": "Rua dos Ipês, nº 393 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 263,
          "numero": 363,
          "ano": 2024,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Planalto.",
          "autor": "Eduardo Esteves",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 264,
    "sapl_id": 1264,
    "numero": 364,
    "ano": 2023,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Coração Criança.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "09/01/2023",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 264,
        "indicacao_id": 264,
        "raw_text": "Rua Pedro Rosa, nº 404",
        "street": "Rua Pedro Rosa",
        "number": "404",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 764,
          "indicacao_id": 264,
          "endereco_id": 264,
          "raw_address": "Rua Pedro Rosa, nº 404",
          "normalized_address": "Rua Pedro Rosa, nº 404 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56224,
          "longitude": -47.17788,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 764,
        "indicacao_id": 264,
        "latitude": -22.56224,
        "longitude": -47.17788,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 404",
        "normalized_address": "Rua Pedro Rosa, nº 404 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 264,
          "numero": 364,
          "ano": 2023,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Coração Criança.",
          "autor": "Marina Ribeiro",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 265,
    "sapl_id": 1265,
    "numero": 365,
    "ano": 2022,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Centro.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "12/06/2022",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 265,
        "indicacao_id": 265,
        "raw_text": "Rua XV de Novembro",
        "street": "Rua XV de Novembro",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 765,
          "indicacao_id": 265,
          "endereco_id": 265,
          "raw_address": "Rua XV de Novembro",
          "normalized_address": "Rua XV de Novembro - Centro, Artur Nogueira - SP",
          "latitude": -22.57548,
          "longitude": -47.1714,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 765,
        "indicacao_id": 265,
        "latitude": -22.57548,
        "longitude": -47.1714,
        "is_approximate": true,
        "raw_address": "Rua XV de Novembro",
        "normalized_address": "Rua XV de Novembro - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 265,
          "numero": 365,
          "ano": 2022,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Centro.",
          "autor": "Rafael Teixeira",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 266,
    "sapl_id": 1266,
    "numero": 366,
    "ano": 2021,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "15/11/2021",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 266,
        "indicacao_id": 266,
        "raw_text": "Rua Maria Marson Aresi, nº 426",
        "street": "Rua Maria Marson Aresi",
        "number": "426",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 766,
          "indicacao_id": 266,
          "endereco_id": 266,
          "raw_address": "Rua Maria Marson Aresi, nº 426",
          "normalized_address": "Rua Maria Marson Aresi, nº 426 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58064,
          "longitude": -47.17284,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 766,
        "indicacao_id": 266,
        "latitude": -22.58064,
        "longitude": -47.17284,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 426",
        "normalized_address": "Rua Maria Marson Aresi, nº 426 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 266,
          "numero": 366,
          "ano": 2021,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
          "autor": "Marina Ribeiro",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 267,
    "sapl_id": 1267,
    "numero": 367,
    "ano": 2024,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Itamaraty.",
    "autor": "Leandro Prado",
    "data_apresentacao": "18/04/2024",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 267,
        "indicacao_id": 267,
        "raw_text": "Rua Goiás, nº 437",
        "street": "Rua Goiás",
        "number": "437",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 767,
          "indicacao_id": 267,
          "endereco_id": 267,
          "raw_address": "Rua Goiás, nº 437",
          "normalized_address": "Rua Goiás, nº 437 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5813,
          "longitude": -47.17086,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 767,
        "indicacao_id": 267,
        "latitude": -22.5813,
        "longitude": -47.17086,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 437",
        "normalized_address": "Rua Goiás, nº 437 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 267,
          "numero": 367,
          "ano": 2024,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Itamaraty.",
          "autor": "Leandro Prado",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 268,
    "sapl_id": 1268,
    "numero": 368,
    "ano": 2023,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Planalto.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "21/09/2023",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 268,
        "indicacao_id": 268,
        "raw_text": "Rua das Hortênsias, nº 448",
        "street": "Rua das Hortênsias",
        "number": "448",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 768,
          "indicacao_id": 268,
          "endereco_id": 268,
          "raw_address": "Rua das Hortênsias, nº 448",
          "normalized_address": "Rua das Hortênsias, nº 448 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56654,
          "longitude": -47.1643,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 768,
        "indicacao_id": 268,
        "latitude": -22.56654,
        "longitude": -47.1643,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 448",
        "normalized_address": "Rua das Hortênsias, nº 448 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 268,
          "numero": 368,
          "ano": 2023,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Planalto.",
          "autor": "Rafael Teixeira",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 269,
    "sapl_id": 1269,
    "numero": 369,
    "ano": 2022,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Conservani.",
    "autor": "Helena Martins",
    "data_apresentacao": "24/02/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 269,
        "indicacao_id": 269,
        "raw_text": "Rua Santa Gertrudes, nº 459",
        "street": "Rua Santa Gertrudes",
        "number": "459",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 769,
          "indicacao_id": 269,
          "endereco_id": 269,
          "raw_address": "Rua Santa Gertrudes, nº 459",
          "normalized_address": "Rua Santa Gertrudes, nº 459 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.5672,
          "longitude": -47.16082,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 769,
        "indicacao_id": 269,
        "latitude": -22.5672,
        "longitude": -47.16082,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 459",
        "normalized_address": "Rua Santa Gertrudes, nº 459 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 269,
          "numero": 369,
          "ano": 2022,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Conservani.",
          "autor": "Helena Martins",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 270,
    "sapl_id": 1270,
    "numero": 370,
    "ano": 2021,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Centro.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "27/07/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 270,
        "indicacao_id": 270,
        "raw_text": "Rua 7 de Setembro",
        "street": "Rua 7 de Setembro",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 770,
          "indicacao_id": 270,
          "endereco_id": 270,
          "raw_address": "Rua 7 de Setembro",
          "normalized_address": "Rua 7 de Setembro - Centro, Artur Nogueira - SP",
          "latitude": -22.57344,
          "longitude": -47.17134,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 770,
        "indicacao_id": 270,
        "latitude": -22.57344,
        "longitude": -47.17134,
        "is_approximate": true,
        "raw_address": "Rua 7 de Setembro",
        "normalized_address": "Rua 7 de Setembro - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 270,
          "numero": 370,
          "ano": 2021,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Centro.",
          "autor": "Fernanda Freitas",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 271,
    "sapl_id": 1271,
    "numero": 371,
    "ano": 2024,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "02/12/2024",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 271,
        "indicacao_id": 271,
        "raw_text": "Rua Reinaldo Stein, nº 481",
        "street": "Rua Reinaldo Stein",
        "number": "481",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 771,
          "indicacao_id": 271,
          "endereco_id": 271,
          "raw_address": "Rua Reinaldo Stein, nº 481",
          "normalized_address": "Rua Reinaldo Stein, nº 481 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5791,
          "longitude": -47.17328,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 771,
        "indicacao_id": 271,
        "latitude": -22.5791,
        "longitude": -47.17328,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 481",
        "normalized_address": "Rua Reinaldo Stein, nº 481 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 271,
          "numero": 371,
          "ano": 2024,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Jardim Sacilotto II.",
          "autor": "Eduardo Esteves",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 272,
    "sapl_id": 1272,
    "numero": 372,
    "ano": 2023,
    "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Bairro São Bento.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "05/05/2023",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 272,
        "indicacao_id": 272,
        "raw_text": "Estrada Municipal São Bento, nº 492",
        "street": "Estrada Municipal São Bento",
        "number": "492",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 772,
          "indicacao_id": 272,
          "endereco_id": 272,
          "raw_address": "Estrada Municipal São Bento, nº 492",
          "normalized_address": "Estrada Municipal São Bento, nº 492 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58734,
          "longitude": -47.1838,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 772,
        "indicacao_id": 272,
        "latitude": -22.58734,
        "longitude": -47.1838,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 492",
        "normalized_address": "Estrada Municipal São Bento, nº 492 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 272,
          "numero": 372,
          "ano": 2023,
          "ementa": "Solicita revitalização da área de lazer e manutenção da quadra esportiva no Bairro São Bento.",
          "autor": "Igor Nascimento",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 273,
    "sapl_id": 1273,
    "numero": 373,
    "ano": 2022,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Pedro Rosa, Coração Criança.",
    "autor": "Caio Campos",
    "data_apresentacao": "08/10/2022",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 273,
        "indicacao_id": 273,
        "raw_text": "Rua Pedro Rosa, nº 503",
        "street": "Rua Pedro Rosa",
        "number": "503",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 773,
          "indicacao_id": 273,
          "endereco_id": 273,
          "raw_address": "Rua Pedro Rosa, nº 503",
          "normalized_address": "Rua Pedro Rosa, nº 503 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.5635,
          "longitude": -47.17824,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 773,
        "indicacao_id": 273,
        "latitude": -22.5635,
        "longitude": -47.17824,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 503",
        "normalized_address": "Rua Pedro Rosa, nº 503 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 273,
          "numero": 373,
          "ano": 2022,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Pedro Rosa, Coração Criança.",
          "autor": "Caio Campos",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 274,
    "sapl_id": 1274,
    "numero": 374,
    "ano": 2021,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua XV de Novembro, Centro.",
    "autor": "Patricia Silva",
    "data_apresentacao": "11/03/2021",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 274,
        "indicacao_id": 274,
        "raw_text": "Rua XV de Novembro, nº 514",
        "street": "Rua XV de Novembro",
        "number": "514",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 774,
          "indicacao_id": 274,
          "endereco_id": 274,
          "raw_address": "Rua XV de Novembro, nº 514",
          "normalized_address": "Rua XV de Novembro, nº 514 - Centro, Artur Nogueira - SP",
          "latitude": -22.57116,
          "longitude": -47.17176,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 774,
        "indicacao_id": 274,
        "latitude": -22.57116,
        "longitude": -47.17176,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 514",
        "normalized_address": "Rua XV de Novembro, nº 514 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 274,
          "numero": 374,
          "ano": 2021,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua XV de Novembro, Centro.",
          "autor": "Patricia Silva",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 275,
    "sapl_id": 1275,
    "numero": 375,
    "ano": 2024,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Maria Marson Aresi, Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "14/08/2024",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 275,
        "indicacao_id": 275,
        "raw_text": "Rua Maria Marson Aresi",
        "street": "Rua Maria Marson Aresi",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 775,
          "indicacao_id": 275,
          "endereco_id": 275,
          "raw_address": "Rua Maria Marson Aresi",
          "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5819,
          "longitude": -47.1732,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 775,
        "indicacao_id": 275,
        "latitude": -22.5819,
        "longitude": -47.1732,
        "is_approximate": true,
        "raw_address": "Rua Maria Marson Aresi",
        "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 275,
          "numero": 375,
          "ano": 2024,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Maria Marson Aresi, Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 276,
    "sapl_id": 1276,
    "numero": 376,
    "ano": 2023,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Goiás, Jardim Itamaraty.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "17/01/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 276,
        "indicacao_id": 276,
        "raw_text": "Rua Goiás, nº 536",
        "street": "Rua Goiás",
        "number": "536",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 776,
          "indicacao_id": 276,
          "endereco_id": 276,
          "raw_address": "Rua Goiás, nº 536",
          "normalized_address": "Rua Goiás, nº 536 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58256,
          "longitude": -47.17122,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 776,
        "indicacao_id": 276,
        "latitude": -22.58256,
        "longitude": -47.17122,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 536",
        "normalized_address": "Rua Goiás, nº 536 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 276,
          "numero": 376,
          "ano": 2023,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Goiás, Jardim Itamaraty.",
          "autor": "Julia Oliveira",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 277,
    "sapl_id": 1277,
    "numero": 377,
    "ano": 2022,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua das Hortênsias, Jardim Planalto.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "20/06/2022",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 277,
        "indicacao_id": 277,
        "raw_text": "Rua das Hortênsias, nº 547",
        "street": "Rua das Hortênsias",
        "number": "547",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 777,
          "indicacao_id": 277,
          "endereco_id": 277,
          "raw_address": "Rua das Hortênsias, nº 547",
          "normalized_address": "Rua das Hortênsias, nº 547 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5678,
          "longitude": -47.16466,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 777,
        "indicacao_id": 277,
        "latitude": -22.5678,
        "longitude": -47.16466,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 547",
        "normalized_address": "Rua das Hortênsias, nº 547 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 277,
          "numero": 377,
          "ano": 2022,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua das Hortênsias, Jardim Planalto.",
          "autor": "Nicolas Rocha",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 278,
    "sapl_id": 1278,
    "numero": 378,
    "ano": 2021,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Santa Gertrudes, Jardim Conservani.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "23/11/2021",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 278,
        "indicacao_id": 278,
        "raw_text": "Rua Santa Gertrudes, nº 558",
        "street": "Rua Santa Gertrudes",
        "number": "558",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 778,
          "indicacao_id": 278,
          "endereco_id": 278,
          "raw_address": "Rua Santa Gertrudes, nº 558",
          "normalized_address": "Rua Santa Gertrudes, nº 558 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56846,
          "longitude": -47.16118,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 778,
        "indicacao_id": 278,
        "latitude": -22.56846,
        "longitude": -47.16118,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 558",
        "normalized_address": "Rua Santa Gertrudes, nº 558 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 278,
          "numero": 378,
          "ano": 2021,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Santa Gertrudes, Jardim Conservani.",
          "autor": "Gabriel Gomes",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 279,
    "sapl_id": 1279,
    "numero": 379,
    "ano": 2024,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua 7 de Setembro, Centro.",
    "autor": "Bianca Barros",
    "data_apresentacao": "26/04/2024",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 279,
        "indicacao_id": 279,
        "raw_text": "Rua 7 de Setembro, nº 569",
        "street": "Rua 7 de Setembro",
        "number": "569",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 779,
          "indicacao_id": 279,
          "endereco_id": 279,
          "raw_address": "Rua 7 de Setembro, nº 569",
          "normalized_address": "Rua 7 de Setembro, nº 569 - Centro, Artur Nogueira - SP",
          "latitude": -22.5747,
          "longitude": -47.1717,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 779,
        "indicacao_id": 279,
        "latitude": -22.5747,
        "longitude": -47.1717,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 569",
        "normalized_address": "Rua 7 de Setembro, nº 569 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 279,
          "numero": 379,
          "ano": 2024,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua 7 de Setembro, Centro.",
          "autor": "Bianca Barros",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 280,
    "sapl_id": 1280,
    "numero": 380,
    "ano": 2023,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Reinaldo Stein, Jardim Sacilotto II.",
    "autor": "Alex Andrade",
    "data_apresentacao": "01/09/2023",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 280,
        "indicacao_id": 280,
        "raw_text": "Rua Reinaldo Stein",
        "street": "Rua Reinaldo Stein",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 780,
          "indicacao_id": 280,
          "endereco_id": 280,
          "raw_address": "Rua Reinaldo Stein",
          "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58036,
          "longitude": -47.17364,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 780,
        "indicacao_id": 280,
        "latitude": -22.58036,
        "longitude": -47.17364,
        "is_approximate": true,
        "raw_address": "Rua Reinaldo Stein",
        "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 280,
          "numero": 380,
          "ano": 2023,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Reinaldo Stein, Jardim Sacilotto II.",
          "autor": "Alex Andrade",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 281,
    "sapl_id": 1281,
    "numero": 381,
    "ano": 2022,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Estrada Municipal São Bento, Bairro São Bento.",
    "autor": "Alex Andrade",
    "data_apresentacao": "04/02/2022",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 281,
        "indicacao_id": 281,
        "raw_text": "Estrada Municipal São Bento, nº 591",
        "street": "Estrada Municipal São Bento",
        "number": "591",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 781,
          "indicacao_id": 281,
          "endereco_id": 281,
          "raw_address": "Estrada Municipal São Bento, nº 591",
          "normalized_address": "Estrada Municipal São Bento, nº 591 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58302,
          "longitude": -47.18416,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 781,
        "indicacao_id": 281,
        "latitude": -22.58302,
        "longitude": -47.18416,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 591",
        "normalized_address": "Estrada Municipal São Bento, nº 591 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 281,
          "numero": 381,
          "ano": 2022,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Estrada Municipal São Bento, Bairro São Bento.",
          "autor": "Alex Andrade",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 282,
    "sapl_id": 1282,
    "numero": 382,
    "ano": 2021,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua José Amaro Rodrigues, Parque das Flores.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "07/07/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 282,
        "indicacao_id": 282,
        "raw_text": "Rua José Amaro Rodrigues, nº 602",
        "street": "Rua José Amaro Rodrigues",
        "number": "602",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 782,
          "indicacao_id": 282,
          "endereco_id": 282,
          "raw_address": "Rua José Amaro Rodrigues, nº 602",
          "normalized_address": "Rua José Amaro Rodrigues, nº 602 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58076,
          "longitude": -47.1626,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 782,
        "indicacao_id": 282,
        "latitude": -22.58076,
        "longitude": -47.1626,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 602",
        "normalized_address": "Rua José Amaro Rodrigues, nº 602 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 282,
          "numero": 382,
          "ano": 2021,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua José Amaro Rodrigues, Parque das Flores.",
          "autor": "Rafael Teixeira",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 283,
    "sapl_id": 1283,
    "numero": 383,
    "ano": 2024,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Joinville, Jardim Blumenau.",
    "autor": "Diana Dias",
    "data_apresentacao": "10/12/2024",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 283,
        "indicacao_id": 283,
        "raw_text": "Rua Joinville, nº 613",
        "street": "Rua Joinville",
        "number": "613",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 783,
          "indicacao_id": 283,
          "endereco_id": 283,
          "raw_address": "Rua Joinville, nº 613",
          "normalized_address": "Rua Joinville, nº 613 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57642,
          "longitude": -47.18312,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 783,
        "indicacao_id": 283,
        "latitude": -22.57642,
        "longitude": -47.18312,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 613",
        "normalized_address": "Rua Joinville, nº 613 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 283,
          "numero": 383,
          "ano": 2024,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Joinville, Jardim Blumenau.",
          "autor": "Diana Dias",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 284,
    "sapl_id": 1284,
    "numero": 384,
    "ano": 2023,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua dos Ipês, Jardim Planalto.",
    "autor": "Leandro Prado",
    "data_apresentacao": "13/05/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 284,
        "indicacao_id": 284,
        "raw_text": "Rua dos Ipês, nº 624",
        "street": "Rua dos Ipês",
        "number": "624",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 784,
          "indicacao_id": 284,
          "endereco_id": 284,
          "raw_address": "Rua dos Ipês, nº 624",
          "normalized_address": "Rua dos Ipês, nº 624 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56716,
          "longitude": -47.16656,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 784,
        "indicacao_id": 284,
        "latitude": -22.56716,
        "longitude": -47.16656,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 624",
        "normalized_address": "Rua dos Ipês, nº 624 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 284,
          "numero": 384,
          "ano": 2023,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua dos Ipês, Jardim Planalto.",
          "autor": "Leandro Prado",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 285,
    "sapl_id": 1285,
    "numero": 385,
    "ano": 2022,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Pedro Rosa, Coração Criança.",
    "autor": "Patricia Silva",
    "data_apresentacao": "16/10/2022",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 285,
        "indicacao_id": 285,
        "raw_text": "Rua Pedro Rosa",
        "street": "Rua Pedro Rosa",
        "number": null,
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 785,
          "indicacao_id": 285,
          "endereco_id": 285,
          "raw_address": "Rua Pedro Rosa",
          "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56332,
          "longitude": -47.18058,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 785,
        "indicacao_id": 285,
        "latitude": -22.56332,
        "longitude": -47.18058,
        "is_approximate": true,
        "raw_address": "Rua Pedro Rosa",
        "normalized_address": "Rua Pedro Rosa - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 285,
          "numero": 385,
          "ano": 2022,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Pedro Rosa, Coração Criança.",
          "autor": "Patricia Silva",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 286,
    "sapl_id": 1286,
    "numero": 386,
    "ano": 2021,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua XV de Novembro, Centro.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "19/03/2021",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 286,
        "indicacao_id": 286,
        "raw_text": "Rua XV de Novembro, nº 646",
        "street": "Rua XV de Novembro",
        "number": "646",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 786,
          "indicacao_id": 286,
          "endereco_id": 286,
          "raw_address": "Rua XV de Novembro, nº 646",
          "normalized_address": "Rua XV de Novembro, nº 646 - Centro, Artur Nogueira - SP",
          "latitude": -22.57098,
          "longitude": -47.16852,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 786,
        "indicacao_id": 286,
        "latitude": -22.57098,
        "longitude": -47.16852,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 646",
        "normalized_address": "Rua XV de Novembro, nº 646 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 286,
          "numero": 386,
          "ano": 2021,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua XV de Novembro, Centro.",
          "autor": "Gabriel Gomes",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 287,
    "sapl_id": 1287,
    "numero": 387,
    "ano": 2024,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Maria Marson Aresi, Jardim Sacilotto II.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "22/08/2024",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 287,
        "indicacao_id": 287,
        "raw_text": "Rua Maria Marson Aresi, nº 657",
        "street": "Rua Maria Marson Aresi",
        "number": "657",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 787,
          "indicacao_id": 287,
          "endereco_id": 287,
          "raw_address": "Rua Maria Marson Aresi, nº 657",
          "normalized_address": "Rua Maria Marson Aresi, nº 657 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58172,
          "longitude": -47.17554,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 787,
        "indicacao_id": 287,
        "latitude": -22.58172,
        "longitude": -47.17554,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 657",
        "normalized_address": "Rua Maria Marson Aresi, nº 657 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 287,
          "numero": 387,
          "ano": 2024,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Maria Marson Aresi, Jardim Sacilotto II.",
          "autor": "Igor Nascimento",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 288,
    "sapl_id": 1288,
    "numero": 388,
    "ano": 2023,
    "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Goiás, Jardim Itamaraty.",
    "autor": "Caio Campos",
    "data_apresentacao": "25/01/2023",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 288,
        "indicacao_id": 288,
        "raw_text": "Rua Goiás, nº 668",
        "street": "Rua Goiás",
        "number": "668",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 788,
          "indicacao_id": 288,
          "endereco_id": 288,
          "raw_address": "Rua Goiás, nº 668",
          "normalized_address": "Rua Goiás, nº 668 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58238,
          "longitude": -47.16798,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 788,
        "indicacao_id": 288,
        "latitude": -22.58238,
        "longitude": -47.16798,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 668",
        "normalized_address": "Rua Goiás, nº 668 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 288,
          "numero": 388,
          "ano": 2023,
          "ementa": "Indica intensificação das rondas preventivas e reforço da segurança pública na Rua Goiás, Jardim Itamaraty.",
          "autor": "Caio Campos",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 289,
    "sapl_id": 1289,
    "numero": 389,
    "ano": 2022,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Planalto.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "28/06/2022",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 289,
        "indicacao_id": 289,
        "raw_text": "Rua das Hortênsias, nº 679",
        "street": "Rua das Hortênsias",
        "number": "679",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 789,
          "indicacao_id": 289,
          "endereco_id": 289,
          "raw_address": "Rua das Hortênsias, nº 679",
          "normalized_address": "Rua das Hortênsias, nº 679 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56762,
          "longitude": -47.167,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 789,
        "indicacao_id": 289,
        "latitude": -22.56762,
        "longitude": -47.167,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 679",
        "normalized_address": "Rua das Hortênsias, nº 679 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 289,
          "numero": 389,
          "ano": 2022,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Planalto.",
          "autor": "Nicolas Rocha",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 290,
    "sapl_id": 1290,
    "numero": 390,
    "ano": 2021,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Conservani.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "03/11/2021",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 290,
        "indicacao_id": 290,
        "raw_text": "Rua Santa Gertrudes",
        "street": "Rua Santa Gertrudes",
        "number": null,
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 790,
          "indicacao_id": 290,
          "endereco_id": 290,
          "raw_address": "Rua Santa Gertrudes",
          "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56828,
          "longitude": -47.16352,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 790,
        "indicacao_id": 290,
        "latitude": -22.56828,
        "longitude": -47.16352,
        "is_approximate": true,
        "raw_address": "Rua Santa Gertrudes",
        "normalized_address": "Rua Santa Gertrudes - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 290,
          "numero": 390,
          "ano": 2021,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Conservani.",
          "autor": "Eduardo Esteves",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 291,
    "sapl_id": 1291,
    "numero": 391,
    "ano": 2024,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Centro.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "06/04/2024",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 291,
        "indicacao_id": 291,
        "raw_text": "Rua 7 de Setembro, nº 701",
        "street": "Rua 7 de Setembro",
        "number": "701",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 791,
          "indicacao_id": 291,
          "endereco_id": 291,
          "raw_address": "Rua 7 de Setembro, nº 701",
          "normalized_address": "Rua 7 de Setembro, nº 701 - Centro, Artur Nogueira - SP",
          "latitude": -22.57452,
          "longitude": -47.16846,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 791,
        "indicacao_id": 291,
        "latitude": -22.57452,
        "longitude": -47.16846,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 701",
        "normalized_address": "Rua 7 de Setembro, nº 701 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 291,
          "numero": 391,
          "ano": 2024,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Centro.",
          "autor": "Marina Ribeiro",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 292,
    "sapl_id": 1292,
    "numero": 392,
    "ano": 2023,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Sacilotto II.",
    "autor": "Helena Martins",
    "data_apresentacao": "09/09/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 292,
        "indicacao_id": 292,
        "raw_text": "Rua Reinaldo Stein, nº 712",
        "street": "Rua Reinaldo Stein",
        "number": "712",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 792,
          "indicacao_id": 292,
          "endereco_id": 292,
          "raw_address": "Rua Reinaldo Stein, nº 712",
          "normalized_address": "Rua Reinaldo Stein, nº 712 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58018,
          "longitude": -47.17598,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 792,
        "indicacao_id": 292,
        "latitude": -22.58018,
        "longitude": -47.17598,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 712",
        "normalized_address": "Rua Reinaldo Stein, nº 712 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 292,
          "numero": 392,
          "ano": 2023,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Sacilotto II.",
          "autor": "Helena Martins",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 293,
    "sapl_id": 1293,
    "numero": 393,
    "ano": 2022,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Bairro São Bento.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "12/02/2022",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 293,
        "indicacao_id": 293,
        "raw_text": "Estrada Municipal São Bento, nº 723",
        "street": "Estrada Municipal São Bento",
        "number": "723",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 793,
          "indicacao_id": 293,
          "endereco_id": 293,
          "raw_address": "Estrada Municipal São Bento, nº 723",
          "normalized_address": "Estrada Municipal São Bento, nº 723 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58284,
          "longitude": -47.18092,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 793,
        "indicacao_id": 293,
        "latitude": -22.58284,
        "longitude": -47.18092,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 723",
        "normalized_address": "Estrada Municipal São Bento, nº 723 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 293,
          "numero": 393,
          "ano": 2022,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Bairro São Bento.",
          "autor": "Julia Oliveira",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 294,
    "sapl_id": 1294,
    "numero": 394,
    "ano": 2021,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Parque das Flores.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "15/07/2021",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 294,
        "indicacao_id": 294,
        "raw_text": "Rua José Amaro Rodrigues, nº 734",
        "street": "Rua José Amaro Rodrigues",
        "number": "734",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 794,
          "indicacao_id": 294,
          "endereco_id": 294,
          "raw_address": "Rua José Amaro Rodrigues, nº 734",
          "normalized_address": "Rua José Amaro Rodrigues, nº 734 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.58058,
          "longitude": -47.16494,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 794,
        "indicacao_id": 294,
        "latitude": -22.58058,
        "longitude": -47.16494,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 734",
        "normalized_address": "Rua José Amaro Rodrigues, nº 734 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 294,
          "numero": 394,
          "ano": 2021,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Parque das Flores.",
          "autor": "Fernanda Freitas",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 295,
    "sapl_id": 1295,
    "numero": 395,
    "ano": 2024,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Blumenau.",
    "autor": "Bianca Barros",
    "data_apresentacao": "18/12/2024",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 295,
        "indicacao_id": 295,
        "raw_text": "Rua Joinville",
        "street": "Rua Joinville",
        "number": null,
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 795,
          "indicacao_id": 295,
          "endereco_id": 295,
          "raw_address": "Rua Joinville",
          "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57624,
          "longitude": -47.17988,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 795,
        "indicacao_id": 295,
        "latitude": -22.57624,
        "longitude": -47.17988,
        "is_approximate": true,
        "raw_address": "Rua Joinville",
        "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 295,
          "numero": 395,
          "ano": 2024,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Blumenau.",
          "autor": "Bianca Barros",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 296,
    "sapl_id": 1296,
    "numero": 396,
    "ano": 2023,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Planalto.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "21/05/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 296,
        "indicacao_id": 296,
        "raw_text": "Rua dos Ipês, nº 756",
        "street": "Rua dos Ipês",
        "number": "756",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 796,
          "indicacao_id": 296,
          "endereco_id": 296,
          "raw_address": "Rua dos Ipês, nº 756",
          "normalized_address": "Rua dos Ipês, nº 756 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56698,
          "longitude": -47.1689,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 796,
        "indicacao_id": 296,
        "latitude": -22.56698,
        "longitude": -47.1689,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 756",
        "normalized_address": "Rua dos Ipês, nº 756 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 296,
          "numero": 396,
          "ano": 2023,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Planalto.",
          "autor": "Rafael Teixeira",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 297,
    "sapl_id": 1297,
    "numero": 397,
    "ano": 2022,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Coração Criança.",
    "autor": "Alex Andrade",
    "data_apresentacao": "24/10/2022",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 297,
        "indicacao_id": 297,
        "raw_text": "Rua Pedro Rosa, nº 767",
        "street": "Rua Pedro Rosa",
        "number": "767",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 797,
          "indicacao_id": 297,
          "endereco_id": 297,
          "raw_address": "Rua Pedro Rosa, nº 767",
          "normalized_address": "Rua Pedro Rosa, nº 767 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56314,
          "longitude": -47.17734,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 797,
        "indicacao_id": 297,
        "latitude": -22.56314,
        "longitude": -47.17734,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 767",
        "normalized_address": "Rua Pedro Rosa, nº 767 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 297,
          "numero": 397,
          "ano": 2022,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Coração Criança.",
          "autor": "Alex Andrade",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 298,
    "sapl_id": 1298,
    "numero": 398,
    "ano": 2021,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Centro.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "27/03/2021",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 298,
        "indicacao_id": 298,
        "raw_text": "Rua XV de Novembro, nº 778",
        "street": "Rua XV de Novembro",
        "number": "778",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 798,
          "indicacao_id": 298,
          "endereco_id": 298,
          "raw_address": "Rua XV de Novembro, nº 778",
          "normalized_address": "Rua XV de Novembro, nº 778 - Centro, Artur Nogueira - SP",
          "latitude": -22.5708,
          "longitude": -47.17086,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 798,
        "indicacao_id": 298,
        "latitude": -22.5708,
        "longitude": -47.17086,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 778",
        "normalized_address": "Rua XV de Novembro, nº 778 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 298,
          "numero": 398,
          "ano": 2021,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Centro.",
          "autor": "Gabriel Gomes",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 299,
    "sapl_id": 1299,
    "numero": 399,
    "ano": 2024,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Sacilotto II.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "02/08/2024",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 299,
        "indicacao_id": 299,
        "raw_text": "Rua Maria Marson Aresi, nº 789",
        "street": "Rua Maria Marson Aresi",
        "number": "789",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 799,
          "indicacao_id": 299,
          "endereco_id": 299,
          "raw_address": "Rua Maria Marson Aresi, nº 789",
          "normalized_address": "Rua Maria Marson Aresi, nº 789 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58154,
          "longitude": -47.1723,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 799,
        "indicacao_id": 299,
        "latitude": -22.58154,
        "longitude": -47.1723,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 789",
        "normalized_address": "Rua Maria Marson Aresi, nº 789 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 299,
          "numero": 399,
          "ano": 2024,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Sacilotto II.",
          "autor": "Igor Nascimento",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 300,
    "sapl_id": 1300,
    "numero": 400,
    "ano": 2023,
    "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Itamaraty.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "05/01/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 300,
        "indicacao_id": 300,
        "raw_text": "Rua Goiás",
        "street": "Rua Goiás",
        "number": null,
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 800,
          "indicacao_id": 300,
          "endereco_id": 300,
          "raw_address": "Rua Goiás",
          "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5822,
          "longitude": -47.17032,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 800,
        "indicacao_id": 300,
        "latitude": -22.5822,
        "longitude": -47.17032,
        "is_approximate": true,
        "raw_address": "Rua Goiás",
        "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 300,
          "numero": 400,
          "ano": 2023,
          "ementa": "Solicita apoio para feira cultural e apresentações comunitárias abertas no Jardim Itamaraty.",
          "autor": "Marina Ribeiro",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 301,
    "sapl_id": 1301,
    "numero": 401,
    "ano": 2022,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Blumenau.",
    "autor": "Leandro Prado",
    "data_apresentacao": "08/06/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 301,
        "indicacao_id": 301,
        "raw_text": "Rua Joinville, nº 811",
        "street": "Rua Joinville",
        "number": "811",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 801,
          "indicacao_id": 301,
          "endereco_id": 301,
          "raw_address": "Rua Joinville, nº 811",
          "normalized_address": "Rua Joinville, nº 811 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57894,
          "longitude": -47.18384,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 801,
        "indicacao_id": 301,
        "latitude": -22.57894,
        "longitude": -47.18384,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 811",
        "normalized_address": "Rua Joinville, nº 811 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 301,
          "numero": 401,
          "ano": 2022,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Blumenau.",
          "autor": "Leandro Prado",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 302,
    "sapl_id": 1302,
    "numero": 402,
    "ano": 2021,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Planalto.",
    "autor": "Bianca Barros",
    "data_apresentacao": "11/11/2021",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 302,
        "indicacao_id": 302,
        "raw_text": "Rua dos Ipês, nº 822",
        "street": "Rua dos Ipês",
        "number": "822",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 802,
          "indicacao_id": 302,
          "endereco_id": 302,
          "raw_address": "Rua dos Ipês, nº 822",
          "normalized_address": "Rua dos Ipês, nº 822 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5641,
          "longitude": -47.16728,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 802,
        "indicacao_id": 302,
        "latitude": -22.5641,
        "longitude": -47.16728,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 822",
        "normalized_address": "Rua dos Ipês, nº 822 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 302,
          "numero": 402,
          "ano": 2021,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Planalto.",
          "autor": "Bianca Barros",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 303,
    "sapl_id": 1303,
    "numero": 403,
    "ano": 2024,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Coração Criança.",
    "autor": "Caio Campos",
    "data_apresentacao": "14/04/2024",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 303,
        "indicacao_id": 303,
        "raw_text": "Rua Pedro Rosa, nº 833",
        "street": "Rua Pedro Rosa",
        "number": "833",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 803,
          "indicacao_id": 303,
          "endereco_id": 303,
          "raw_address": "Rua Pedro Rosa, nº 833",
          "normalized_address": "Rua Pedro Rosa, nº 833 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56584,
          "longitude": -47.1813,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 803,
        "indicacao_id": 303,
        "latitude": -22.56584,
        "longitude": -47.1813,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 833",
        "normalized_address": "Rua Pedro Rosa, nº 833 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 303,
          "numero": 403,
          "ano": 2024,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Coração Criança.",
          "autor": "Caio Campos",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 304,
    "sapl_id": 1304,
    "numero": 404,
    "ano": 2023,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Centro.",
    "autor": "Helena Martins",
    "data_apresentacao": "17/09/2023",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 304,
        "indicacao_id": 304,
        "raw_text": "Rua XV de Novembro, nº 844",
        "street": "Rua XV de Novembro",
        "number": "844",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 804,
          "indicacao_id": 304,
          "endereco_id": 304,
          "raw_address": "Rua XV de Novembro, nº 844",
          "normalized_address": "Rua XV de Novembro, nº 844 - Centro, Artur Nogueira - SP",
          "latitude": -22.5735,
          "longitude": -47.16924,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 804,
        "indicacao_id": 304,
        "latitude": -22.5735,
        "longitude": -47.16924,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 844",
        "normalized_address": "Rua XV de Novembro, nº 844 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 304,
          "numero": 404,
          "ano": 2023,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Centro.",
          "autor": "Helena Martins",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 305,
    "sapl_id": 1305,
    "numero": 405,
    "ano": 2022,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Sacilotto II.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "20/02/2022",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 305,
        "indicacao_id": 305,
        "raw_text": "Rua Maria Marson Aresi",
        "street": "Rua Maria Marson Aresi",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 805,
          "indicacao_id": 305,
          "endereco_id": 305,
          "raw_address": "Rua Maria Marson Aresi",
          "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.57866,
          "longitude": -47.17626,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 805,
        "indicacao_id": 305,
        "latitude": -22.57866,
        "longitude": -47.17626,
        "is_approximate": true,
        "raw_address": "Rua Maria Marson Aresi",
        "normalized_address": "Rua Maria Marson Aresi - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 305,
          "numero": 405,
          "ano": 2022,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Sacilotto II.",
          "autor": "Fernanda Freitas",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 306,
    "sapl_id": 1306,
    "numero": 406,
    "ano": 2021,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Itamaraty.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "23/07/2021",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 306,
        "indicacao_id": 306,
        "raw_text": "Rua Goiás, nº 866",
        "street": "Rua Goiás",
        "number": "866",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 806,
          "indicacao_id": 306,
          "endereco_id": 306,
          "raw_address": "Rua Goiás, nº 866",
          "normalized_address": "Rua Goiás, nº 866 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.5849,
          "longitude": -47.1687,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 806,
        "indicacao_id": 306,
        "latitude": -22.5849,
        "longitude": -47.1687,
        "is_approximate": false,
        "raw_address": "Rua Goiás, nº 866",
        "normalized_address": "Rua Goiás, nº 866 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 306,
          "numero": 406,
          "ano": 2021,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Itamaraty.",
          "autor": "Eduardo Esteves",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 307,
    "sapl_id": 1307,
    "numero": 407,
    "ano": 2024,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Planalto.",
    "autor": "Patricia Silva",
    "data_apresentacao": "26/12/2024",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 307,
        "indicacao_id": 307,
        "raw_text": "Rua das Hortênsias, nº 877",
        "street": "Rua das Hortênsias",
        "number": "877",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 807,
          "indicacao_id": 307,
          "endereco_id": 307,
          "raw_address": "Rua das Hortênsias, nº 877",
          "normalized_address": "Rua das Hortênsias, nº 877 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56456,
          "longitude": -47.16772,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 807,
        "indicacao_id": 307,
        "latitude": -22.56456,
        "longitude": -47.16772,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 877",
        "normalized_address": "Rua das Hortênsias, nº 877 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 307,
          "numero": 407,
          "ano": 2024,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Planalto.",
          "autor": "Patricia Silva",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 308,
    "sapl_id": 1308,
    "numero": 408,
    "ano": 2023,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Conservani.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "01/05/2023",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 308,
        "indicacao_id": 308,
        "raw_text": "Rua Santa Gertrudes, nº 888",
        "street": "Rua Santa Gertrudes",
        "number": "888",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 808,
          "indicacao_id": 308,
          "endereco_id": 308,
          "raw_address": "Rua Santa Gertrudes, nº 888",
          "normalized_address": "Rua Santa Gertrudes, nº 888 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.5708,
          "longitude": -47.15866,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 808,
        "indicacao_id": 308,
        "latitude": -22.5708,
        "longitude": -47.15866,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 888",
        "normalized_address": "Rua Santa Gertrudes, nº 888 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 308,
          "numero": 408,
          "ano": 2023,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Conservani.",
          "autor": "Nicolas Rocha",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 309,
    "sapl_id": 1309,
    "numero": 409,
    "ano": 2022,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Centro.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "04/10/2022",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 309,
        "indicacao_id": 309,
        "raw_text": "Rua 7 de Setembro, nº 899",
        "street": "Rua 7 de Setembro",
        "number": "899",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 809,
          "indicacao_id": 309,
          "endereco_id": 309,
          "raw_address": "Rua 7 de Setembro, nº 899",
          "normalized_address": "Rua 7 de Setembro, nº 899 - Centro, Artur Nogueira - SP",
          "latitude": -22.57146,
          "longitude": -47.16918,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 809,
        "indicacao_id": 309,
        "latitude": -22.57146,
        "longitude": -47.16918,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 899",
        "normalized_address": "Rua 7 de Setembro, nº 899 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 309,
          "numero": 409,
          "ano": 2022,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Centro.",
          "autor": "Julia Oliveira",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 310,
    "sapl_id": 1310,
    "numero": 410,
    "ano": 2021,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Sacilotto II.",
    "autor": "Diana Dias",
    "data_apresentacao": "07/03/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 310,
        "indicacao_id": 310,
        "raw_text": "Rua Reinaldo Stein",
        "street": "Rua Reinaldo Stein",
        "number": null,
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 810,
          "indicacao_id": 310,
          "endereco_id": 310,
          "raw_address": "Rua Reinaldo Stein",
          "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5827,
          "longitude": -47.1767,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 810,
        "indicacao_id": 310,
        "latitude": -22.5827,
        "longitude": -47.1767,
        "is_approximate": true,
        "raw_address": "Rua Reinaldo Stein",
        "normalized_address": "Rua Reinaldo Stein - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 310,
          "numero": 410,
          "ano": 2021,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Sacilotto II.",
          "autor": "Diana Dias",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 311,
    "sapl_id": 1311,
    "numero": 411,
    "ano": 2024,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Bairro São Bento.",
    "autor": "Julia Oliveira",
    "data_apresentacao": "10/08/2024",
    "thematic_category": "INFRAESTRUTURA_VIARIA",
    "categoria_id": 1,
    "categoria": {
      "id": 1,
      "nome": "Infraestrutura e Vias"
    },
    "enderecos_extraidos": [
      {
        "id": 311,
        "indicacao_id": 311,
        "raw_text": "Estrada Municipal São Bento, nº 71",
        "street": "Estrada Municipal São Bento",
        "number": "71",
        "bairro": "Bairro São Bento",
        "status": "geocodificado",
        "geo_pin": {
          "id": 811,
          "indicacao_id": 311,
          "endereco_id": 311,
          "raw_address": "Estrada Municipal São Bento, nº 71",
          "normalized_address": "Estrada Municipal São Bento, nº 71 - Bairro São Bento, Artur Nogueira - SP",
          "latitude": -22.58536,
          "longitude": -47.18164,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 811,
        "indicacao_id": 311,
        "latitude": -22.58536,
        "longitude": -47.18164,
        "is_approximate": false,
        "raw_address": "Estrada Municipal São Bento, nº 71",
        "normalized_address": "Estrada Municipal São Bento, nº 71 - Bairro São Bento, Artur Nogueira - SP",
        "indicacao": {
          "id": 311,
          "numero": 411,
          "ano": 2024,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Bairro São Bento.",
          "autor": "Julia Oliveira",
          "thematic_category": "INFRAESTRUTURA_VIARIA",
          "categoria": {
            "id": 1,
            "nome": "Infraestrutura e Vias"
          }
        }
      }
    ]
  },
  {
    "id": 312,
    "sapl_id": 1312,
    "numero": 412,
    "ano": 2023,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Parque das Flores.",
    "autor": "Leandro Prado",
    "data_apresentacao": "13/01/2023",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 312,
        "indicacao_id": 312,
        "raw_text": "Rua José Amaro Rodrigues, nº 82",
        "street": "Rua José Amaro Rodrigues",
        "number": "82",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 812,
          "indicacao_id": 312,
          "endereco_id": 312,
          "raw_address": "Rua José Amaro Rodrigues, nº 82",
          "normalized_address": "Rua José Amaro Rodrigues, nº 82 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57752,
          "longitude": -47.16566,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 812,
        "indicacao_id": 312,
        "latitude": -22.57752,
        "longitude": -47.16566,
        "is_approximate": false,
        "raw_address": "Rua José Amaro Rodrigues, nº 82",
        "normalized_address": "Rua José Amaro Rodrigues, nº 82 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 312,
          "numero": 412,
          "ano": 2023,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Parque das Flores.",
          "autor": "Leandro Prado",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 313,
    "sapl_id": 1313,
    "numero": 413,
    "ano": 2022,
    "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Blumenau.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "16/06/2022",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 313,
        "indicacao_id": 313,
        "raw_text": "Rua Joinville, nº 93",
        "street": "Rua Joinville",
        "number": "93",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 813,
          "indicacao_id": 313,
          "endereco_id": 313,
          "raw_address": "Rua Joinville, nº 93",
          "normalized_address": "Rua Joinville, nº 93 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57876,
          "longitude": -47.1806,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 813,
        "indicacao_id": 313,
        "latitude": -22.57876,
        "longitude": -47.1806,
        "is_approximate": false,
        "raw_address": "Rua Joinville, nº 93",
        "normalized_address": "Rua Joinville, nº 93 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 313,
          "numero": 413,
          "ano": 2022,
          "ementa": "Indica atendimento social itinerante e suporte comunitário às famílias do Jardim Blumenau.",
          "autor": "Rafael Teixeira",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 314,
    "sapl_id": 1314,
    "numero": 414,
    "ano": 2023,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Coração Criança.",
    "autor": "Helena Martins",
    "data_apresentacao": "19/11/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 314,
        "indicacao_id": 314,
        "raw_text": "Rua Antônio Tagliari, nº 104",
        "street": "Rua Antônio Tagliari",
        "number": "104",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 814,
          "indicacao_id": 314,
          "endereco_id": 314,
          "raw_address": "Rua Antônio Tagliari, nº 104",
          "normalized_address": "Rua Antônio Tagliari, nº 104 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56092,
          "longitude": -47.17962,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 814,
        "indicacao_id": 314,
        "latitude": -22.56092,
        "longitude": -47.17962,
        "is_approximate": false,
        "raw_address": "Rua Antônio Tagliari, nº 104",
        "normalized_address": "Rua Antônio Tagliari, nº 104 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 314,
          "numero": 414,
          "ano": 2023,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Coração Criança.",
          "autor": "Helena Martins",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 315,
    "sapl_id": 1315,
    "numero": 415,
    "ano": 2022,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Centro.",
    "autor": "Alex Andrade",
    "data_apresentacao": "22/04/2022",
    "thematic_category": "MEIO_AMBIENTE",
    "categoria_id": 7,
    "categoria": {
      "id": 7,
      "nome": "Meio Ambiente"
    },
    "enderecos_extraidos": [
      {
        "id": 315,
        "indicacao_id": 315,
        "raw_text": "Avenida Fernando Arens",
        "street": "Avenida Fernando Arens",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 815,
          "indicacao_id": 315,
          "endereco_id": 315,
          "raw_address": "Avenida Fernando Arens",
          "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
          "latitude": -22.57356,
          "longitude": -47.17136,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 815,
        "indicacao_id": 315,
        "latitude": -22.57356,
        "longitude": -47.17136,
        "is_approximate": true,
        "raw_address": "Avenida Fernando Arens",
        "normalized_address": "Avenida Fernando Arens - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 315,
          "numero": 415,
          "ano": 2022,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Centro.",
          "autor": "Alex Andrade",
          "thematic_category": "MEIO_AMBIENTE",
          "categoria": {
            "id": 7,
            "nome": "Meio Ambiente"
          }
        }
      }
    ]
  },
  {
    "id": 316,
    "sapl_id": 1316,
    "numero": 416,
    "ano": 2021,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Parque das Flores.",
    "autor": "Diana Dias",
    "data_apresentacao": "25/09/2021",
    "thematic_category": "SAUDE",
    "categoria_id": 8,
    "categoria": {
      "id": 8,
      "nome": "Saúde"
    },
    "enderecos_extraidos": [
      {
        "id": 316,
        "indicacao_id": 316,
        "raw_text": "Av. Dr. Roberto Silva, nº 126",
        "street": "Av. Dr. Roberto Silva",
        "number": "126",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 816,
          "indicacao_id": 316,
          "endereco_id": 316,
          "raw_address": "Av. Dr. Roberto Silva, nº 126",
          "normalized_address": "Av. Dr. Roberto Silva, nº 126 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57682,
          "longitude": -47.16708,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 816,
        "indicacao_id": 316,
        "latitude": -22.57682,
        "longitude": -47.16708,
        "is_approximate": false,
        "raw_address": "Av. Dr. Roberto Silva, nº 126",
        "normalized_address": "Av. Dr. Roberto Silva, nº 126 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 316,
          "numero": 416,
          "ano": 2021,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Parque das Flores.",
          "autor": "Diana Dias",
          "thematic_category": "SAUDE",
          "categoria": {
            "id": 8,
            "nome": "Saúde"
          }
        }
      }
    ]
  },
  {
    "id": 317,
    "sapl_id": 1317,
    "numero": 417,
    "ano": 2024,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Itamaraty.",
    "autor": "Fernanda Freitas",
    "data_apresentacao": "28/02/2024",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 317,
        "indicacao_id": 317,
        "raw_text": "Rua Itamaraty, nº 137",
        "street": "Rua Itamaraty",
        "number": "137",
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 817,
          "indicacao_id": 317,
          "endereco_id": 317,
          "raw_address": "Rua Itamaraty, nº 137",
          "normalized_address": "Rua Itamaraty, nº 137 - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58048,
          "longitude": -47.16702,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 817,
        "indicacao_id": 317,
        "latitude": -22.58048,
        "longitude": -47.16702,
        "is_approximate": false,
        "raw_address": "Rua Itamaraty, nº 137",
        "normalized_address": "Rua Itamaraty, nº 137 - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 317,
          "numero": 417,
          "ano": 2024,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Itamaraty.",
          "autor": "Fernanda Freitas",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 318,
    "sapl_id": 1318,
    "numero": 418,
    "ano": 2023,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Planalto.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "03/07/2023",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 318,
        "indicacao_id": 318,
        "raw_text": "Rua das Margaridas, nº 148",
        "street": "Rua das Margaridas",
        "number": "148",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 818,
          "indicacao_id": 318,
          "endereco_id": 318,
          "raw_address": "Rua das Margaridas, nº 148",
          "normalized_address": "Rua das Margaridas, nº 148 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56472,
          "longitude": -47.17004,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 818,
        "indicacao_id": 318,
        "latitude": -22.56472,
        "longitude": -47.17004,
        "is_approximate": false,
        "raw_address": "Rua das Margaridas, nº 148",
        "normalized_address": "Rua das Margaridas, nº 148 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 318,
          "numero": 418,
          "ano": 2023,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Planalto.",
          "autor": "Igor Nascimento",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 319,
    "sapl_id": 1319,
    "numero": 419,
    "ano": 2022,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Conservani.",
    "autor": "Caio Campos",
    "data_apresentacao": "06/12/2022",
    "thematic_category": "LIMPEZA_ZELADORIA",
    "categoria_id": 6,
    "categoria": {
      "id": 6,
      "nome": "Limpeza e Zeladoria"
    },
    "enderecos_extraidos": [
      {
        "id": 319,
        "indicacao_id": 319,
        "raw_text": "Rua Expedicionários, nº 159",
        "street": "Rua Expedicionários",
        "number": "159",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 819,
          "indicacao_id": 319,
          "endereco_id": 319,
          "raw_address": "Rua Expedicionários, nº 159",
          "normalized_address": "Rua Expedicionários, nº 159 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.56638,
          "longitude": -47.15948,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 819,
        "indicacao_id": 319,
        "latitude": -22.56638,
        "longitude": -47.15948,
        "is_approximate": false,
        "raw_address": "Rua Expedicionários, nº 159",
        "normalized_address": "Rua Expedicionários, nº 159 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 319,
          "numero": 419,
          "ano": 2022,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Conservani.",
          "autor": "Caio Campos",
          "thematic_category": "LIMPEZA_ZELADORIA",
          "categoria": {
            "id": 6,
            "nome": "Limpeza e Zeladoria"
          }
        }
      }
    ]
  },
  {
    "id": 320,
    "sapl_id": 1320,
    "numero": 420,
    "ano": 2021,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Centro.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "09/05/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 320,
        "indicacao_id": 320,
        "raw_text": "Rua Duque de Caxias",
        "street": "Rua Duque de Caxias",
        "number": null,
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 820,
          "indicacao_id": 320,
          "endereco_id": 320,
          "raw_address": "Rua Duque de Caxias",
          "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
          "latitude": -22.57112,
          "longitude": -47.174,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 820,
        "indicacao_id": 320,
        "latitude": -22.57112,
        "longitude": -47.174,
        "is_approximate": true,
        "raw_address": "Rua Duque de Caxias",
        "normalized_address": "Rua Duque de Caxias - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 320,
          "numero": 420,
          "ano": 2021,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Centro.",
          "autor": "Gabriel Gomes",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 321,
    "sapl_id": 1321,
    "numero": 421,
    "ano": 2024,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Sacilotto II.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "12/10/2024",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 321,
        "indicacao_id": 321,
        "raw_text": "Rua Santo de Faveri, nº 181",
        "street": "Rua Santo de Faveri",
        "number": "181",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 821,
          "indicacao_id": 321,
          "endereco_id": 321,
          "raw_address": "Rua Santo de Faveri, nº 181",
          "normalized_address": "Rua Santo de Faveri, nº 181 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58178,
          "longitude": -47.17902,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 821,
        "indicacao_id": 321,
        "latitude": -22.58178,
        "longitude": -47.17902,
        "is_approximate": false,
        "raw_address": "Rua Santo de Faveri, nº 181",
        "normalized_address": "Rua Santo de Faveri, nº 181 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 321,
          "numero": 421,
          "ano": 2024,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Sacilotto II.",
          "autor": "Nicolas Rocha",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 322,
    "sapl_id": 1322,
    "numero": 422,
    "ano": 2023,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Residencial Bela Vista.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "15/03/2023",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 322,
        "indicacao_id": 322,
        "raw_text": "Rua Bela Vista, nº 192",
        "street": "Rua Bela Vista",
        "number": "192",
        "bairro": "Residencial Bela Vista",
        "status": "geocodificado",
        "geo_pin": {
          "id": 822,
          "indicacao_id": 322,
          "endereco_id": 322,
          "raw_address": "Rua Bela Vista, nº 192",
          "normalized_address": "Rua Bela Vista, nº 192 - Residencial Bela Vista, Artur Nogueira - SP",
          "latitude": -22.56252,
          "longitude": -47.17146,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 822,
        "indicacao_id": 322,
        "latitude": -22.56252,
        "longitude": -47.17146,
        "is_approximate": false,
        "raw_address": "Rua Bela Vista, nº 192",
        "normalized_address": "Rua Bela Vista, nº 192 - Residencial Bela Vista, Artur Nogueira - SP",
        "indicacao": {
          "id": 322,
          "numero": 422,
          "ano": 2023,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Residencial Bela Vista.",
          "autor": "Marina Ribeiro",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 323,
    "sapl_id": 1323,
    "numero": 423,
    "ano": 2022,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Parque das Flores.",
    "autor": "Bianca Barros",
    "data_apresentacao": "18/08/2022",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 323,
        "indicacao_id": 323,
        "raw_text": "Rua Humberto Rossetti, nº 203",
        "street": "Rua Humberto Rossetti",
        "number": "203",
        "bairro": "Parque das Flores",
        "status": "geocodificado",
        "geo_pin": {
          "id": 823,
          "indicacao_id": 323,
          "endereco_id": 323,
          "raw_address": "Rua Humberto Rossetti, nº 203",
          "normalized_address": "Rua Humberto Rossetti, nº 203 - Parque das Flores, Artur Nogueira - SP",
          "latitude": -22.57818,
          "longitude": -47.16698,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 823,
        "indicacao_id": 323,
        "latitude": -22.57818,
        "longitude": -47.16698,
        "is_approximate": false,
        "raw_address": "Rua Humberto Rossetti, nº 203",
        "normalized_address": "Rua Humberto Rossetti, nº 203 - Parque das Flores, Artur Nogueira - SP",
        "indicacao": {
          "id": 323,
          "numero": 423,
          "ano": 2022,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Parque das Flores.",
          "autor": "Bianca Barros",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 324,
    "sapl_id": 1324,
    "numero": 424,
    "ano": 2021,
    "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Blumenau.",
    "autor": "Patricia Silva",
    "data_apresentacao": "21/01/2021",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 324,
        "indicacao_id": 324,
        "raw_text": "Rua Blumenau, nº 214",
        "street": "Rua Blumenau",
        "number": "214",
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 824,
          "indicacao_id": 324,
          "endereco_id": 324,
          "raw_address": "Rua Blumenau, nº 214",
          "normalized_address": "Rua Blumenau, nº 214 - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57384,
          "longitude": -47.17892,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 824,
        "indicacao_id": 324,
        "latitude": -22.57384,
        "longitude": -47.17892,
        "is_approximate": false,
        "raw_address": "Rua Blumenau, nº 214",
        "normalized_address": "Rua Blumenau, nº 214 - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 324,
          "numero": 424,
          "ano": 2021,
          "ementa": "Solicita adequações prediais e otimização dos serviços de atendimento ao público no Jardim Blumenau.",
          "autor": "Patricia Silva",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  },
  {
    "id": 325,
    "sapl_id": 1325,
    "numero": 425,
    "ano": 2022,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Blumenau.",
    "autor": "Eduardo Esteves",
    "data_apresentacao": "24/06/2022",
    "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
    "categoria_id": 13,
    "categoria": {
      "id": 13,
      "nome": "Assistência Social e Habitação"
    },
    "enderecos_extraidos": [
      {
        "id": 325,
        "indicacao_id": 325,
        "raw_text": "Rua Joinville",
        "street": "Rua Joinville",
        "number": null,
        "bairro": "Jardim Blumenau",
        "status": "geocodificado",
        "geo_pin": {
          "id": 825,
          "indicacao_id": 325,
          "endereco_id": 325,
          "raw_address": "Rua Joinville",
          "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
          "latitude": -22.57858,
          "longitude": -47.18294,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 825,
        "indicacao_id": 325,
        "latitude": -22.57858,
        "longitude": -47.18294,
        "is_approximate": true,
        "raw_address": "Rua Joinville",
        "normalized_address": "Rua Joinville - Jardim Blumenau, Artur Nogueira - SP",
        "indicacao": {
          "id": 325,
          "numero": 425,
          "ano": 2022,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Blumenau.",
          "autor": "Eduardo Esteves",
          "thematic_category": "ASSISTENCIA_SOCIAL_HABITACAO",
          "categoria": {
            "id": 13,
            "nome": "Assistência Social e Habitação"
          }
        }
      }
    ]
  },
  {
    "id": 326,
    "sapl_id": 1326,
    "numero": 426,
    "ano": 2021,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Planalto.",
    "autor": "Gabriel Gomes",
    "data_apresentacao": "27/11/2021",
    "thematic_category": "ILUMINACAO_PUBLICA",
    "categoria_id": 4,
    "categoria": {
      "id": 4,
      "nome": "Iluminação Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 326,
        "indicacao_id": 326,
        "raw_text": "Rua dos Ipês, nº 236",
        "street": "Rua dos Ipês",
        "number": "236",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 826,
          "indicacao_id": 326,
          "endereco_id": 326,
          "raw_address": "Rua dos Ipês, nº 236",
          "normalized_address": "Rua dos Ipês, nº 236 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.56374,
          "longitude": -47.16638,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 826,
        "indicacao_id": 326,
        "latitude": -22.56374,
        "longitude": -47.16638,
        "is_approximate": false,
        "raw_address": "Rua dos Ipês, nº 236",
        "normalized_address": "Rua dos Ipês, nº 236 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 326,
          "numero": 426,
          "ano": 2021,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Planalto.",
          "autor": "Gabriel Gomes",
          "thematic_category": "ILUMINACAO_PUBLICA",
          "categoria": {
            "id": 4,
            "nome": "Iluminação Pública"
          }
        }
      }
    ]
  },
  {
    "id": 327,
    "sapl_id": 1327,
    "numero": 427,
    "ano": 2024,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Coração Criança.",
    "autor": "Leandro Prado",
    "data_apresentacao": "02/04/2024",
    "thematic_category": "TRANSITO_SINALIZACAO",
    "categoria_id": 2,
    "categoria": {
      "id": 2,
      "nome": "Trânsito e Sinalização"
    },
    "enderecos_extraidos": [
      {
        "id": 327,
        "indicacao_id": 327,
        "raw_text": "Rua Pedro Rosa, nº 247",
        "street": "Rua Pedro Rosa",
        "number": "247",
        "bairro": "Coração Criança",
        "status": "geocodificado",
        "geo_pin": {
          "id": 827,
          "indicacao_id": 327,
          "endereco_id": 327,
          "raw_address": "Rua Pedro Rosa, nº 247",
          "normalized_address": "Rua Pedro Rosa, nº 247 - Coração Criança, Artur Nogueira - SP",
          "latitude": -22.56548,
          "longitude": -47.1804,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 827,
        "indicacao_id": 327,
        "latitude": -22.56548,
        "longitude": -47.1804,
        "is_approximate": false,
        "raw_address": "Rua Pedro Rosa, nº 247",
        "normalized_address": "Rua Pedro Rosa, nº 247 - Coração Criança, Artur Nogueira - SP",
        "indicacao": {
          "id": 327,
          "numero": 427,
          "ano": 2024,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Coração Criança.",
          "autor": "Leandro Prado",
          "thematic_category": "TRANSITO_SINALIZACAO",
          "categoria": {
            "id": 2,
            "nome": "Trânsito e Sinalização"
          }
        }
      }
    ]
  },
  {
    "id": 328,
    "sapl_id": 1328,
    "numero": 428,
    "ano": 2023,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Centro.",
    "autor": "Nicolas Rocha",
    "data_apresentacao": "05/09/2023",
    "thematic_category": "CULTURA_EVENTOS",
    "categoria_id": 12,
    "categoria": {
      "id": 12,
      "nome": "Cultura e Eventos"
    },
    "enderecos_extraidos": [
      {
        "id": 328,
        "indicacao_id": 328,
        "raw_text": "Rua XV de Novembro, nº 258",
        "street": "Rua XV de Novembro",
        "number": "258",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 828,
          "indicacao_id": 328,
          "endereco_id": 328,
          "raw_address": "Rua XV de Novembro, nº 258",
          "normalized_address": "Rua XV de Novembro, nº 258 - Centro, Artur Nogueira - SP",
          "latitude": -22.57314,
          "longitude": -47.16834,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 828,
        "indicacao_id": 328,
        "latitude": -22.57314,
        "longitude": -47.16834,
        "is_approximate": false,
        "raw_address": "Rua XV de Novembro, nº 258",
        "normalized_address": "Rua XV de Novembro, nº 258 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 328,
          "numero": 428,
          "ano": 2023,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Centro.",
          "autor": "Nicolas Rocha",
          "thematic_category": "CULTURA_EVENTOS",
          "categoria": {
            "id": 12,
            "nome": "Cultura e Eventos"
          }
        }
      }
    ]
  },
  {
    "id": 329,
    "sapl_id": 1329,
    "numero": 429,
    "ano": 2022,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Sacilotto II.",
    "autor": "Helena Martins",
    "data_apresentacao": "08/02/2022",
    "thematic_category": "TRANSPORTE_PUBLICO",
    "categoria_id": 3,
    "categoria": {
      "id": 3,
      "nome": "Transporte Público"
    },
    "enderecos_extraidos": [
      {
        "id": 329,
        "indicacao_id": 329,
        "raw_text": "Rua Maria Marson Aresi, nº 269",
        "street": "Rua Maria Marson Aresi",
        "number": "269",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 829,
          "indicacao_id": 329,
          "endereco_id": 329,
          "raw_address": "Rua Maria Marson Aresi, nº 269",
          "normalized_address": "Rua Maria Marson Aresi, nº 269 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.5783,
          "longitude": -47.17536,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 829,
        "indicacao_id": 329,
        "latitude": -22.5783,
        "longitude": -47.17536,
        "is_approximate": false,
        "raw_address": "Rua Maria Marson Aresi, nº 269",
        "normalized_address": "Rua Maria Marson Aresi, nº 269 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 329,
          "numero": 429,
          "ano": 2022,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Sacilotto II.",
          "autor": "Helena Martins",
          "thematic_category": "TRANSPORTE_PUBLICO",
          "categoria": {
            "id": 3,
            "nome": "Transporte Público"
          }
        }
      }
    ]
  },
  {
    "id": 330,
    "sapl_id": 1330,
    "numero": 430,
    "ano": 2021,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Itamaraty.",
    "autor": "Marina Ribeiro",
    "data_apresentacao": "11/07/2021",
    "thematic_category": "ESPORTE_LAZER",
    "categoria_id": 10,
    "categoria": {
      "id": 10,
      "nome": "Esporte e Lazer"
    },
    "enderecos_extraidos": [
      {
        "id": 330,
        "indicacao_id": 330,
        "raw_text": "Rua Goiás",
        "street": "Rua Goiás",
        "number": null,
        "bairro": "Jardim Itamaraty",
        "status": "geocodificado",
        "geo_pin": {
          "id": 830,
          "indicacao_id": 330,
          "endereco_id": 330,
          "raw_address": "Rua Goiás",
          "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
          "latitude": -22.58454,
          "longitude": -47.1678,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 830,
        "indicacao_id": 330,
        "latitude": -22.58454,
        "longitude": -47.1678,
        "is_approximate": true,
        "raw_address": "Rua Goiás",
        "normalized_address": "Rua Goiás - Jardim Itamaraty, Artur Nogueira - SP",
        "indicacao": {
          "id": 330,
          "numero": 430,
          "ano": 2021,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Itamaraty.",
          "autor": "Marina Ribeiro",
          "thematic_category": "ESPORTE_LAZER",
          "categoria": {
            "id": 10,
            "nome": "Esporte e Lazer"
          }
        }
      }
    ]
  },
  {
    "id": 331,
    "sapl_id": 1331,
    "numero": 431,
    "ano": 2024,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Planalto.",
    "autor": "Patricia Silva",
    "data_apresentacao": "14/12/2024",
    "thematic_category": "ADMINISTRACAO",
    "categoria_id": 14,
    "categoria": {
      "id": 14,
      "nome": "Administração Pública"
    },
    "enderecos_extraidos": [
      {
        "id": 331,
        "indicacao_id": 331,
        "raw_text": "Rua das Hortênsias, nº 291",
        "street": "Rua das Hortênsias",
        "number": "291",
        "bairro": "Jardim Planalto",
        "status": "geocodificado",
        "geo_pin": {
          "id": 831,
          "indicacao_id": 331,
          "endereco_id": 331,
          "raw_address": "Rua das Hortênsias, nº 291",
          "normalized_address": "Rua das Hortênsias, nº 291 - Jardim Planalto, Artur Nogueira - SP",
          "latitude": -22.5642,
          "longitude": -47.16682,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 831,
        "indicacao_id": 331,
        "latitude": -22.5642,
        "longitude": -47.16682,
        "is_approximate": false,
        "raw_address": "Rua das Hortênsias, nº 291",
        "normalized_address": "Rua das Hortênsias, nº 291 - Jardim Planalto, Artur Nogueira - SP",
        "indicacao": {
          "id": 331,
          "numero": 431,
          "ano": 2024,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Planalto.",
          "autor": "Patricia Silva",
          "thematic_category": "ADMINISTRACAO",
          "categoria": {
            "id": 14,
            "nome": "Administração Pública"
          }
        }
      }
    ]
  },
  {
    "id": 332,
    "sapl_id": 1332,
    "numero": 432,
    "ano": 2023,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Conservani.",
    "autor": "Bianca Barros",
    "data_apresentacao": "17/05/2023",
    "thematic_category": "SANEAMENTO_AGUA",
    "categoria_id": 5,
    "categoria": {
      "id": 5,
      "nome": "Saneamento e Água"
    },
    "enderecos_extraidos": [
      {
        "id": 332,
        "indicacao_id": 332,
        "raw_text": "Rua Santa Gertrudes, nº 302",
        "street": "Rua Santa Gertrudes",
        "number": "302",
        "bairro": "Jardim Conservani",
        "status": "geocodificado",
        "geo_pin": {
          "id": 832,
          "indicacao_id": 332,
          "endereco_id": 332,
          "raw_address": "Rua Santa Gertrudes, nº 302",
          "normalized_address": "Rua Santa Gertrudes, nº 302 - Jardim Conservani, Artur Nogueira - SP",
          "latitude": -22.57044,
          "longitude": -47.16334,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 832,
        "indicacao_id": 332,
        "latitude": -22.57044,
        "longitude": -47.16334,
        "is_approximate": false,
        "raw_address": "Rua Santa Gertrudes, nº 302",
        "normalized_address": "Rua Santa Gertrudes, nº 302 - Jardim Conservani, Artur Nogueira - SP",
        "indicacao": {
          "id": 332,
          "numero": 432,
          "ano": 2023,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Conservani.",
          "autor": "Bianca Barros",
          "thematic_category": "SANEAMENTO_AGUA",
          "categoria": {
            "id": 5,
            "nome": "Saneamento e Água"
          }
        }
      }
    ]
  },
  {
    "id": 333,
    "sapl_id": 1333,
    "numero": 433,
    "ano": 2022,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Centro.",
    "autor": "Caio Campos",
    "data_apresentacao": "20/10/2022",
    "thematic_category": "SEGURANCA",
    "categoria_id": 11,
    "categoria": {
      "id": 11,
      "nome": "Segurança"
    },
    "enderecos_extraidos": [
      {
        "id": 333,
        "indicacao_id": 333,
        "raw_text": "Rua 7 de Setembro, nº 313",
        "street": "Rua 7 de Setembro",
        "number": "313",
        "bairro": "Centro",
        "status": "geocodificado",
        "geo_pin": {
          "id": 833,
          "indicacao_id": 333,
          "endereco_id": 333,
          "raw_address": "Rua 7 de Setembro, nº 313",
          "normalized_address": "Rua 7 de Setembro, nº 313 - Centro, Artur Nogueira - SP",
          "latitude": -22.5711,
          "longitude": -47.16828,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 833,
        "indicacao_id": 333,
        "latitude": -22.5711,
        "longitude": -47.16828,
        "is_approximate": false,
        "raw_address": "Rua 7 de Setembro, nº 313",
        "normalized_address": "Rua 7 de Setembro, nº 313 - Centro, Artur Nogueira - SP",
        "indicacao": {
          "id": 333,
          "numero": 433,
          "ano": 2022,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Centro.",
          "autor": "Caio Campos",
          "thematic_category": "SEGURANCA",
          "categoria": {
            "id": 11,
            "nome": "Segurança"
          }
        }
      }
    ]
  },
  {
    "id": 334,
    "sapl_id": 1334,
    "numero": 434,
    "ano": 2021,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Sacilotto II.",
    "autor": "Rafael Teixeira",
    "data_apresentacao": "23/03/2021",
    "thematic_category": "OUTROS",
    "categoria_id": 15,
    "categoria": {
      "id": 15,
      "nome": "Outros"
    },
    "enderecos_extraidos": [
      {
        "id": 334,
        "indicacao_id": 334,
        "raw_text": "Rua Reinaldo Stein, nº 324",
        "street": "Rua Reinaldo Stein",
        "number": "324",
        "bairro": "Jardim Sacilotto II",
        "status": "geocodificado",
        "geo_pin": {
          "id": 834,
          "indicacao_id": 334,
          "endereco_id": 334,
          "raw_address": "Rua Reinaldo Stein, nº 324",
          "normalized_address": "Rua Reinaldo Stein, nº 324 - Jardim Sacilotto II, Artur Nogueira - SP",
          "latitude": -22.58234,
          "longitude": -47.1758,
          "status": "geocodificado",
          "is_approximate": false
        }
      }
    ],
    "geo_pins": [
      {
        "id": 834,
        "indicacao_id": 334,
        "latitude": -22.58234,
        "longitude": -47.1758,
        "is_approximate": false,
        "raw_address": "Rua Reinaldo Stein, nº 324",
        "normalized_address": "Rua Reinaldo Stein, nº 324 - Jardim Sacilotto II, Artur Nogueira - SP",
        "indicacao": {
          "id": 334,
          "numero": 434,
          "ano": 2021,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Jardim Sacilotto II.",
          "autor": "Rafael Teixeira",
          "thematic_category": "OUTROS",
          "categoria": {
            "id": 15,
            "nome": "Outros"
          }
        }
      }
    ]
  },
  {
    "id": 335,
    "sapl_id": 1335,
    "numero": 435,
    "ano": 2024,
    "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Bairrinho.",
    "autor": "Igor Nascimento",
    "data_apresentacao": "26/08/2024",
    "thematic_category": "EDUCACAO",
    "categoria_id": 9,
    "categoria": {
      "id": 9,
      "nome": "Educação"
    },
    "enderecos_extraidos": [
      {
        "id": 335,
        "indicacao_id": 335,
        "raw_text": "Rodovia SP-107, Bairrinha",
        "street": "Rodovia SP-107",
        "number": null,
        "bairro": "Bairrinha",
        "status": "geocodificado",
        "geo_pin": {
          "id": 835,
          "indicacao_id": 335,
          "endereco_id": 335,
          "raw_address": "Rodovia SP-107, Bairrinha",
          "normalized_address": "Rodovia SP-107 - Bairrinho, Artur Nogueira - SP",
          "latitude": -22.585,
          "longitude": -47.18074,
          "status": "geocodificado",
          "is_approximate": true
        }
      }
    ],
    "geo_pins": [
      {
        "id": 835,
        "indicacao_id": 335,
        "latitude": -22.585,
        "longitude": -47.18074,
        "is_approximate": true,
        "raw_address": "Rodovia SP-107, Bairrinha",
        "normalized_address": "Rodovia SP-107 - Bairrinho, Artur Nogueira - SP",
        "indicacao": {
          "id": 335,
          "numero": 435,
          "ano": 2024,
          "ementa": "Indica providências e melhorias gerais nos serviços públicos municipais no Bairrinho.",
          "autor": "Igor Nascimento",
          "thematic_category": "EDUCACAO",
          "categoria": {
            "id": 9,
            "nome": "Educação"
          }
        }
      }
    ]
  }
];

export const MOCK_STATS = {
  "total_indicacoes": 235,
  "total_pins": 235,
  "pins_aproximados": 47,
  "autores": [
    "Alex Andrade",
    "Bianca Barros",
    "Caio Campos",
    "Diana Dias",
    "Eduardo Esteves",
    "Fernanda Freitas",
    "Gabriel Gomes",
    "Helena Martins",
    "Igor Nascimento",
    "Julia Oliveira",
    "Leandro Prado",
    "Marina Ribeiro",
    "Nicolas Rocha",
    "Patricia Silva",
    "Rafael Teixeira"
  ],
  "anos": [
    2026,
    2025,
    2024,
    2023,
    2022,
    2021
  ],
  "bairros": [
    "Bairrinho",
    "Bairro São Bento",
    "Centro",
    "Coração Criança",
    "Jardim Bela Vista",
    "Jardim Blumenau",
    "Jardim Conservani",
    "Jardim Faveri",
    "Jardim Itamaraty",
    "Jardim Planalto",
    "Jardim Sacilotto I",
    "Jardim Sacilotto II",
    "Parque das Flores"
  ],
  "demandas_por_ano": [
    { "ano": 2026, "count": 10 },
    { "ano": 2025, "count": 14 },
    { "ano": 2024, "count": 33 },
    { "ano": 2023, "count": 58 },
    { "ano": 2022, "count": 61 },
    { "ano": 2021, "count": 59 }
  ],
  "demandas_por_thematic_category": [
    {
      "category": "INFRAESTRUTURA_VIARIA",
      "count": 15
    },
    {
      "category": "TRANSITO_SINALIZACAO",
      "count": 16
    },
    {
      "category": "TRANSPORTE_PUBLICO",
      "count": 16
    },
    {
      "category": "ILUMINACAO_PUBLICA",
      "count": 16
    },
    {
      "category": "SANEAMENTO_AGUA",
      "count": 16
    },
    {
      "category": "LIMPEZA_ZELADORIA",
      "count": 15
    },
    {
      "category": "MEIO_AMBIENTE",
      "count": 15
    },
    {
      "category": "SAUDE",
      "count": 15
    },
    {
      "category": "EDUCACAO",
      "count": 16
    },
    {
      "category": "ESPORTE_LAZER",
      "count": 16
    },
    {
      "category": "SEGURANCA",
      "count": 16
    },
    {
      "category": "CULTURA_EVENTOS",
      "count": 16
    },
    {
      "category": "ASSISTENCIA_SOCIAL_HABITACAO",
      "count": 15
    },
    {
      "category": "ADMINISTRACAO",
      "count": 16
    },
    {
      "category": "OUTROS",
      "count": 16
    }
  ]
};

// ── Vitrine de casos de borda do card de indicação (apenas mock) ─────────────
// Coautoria (2, 3 e 5 autores) e indicações sem endereço/pin, posicionadas no
// início da lista para aparecerem na primeira página do painel.

const COAUTORIAS = {
  902: "Mário Silva, Julia Oliveira",
  903: "Fernanda Freitas, Caio Campos, Helena Martins",
  904: "Caio Campos, Diana Dias, Eduardo Esteves, Gabriel Gomes, Igor Nascimento",
};

MOCK_INDICACOES.forEach((ind) => {
  const autor = COAUTORIAS[ind.id];
  if (!autor) return;
  ind.autor = autor;
  (ind.geo_pins || []).forEach((p) => {
    if (p.indicacao) p.indicacao.autor = autor;
  });
});

const SEM_ENDERECO = [
  {
    // Sem endereço, sem bairro, autor único (tema municipal amplo)
    id: 905,
    sapl_id: 9905,
    numero: 5,
    ano: 2024,
    ementa:
      "Solicita estudo de viabilidade para ampliação do horário de atendimento das Unidades Básicas de Saúde do município até as 22h.",
    autor: "Patricia Silva",
    data_apresentacao: "22/05/2024",
    thematic_category: "SAUDE",
    enderecos_extraidos: [],
    geo_pins: [],
  },
  {
    // Sem endereço + coautoria
    id: 906,
    sapl_id: 9906,
    numero: 6,
    ano: 2024,
    ementa:
      "Solicita a realização de campanha municipal de vacinação antirrábica e castração gratuita de cães e gatos.",
    autor: "Bianca Barros, Nicolas Rocha",
    data_apresentacao: "03/06/2024",
    thematic_category: "MEIO_AMBIENTE",
    enderecos_extraidos: [],
    geo_pins: [],
  },
  {
    // Apenas bairro conhecido (fallback "Bairro X")
    id: 907,
    sapl_id: 9907,
    numero: 7,
    ano: 2024,
    ementa:
      "Solicita intensificação das rondas da Guarda Civil Municipal no período noturno no Jardim Planalto.",
    autor: "Leandro Prado",
    data_apresentacao: "11/06/2024",
    thematic_category: "SEGURANCA",
    bairro: "Jardim Planalto",
    enderecos_extraidos: [],
    geo_pins: [],
  },
  {
    // Endereço extraído do texto, mas não geocodificado (sem pin)
    id: 908,
    sapl_id: 9908,
    numero: 8,
    ano: 2024,
    ementa:
      "Solicita operação tapa-buracos na Estrada Municipal ANG-040, próximo ao sítio Boa Esperança.",
    autor: "Rafael Teixeira, Marina Ribeiro, Alex Andrade",
    data_apresentacao: "18/06/2024",
    thematic_category: "INFRAESTRUTURA_VIARIA",
    enderecos_extraidos: [
      {
        id: 9908,
        indicacao_id: 908,
        raw_text: "Estrada Municipal ANG-040, próximo ao sítio Boa Esperança",
        street: "Estrada Municipal ANG-040",
        bairro: null,
        status: "nao_encontrado",
        geo_pin: null,
      },
    ],
    geo_pins: [],
  },
];

MOCK_INDICACOES.splice(4, 0, ...SEM_ENDERECO);
